const twinsBabyData = {
  version: 1,
  lang: "kr",

  datas: [
    {
      week: 0,
      baby: {
        head: {
          title: "두 생명이 동시에 성장 시작!",
          discribed: "",
          size: "0.1~0.2mm",
        },
        body: [
          {
            subTitle: "정자와 난자의 만남, 두배의 기적",
            discribed:
              "임신 1~2주차에는 나팔관 안에서 하나 또는 두 개의 난자가 배란되며, 정자와 만나 수정을 하게 돼요.",
          },
          {
            subTitle: "",
            discribed:
              "이 시기가 바로 두 생명이 시작되는 순간입니다.\n하나의 수정란이 나뉘는 경우는 일란성 쌍둥이, 두 개의 난자가 각기 정자와 만나 수정되는 경우는 이란성 쌍둥이예요.",
          },
          {
            subTitle: "",
            discribed:
              "수정된 후 약 12~15시간이 지나면 세포분열이 시작되고, 그 크기는 지름 0.2mm 정도의 아주 작은 생명체랍니다.\n\n이 시기의 아기들은 아직 태아가 아니라 배아라고 불려요. 배아는 세포분열을 반복하면서, 완전한 개체인 태아가 되기 전까지의 상태예요.\n(참고: 임신 8주까지는 의학적으로 '배아기'로 분류돼요.)",
          },
          {
            subTitle: "자궁으로의 여행",
            discribed:
              "쌍둥이 수정란들은 각각 또는 함께, 나팔관을 따라 자궁으로 이동해요.\n\n이동은 대략 수정 후 5~7일간 이어지며, 그동안 세포는 빠르게 분열하면서 착상을 준비한답니다.",
          },
          {
            subTitle: "쌍태아, 배로 소중한 시작",
            discribed:
              "쌍태아의 경우, 일란성 쌍둥이는 한 수정란이 분열된 후 하나의 자궁 공간에 함께 착상하거나, 태반을 공유할 수 있고, 이란성 쌍둥이는 각각의 수정란이 따로 착상하면서 두 개의 태반과 양막이 만들어지기도 해요.\n\n이 모든 과정은 아직 초음파로 확인되지 않지만, 두 아기의 생명은 이미 자신만의 리듬으로 성장이라는 여정을 시작하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 으슬으슬, 감기가 아니에요!",
          discribed: "호르몬 분비로 몸에 변화가 생기고 있어요!",
        },
        body: [
          {
            subTitle: "배란을 준비해요!",
            discribed:
              "임신 1주 차는 임신이 된 상태가 아닌, 마지막 생리 기간이에요. 하지만 이 시기는 엄마 몸이 착상을 위한 준비를 시작하는 아주 중요한 시간이랍니다.\n\n정자와 난자가 만나 수정이 이루어지는 것은 보통 임신 2주차 후반, 배란일 무렵이에요.\n\n쌍둥이의 경우, 하나의 수정란이 나뉘는 일란성 또는 두 개의 난자가 각각 수정되는 이란성으로 나뉘게 되며, 두 생명이 동시에 성장할 준비를 시작해요.\n\n둘 중 어느 경우든, 엄마의 몸은 단태아 임신보다 더 많은 호르몬과 에너지를 소모하게 됩니다.\n\n수정란은 수정 후 약 12~15시간이 지나면 세포분열을 시작하게 되며, 그 이후 5~6일 동안 자궁으로 이동해 착상을 준비해요.\n\n임신 2주차에는 자궁 내막이 점점 두꺼워지고, 초기의 태아가 착상하기 쉬운 환경을 만들기 위해 황체호르몬(프로게스테론)이 계속 분비돼요.\n\n아직은 눈에 보이지 않지만, 두 생명이 동시에 움직이고 있다는 점에서 쌍태아 임신의 시작은 단태아와는 또 다른 경이로움을 가집니다.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "임신 1~2주차에는 아직 눈에 띄는 증상이 없는 경우가 많아요. 하지만 쌍태아 임신의 경우에는 호르몬 수치가 더 빠르게, 더 많이 증가하면서 예민한 분이라면 미세한 변화를 일찍 느끼기도 합니다.\n\n가장 흔한 초기 증상은 다음과 같아요:\n- 평소보다 더 쉽게 피곤해지고 졸림이 많아져요.\n- 가슴이 팽팽하거나 아프고, 감기처럼 으슬으슬한 오한이 있어요.\n- 체온이 미묘하게 올라가는 경우도 있어요.\n- 생리 예정일을 1주 넘겨도 생리가 없다면, 꼭 임신 테스트를 해보세요.\n- 쌍태아는 조기에 확인할수록 더욱 꼼꼼한 관리가 필요하기 때문에, 몸의 미세한 변화에도 귀를 기울이는 것이 좋아요.",
          },
          {
            subTitle: "예비엄마라면 조심해요!",
            discribed:
              "쌍둥이를 준비 중인 엄마는 단태아보다 더 많은 신체적 에너지와 영양분, 회복력을 요구받게 돼요. 그래서 임신 확정 전이라도 아래의 사항을 꼭 실천해 주세요.\n\n- 흡연과 음주는 무조건 피하기\n- 감기약, 진통제 등 일반 약물 복용 자제하기\n- 카페인 과다 섭취 주의하기\n- 미세먼지, 독한 세제, 염색약 등 유해물질 노출 피하기 충분한 수면과 스트레스 관리로 면역력 유지하기\n-임신을 계획하고 있다면 배란기 이후뿐 아니라 평소에도 몸을 보호하는 생활 습관이 중요해요.\n\n두 생명을 위한 준비는 엄마의 조용한 노력에서 시작됩니다.",
          },
          {
            subTitle: "어떤 영양소가 중요할까요?",
            discribed:
              "- 엽산: \n엽산은 신경관 결손(뇌 또는 척수 기형) 예방에 필수적인 영양소예요.\n\n쌍태아 임신의 경우 엽산 요구량이 더 높기 때문에, 하루 최소 0.6~0.8mg 이상 섭취가 권장됩니다.\n\n식품으로는 브로콜리, 키위, 현미, 오렌지, 달걀노른자 등이 좋고,조리 과정에서 파괴되기 쉬우므로 엽산 보충제 병행이 권장돼요.\n\n- 비타민 D : \n엄마의 면역력과 태아의 뼈 형성에 중요한 영양소예요.\n결핍되면 임신중독증, 임신성 고혈압, 조산 위험이 높아질 수 있어요.\n햇빛 노출 부족이 흔한 요즘은, 연어, 고등어, 달걀노른자, 우유 등으로 보충하거나 영양제를 함께 섭취하는 것이 좋습니다.\n\n- 철분, 오메가-3, 유산균 : \n철분은 혈액량이 더 많아지는 쌍태아 임신에서 필수!\n오메가-3는 태아의 두뇌 발달에 좋아요.\n유산균은 소화와 면역 관리에 도움을 줘요.",
          },
          {
            subTitle: "임신기간은 어떻게 계산할까요?",
            discribed:
              "출산 예정일에 정확히 출산할 확률은 매우 낮지만 출산 예정일을 알면 태아의 건강 상태를 체크하고 계획적인 출산 준비를 하는 데 큰 도움이 되겠죠?\n\n임신 기간을 계산할 때에는 수정일이나 마지막 월경기간을 이용하는데, 정확한 수정일은 파악하기 어렵기 때문에 주로 마지막 월경기간을 사용해요.\n\n그렇기 때문에 임신을 계획중이라면 월경 기간을 꼼꼼히 기록해 두는 것이 좋답니다.\n\n태아가 모체 내에 있는 기간이 항상 일정한 것은 아니지만, 대체로 최초생리일로 부터 280일, 즉 4주간(26일)을 1개월로 본 40주(10개월)를 임신기간으로 봐요.\n그래서 마지막으로 월경을 마친 달수에서 3을 빼거나, 그 달의 숫자가 작아 3을 뺄수 잆을 때에는 9를 더한 것이 아기가 나올 '달' 이에요.\n\n그런 다음 마지막으로 월경의 첫 날에 7일 더한 것이 분만 예정일이 되죠.\n\n예를 들어마지막 생리 시작일이 10월 7일인 경우 10 - 3 = 7, 7 + 7 = 14 그러므로 분만 예정일은 7월 14일이 되는 거예요.\n\n하지만 쌍태아는 조산 가능성이 높기 때문에 출산은 보통 36~37주 전후로 앞당겨지는 경우가 많답니다. 따라서 산부인과 전문의의 정기적인 진료를 받으며 관리해야 해요. ",
          },
        ],
      },
      dad: {
        head: {
          title:
            "쌍둥이를 품은 임신, 두 배의 기쁨만큼, 두 배의 책임도 함께 시작돼요",
          discribed:
            "이제부터 아빠도 함께 준비할 차례예요. 단 한 생명도 소중하지만, 두 생명을 맞이할 준비는 마음과 몸 모두 더욱 깊은 배려와 협력이 필요하답니다.\n40주간의 여정을 함께해봐요!",
        },
        body: [
          {
            subTitle: "건강한 정자를 위한 3개월!",
            discribed:
              "건강한 쌍태아 임신을 위해서는 정자의 건강도 매우 중요해요.\n\n정자가 만들어져 밖으로 나오는 데에는 약 72~90일, 즉 3개월 정도의 시간이 걸리기 때문에, 임신을 계획 중이라면 그보다 더 앞서 준비해야 한답니다.\n\n1. 규칙적인 생활과 충분한 수면\n정자 형성에 중요한 FSH, LH, 테스토스테론은 밤에 감소하고 낮에 증가하는 리듬을 가지기 때문에 밤낮이 바뀐 생활, 수면 부족, 야간 근무 등은 정자의 질에 나쁜 영향을 줘요.\n\n쌍둥이를 준비 중이라면 보다 안정적이고 규칙적인 생활이 필수입니다. 낮에 활동하고 밤에 숙면하는 리듬을 지켜주세요.\n\n2. 정자를 위한 영양소\n아연: 정자의 운동성과 양에 도움 → 굴, 쇠고기, 유제품 등에 풍부해요.\n\n셀레늄: 정자의 구조와 질 향상 → 브라질너트, 달걀, 생선 등에 포함돼요.\n\n비타민C, E, 오메가-3도 산화 스트레스를 줄여 정자의 DNA를 보호해준답니다.\n\n평소 식단이 불균형하거나 식품 섭취가 어려운 경우에는 영양제를 병행하는 것도 좋은 방법이에요.\n\n3. 술·담배는 반드시 NO!\n흡연은 활성산소를 증가시켜 정자의 운동성과 DNA 구조를 손상시켜요.\n\n음주는 정자 수와 정자 질 모두에 악영향을 주며, \n특히 쌍태아 임신은 착상률이나 수정률이 더욱 민감하기 때문에 철저한 금연, 금주가 반드시 필요해요.\n\n4. 고환 온도 낮게 유지하기\n정자는 35도 전후의 약간 낮은 온도에서 잘 생성돼요.\n\n- 사우나, 찜질방, 장시간 반신욕\n- 몸을 조이는 속옷, 스키니진\n- 장시간 앉아 있는 자세, 다리 꼬기\n\n이 모든 것들이 고환의 온도를 올려 정자의 운동성, 수, 형태에 악영향을 줄 수 있어요.\n시원하고 여유로운 착석 자세, 헐렁한 복장이 도움이 된답니다.",
          },
          {
            subTitle:
              "임신은 부부가 함께 달리는 마라톤, 지금부터 같이 준비해요!",
            discribed:
              "쌍태아 임신은 단태아보다 신체적·정서적 부담이 큰 여정이에요. 엄마 혼자서는 버거울 수 있어요. 그래서 아빠의 응원, 관심, 책임감이 두 배로 필요해요.\n\n오늘부터 함께 산책하며 이야기 나눠볼까요?\n태교책을 같이 읽고 대화해보는 건 어때요?\n임신·출산 강의나 콘텐츠를 함께 보는 것도 좋아요.\n두 아이를 위한 40주, 단순한 ‘기다림’이 아니라 함께 만들어가는 시간이에요.\n\n당신은 이제, 한 가족의 든든한 중심이랍니다.",
          },
        ],
      },
    },
    {
      week: 3,
      baby: {
        head: {
          title: "아직은 태아가 아닌 배아!",
          discribed: "",
          size: "각각 약 0.2mm",
        },
        body: [
          {
            subTitle: "착상이 시작되요!",
            discribed:
              "3주차의 쌍둥이 배아는 각각 약 0.2mm 크기, 무게는 1g도 되지 않을 정도로 작지만 지금 이 순간 자궁으로 도달해 착상을 시작하려는 중요한 시기예요.\n\n수정란은 수정 후 약 3~5일 후 자궁에 도달하고, 그 이후 약 7일이 지나면 자궁 내벽에 자리를 잡기 위해 착상 시도를 본격적으로 시작해요.",
          },
          {
            subTitle: "쌍둥이도 각자의 방식으로 착상해요!",
            discribed:
              "이란성 쌍둥이라면 두 개의 배아가 각기 다른 위치에 착상해 각각의 태반을 만들 수 있고, 일란성 쌍둥이라면 하나의 수정란이 나뉘어 같은 공간에 착상하거나 태반을 공유하기도 해요.\n\n착상이 성공적으로 이루어져야만 임신이 '유지 가능한 상태'로 진입했다고 볼 수 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "두 생명이 엄마의 몸에 뿌리내리는 소중한 시기예요. 하지만 아직은 임신을 확인하기 어려워요!",
          discribed: "아직 몸에 큰 변화가 없을수도 있어요.",
        },
        body: [
          {
            subTitle: "아직까지 임신임을 알 수 있는 뚜렷한 자각 증세는 없어요!",
            discribed:
              "자궁 안에서는 두 생명을 품기 위한 환경 조성이 조용히 진행 중이에요. 자궁은 여전히 평소처럼 달걀 정도 크기로 외형상 큰 변화는 없고, 양수도 아주 미세하게 만들어지기 시작하지만 겉으로는 특별한 차이가 느껴지지 않을 수 있어요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "• 기초체온이 미세하게 상승하며 으슬으슬하거나 몸이 나른하게 느껴질 수 있어요.\n• 쌍태아일 경우 호르몬 분비가 더 많아져 피로감과 졸림이 더 심할 수 있어요.\n• 이르게 가벼운 입덧이 시작되거나 후각이 예민해질 수도 있어요.\n• 유방의 통증이나 묵직함, 아랫배가 당기는 느낌도 경험할 수 있답니다.",
          },
          {
            subTitle: "임신 테스트를 해봐요!",
            discribed:
              "쌍태아의 경우에도 착상이 잘 이루어지면 사람융모성생식선 자극 호르몬 (hCG 호르몬) 수치가 상승하면서 임신 테스트기를 통해 임신 여부를 알 수 있게 돼요.\n\n초기에는 조심해야 할 것이 많기 때문에, 임신 사실을 빠르게 확인하면 약 복용이나 음주 등 실수를 줄일 수 있어요.",
          },
          {
            subTitle: "영양 관리도 신경써주세요!",
            discribed:
              "쌍둥이를 임신한 경우, 두 아이가 동시에 성장하기 때문에 엄마의 몸은 더 많은 영양소를 필요로 해요.\n\n**단백질**: 태반과 두 아기의 뇌, 근육 형성에 필수!\n\n**철분**: 임신 후 혈액량이 크게 증가하므로 반드시 보충해야 해요. 철분은 비타민C가 풍부한 과일, 채소와 함께 섭취하면 흡수율이 좋아요.\n\n**지방**: 임신 중 필요한 열량과 수유기 유즙 형성을 위해 필수예요.\n\n**칼슘**: 쌍둥이의 뼈, 심장, 신경, 근육 발달을 위해 더 많이 필요해요. 요거트, 치즈 등에 풍부하며, 비타민D와 함께 섭취하면 흡수가 더 잘 돼요.",
          },
          {
            subTitle: "쌍태아 임신, 더 꼼꼼하게!",
            discribed:
              "쌍태아 임신은 단태아보다 에너지 소모와 영양소 요구량이 높기 때문에, 초기부터 균형 잡힌 식단과 보충제 섭취에 더 신경 써주세요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "엄마의 컨디션 변화, 쌍둥이를 품고 있다면 더 섬세하게 살펴주세요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "호르몬 변화로 엄마의 상태가 크게 달라질 수 있어요!",
            discribed:
              "3주차는 착상이 진행되며 호르몬 수치가 빠르게 올라가는 시기예요. 쌍태아의 경우에는 단태아보다 융모성 생식선 자극 호르몬 (hCG 호르몬) 수치가 더 높게 분비되기 때문에 엄마는 더 피로하고, 더 민감하고, 감정 기복도 커질 수 있어요.\n\n이 시기에는 작은 자극에도 쉽게 예민해지고, 기분이 이유 없이 가라앉거나 불안해질 수도 있답니다.",
          },
          {
            subTitle: "차근차근 준비해요!",
            discribed:
              "아직 임신 사실을 모를 수도 있지만, 평소보다 엄마가 더 피곤해하거나 컨디션 난조를 보인다면 따뜻하게 배려해주세요.\n\n쌍둥이 임신은 처음부터 더 많은 에너지가 필요하기 때문에, 엄마가 충분히 휴식을 취할 수 있도록 도와주시는 것이 중요해요.",
          },
          {
            subTitle: "반드시 금연!",
            discribed:
              "쌍둥이를 임신한 엄마와 아기들은 환경 요인에 더욱 민감할 수 있어요.\n\n담배 연기 속 유해물질은 아기들의 발달을 방해하고, 조산, 저체중아, 호흡기 이상 위험을 높일 수 있어요. 특히 쌍둥이 임신은 조산 가능성이 상대적으로 높기 때문에, 임신 초기부터 엄격한 환경 관리가 필수예요.",
          },
        ],
      },
    },
    {
      week: 4,
      baby: {
        head: {
          title: "아기집이 만들어졌어요!",
          discribed: "",
          size: "각각 1mm 미만",
        },
        body: [
          {
            subTitle: "아직은 태아가 아닌 배아!",
            discribed:
              "임신4주차의 배아는 머리와 몸통이 나뉘고, 세포도 외배엽, 중배엽, 내배엽으로 나뉘어요. 이들은 각각 다른 신체 기관으로 발달하게 된답니다.\n\n가장 위쪽에 있는 외배엽은 피부, 털, 손톱, 발톱, 뇌, 척수, 신경을 만들고, 중간에 있는 중배엽은 근육, 골격, 비뇨생식기, 심장, 혈관과 혈액을 연결하는 다른 기관들을 생성해요.",
          },
          {
            subTitle: "아기는 열심히 성장중!",
            discribed:
              "착상 후 5일 정도가 지난 수정란은 바깥쪽 중심부에 몸의 앞뒤나 좌우를 결정하는 하나의 관이 생기는데, 이것이 바로 신경관이에요.\n\n신경관은 시간이 흐르면서 뇌와 척추로 나누어져 발달하게 되며 나중에는 중추신경의 근원이 돼요. 뿐만아니라 심장을 형성하는 조직도 벌써 서서히 만들어지고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "축하합니다, 두 생명이 함께 찾아왔어요!",
          discribed: "생리를 하지않고 임신 테스트 결과가 양성으로 나와요.",
        },
        body: [
          {
            subTitle: "기관형성기란?",
            discribed:
              "4주차는 수정란들이 자궁벽에 안정적으로 착상을 마치고 본격적인 성장이 시작되는 시기예요. 이 시점부터 아기의 주요 기관이 형성되기 시작하며, 의학적으로 '기관형성기'(4~10주차)에 들어섭니다.\n\n쌍태아는 각각의 배아가 독립적으로 또는 함께 눈, 코, 입, 뇌, 심장, 팔·다리, 내장기관 등을 차례차례 만들어가기 시작해요.\n\n이 시기는 태아 발달에 매우 민감한 시기이기 때문에, 약물 복용, X선 촬영, 유해 환경 노출은 반드시 의사와 상담 후에 진행해 주세요.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "쌍태아 임신의 경우, 호르몬 농도가 더 높아 아래 증상들이 단태아보다 더 빠르거나 강하게 나타날 수 있어요:\n\n• 착상혈 (소량의 갈색 또는 분홍색 혈액)\n• 아랫배 콕콕 찌르는 듯한 통증\n• 잦은 소변 (자궁이 방광을 누르기 시작)\n• 변비나 더부룩함\n• 가벼운 입덧, 메스꺼움, 후각 예민\n\n이러한 증상은 정상적인 호르몬 변화의 일부이니 너무 걱정하지 않으셔도 돼요.",
          },
          {
            subTitle: "병원 선택, 신중하게 해주세요!",
            discribed:
              "임산부와 태아의 건강 상태를 꼼꼼히 체크하고 안전하게 분만할 수 있는 병원을 선택할 때에는 여러 가지 조건을 신중히 고려해야해요.\n\n중간에 병원을 바꾸는 일 없이 임신 초기부터 출산까지 같은 의사에게 꾸준히 진찰을 받기 위해서는 병원들의 장단점을 따져보고 반드시 직접 병원을 방문해 진료를 받아본 후 결정하는 것을 권해드려요.",
          },
          {
            subTitle: "병원 선택 시 고려사항",
            discribed:
              "**집과의 거리**\n임신기간동안에는 매달 정기검진을 받아야 하고, 막달이 가까워지면 1~2주에 한 번씩 병원에 가야 해요. 임신부터 출산 시까지 병원에 가는 횟수는 평균적으로 15회 이상이에요.\n\n무거운 몸을 이끌고 병원에 가는 건 보통일이 아니죠. 집에서 차로 20~30분 이내에 갈 수 있는 거리나 걸어서 갈 수 있는 거리가 부담이 없어요.\n\n**산모의 건강 상태**\n심장 질환이나 고혈압, 당뇨병 등 특정 질환이 있거나 고령임신, 임신중독증, 전치태반 등 고위험 임산부라면 내과나 소아과와 협진이 가능하고 응급 상황 시 수술이 가능한 병원에서 진료를 받아야 해요.\n\n**분만 방법**\n가족 분만, 수중 분만 등 자신이 원하는 분만법이 가능한지 확인해요.\n\n**기타 시설**\n모자동실이나 산후조리, 가족분만실과 같은 병원의 시설이나 비용, 의료진의 전공분야 등을 확인해보세요.",
          },
          {
            subTitle: "국민행복카드를 이용하세요!",
            discribed:
              "정부에서는 임산부에게 건강한 태아의 분만과 산모의 건강관리를 위해 진료비 일부를 국민행복카드를 통해 지원하고 있어요.\n\n임신 1회당 100만원 이용권의 국민행복카드가 지원되며 다태아(쌍둥이 포함) 임산부는 140만원까지 지원되고 분만 취약자의 경우는 20만원이 추가로 지원돼요.\n\n신청방법과 지원자격, 사용 방법에 대한 자세한 내용은 www.voucher.go.kr에서 확인해보세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "본격적인 아빠의 역할이 시작돼요!",
          discribed: "아내와 두 아이를 위해 마음을 단단히 먹으세요.",
        },
        body: [
          {
            subTitle: "첫 초음파, 꼭 함께 가보세요!",
            discribed:
              "4주차는 병원에서 아기집을 확인할 수 있는 시기예요. 쌍태아인 경우, 아기집이 2개 보이는지 확인할 수 있는 중요한 타이밍이기도 해요.\n\n임신테스트기와 혈액검사 이후, 초음파로 직접 '아기가 있어요'라는 말을 듣는 것은 아빠에게도 임신을 실감하게 해주는 소중한 경험이어요.\n\n병원에서 임신확인서를 발급받으면 직장, 건강보험, 복지제도 등 각종 지원을 신청할 수 있어요.",
          },
          {
            subTitle: "소식은 조금만 기다려주세요!",
            discribed:
              "설레는 마음에 주변에 소식을 알리고 싶겠지만, 임신 초기(특히 쌍태아)는 더 조심이 필요한 시기예요.\n\n안정기에 접어든 뒤 가족과 친구들에게 천천히 알리는 걸 추천해요.",
          },
          {
            subTitle: "무슨 일이 있어도 금연은 필수!",
            discribed:
              "아빠의 흡연은 직접 흡연뿐 아니라 간접·3차 흡연을 통해서도 엄마와 아기에게 해를 끼칠 수 있어요.\n\n나가서 피우고 냄새를 빼고 들어와도 괜찮지 않아요. 집안, 옷, 손, 머리카락 등에 남은 담배 성분은 쌍태아에게 조산, 저체중, 호흡기 질환 위험을 높일 수 있어요.\n\n아직까지 흡연을 그만두지 못했다면 이제는 정말 결단을 내려야 할 때! 아기를 생각해서라도 마음을 단단히 먹어주세요!",
          },
          {
            subTitle: "두 아기에게 태명을 지어주세요!",
            discribed:
              "초음파로 아기집을 확인하고 나면 정말로 아기들이 찾아왔다는 사실이 실감 나기 시작하죠.\n\n이때 아내와 함께 태명을 정해보는 것은 임신을 실감하고 정서적 유대감을 높이는 데 큰 도움이 돼요. 청각은 태아가 가장 먼저 발달시키는 감각 중 하나예요.\n\n따뜻한 마음을 담아 두 아기에게 자주 태명을 불러주세요. 감정 안정과 뇌 발달에도 긍정적인 영향을 줄 수 있어요.",
          },
        ],
      },
    },
    {
      week: 5,
      baby: {
        head: {
          title: "저희를 병원에서 확인할 수 있어요!",
          discribed: "깨알만 한 크기에요!",
          size: "각각 약 1mm",
        },
        body: [
          {
            subTitle: "아기집이 보여요!",
            discribed:
              "5주차 초음파 검사에서는 아기집이 2개 보일 수 있어요. 이는 쌍둥이 임신이 확인되는 첫 단서이자, 두 생명이 뱃속에 함께 있다는 가장 감동적인 순간 중 하나랍니다.\n\n이 시기의 아기들은 올챙이처럼 조그마한 모습이에요. 작은 꼬리 모양의 부분은 곧 몸통이 되고, 튀어나온 한쪽은 머리로 자라게 될 부분이에요.\n\n아직은 사람의 형태와는 거리가 있지만, 작고 소중한 생명이 스스로를 만들어가고 있어요.",
          },
          {
            subTitle: "두 아기의 심장도 자라기 시작해요!",
            discribed:
              "신체기관 중 가장 먼저 형성되는 장기는 바로 심장이에요. 혈액 순환이 태아의 성장에 가장 필수적이기 때문이에요.\n\n지금 이 시점에 두 아기 모두의 심장은 세포 단계에서 박동의 준비를 시작하고 있으며, 곧 초음파로도 두 생명의 심장 소리를 들을 수 있게 될 거예요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 극초기, 두 생명을 위해 무엇이든 조심조심!",
          discribed: "임신 초기 증상들이 나타나기 시작해요.",
        },
        body: [
          {
            subTitle: "신체적 변화가 더 강하게 나타나요!",
            discribed:
              "병원에서 두 개의 아기집이 확인되었나요? 쌍둥이를 품은 예비 엄마가 되신 걸 진심으로 축하드려요!\n\n5주차부터는 단태아보다 더 빠르게, 그리고 더 강하게 임신 실감 증상이 나타날 수 있어요. 몸도, 마음도 이전과 다르게 느껴질 수 있고, 하루하루가 조심스럽고 낯설게 느껴질 수도 있어요.\n\n하지만 이는 두 생명을 품은 엄마의 몸이 정상적으로 적응해가는 과정이랍니다.",
          },
          {
            subTitle: "이런 증상들이 나타날 수 있어요!",
            discribed:
              "쌍태아의 경우 융모성 생식선 자극 호르몬 (hCG 호르몬)과 프로게스테론 수치가 더 높아 다음과 같은 증상이 단태아보다 더 두드러지게 나타날 수 있어요:\n\n• 입덧이 시작되고 냄새에 더 민감해져요\n• 감정 기복이 심해지고 갑자기 울컥하거나 우울감을 느낄 수 있어요\n• 기초체온이 높아지면서 몸살감기처럼 으슬으슬한 느낌이 들어요\n• 소화 기능 저하로 인한 변비, 더부룩함, 가끔 설사\n• 하루 종일 피곤하고 졸음이 쏟아져요\n\n이러한 증상은 엄마의 몸이 아기들을 보호하고 유지하기 위한 정상적인 변화이니 걱정하지 않아도 돼요.",
          },
          {
            subTitle: "만약 임신사실을 모르고 약을 먹었다면?",
            discribed:
              "임신 5주차는 임신을 모른 채 약을 복용하는 경우가 종종 있어요. 특히 몸살 증상이나 미열, 소화불량 등을 감기나 스트레스로 오해하고 진통제나 감기약을 복용하는 경우가 많지요.\n\n하지만 다행히도 대부분의 약물은 배아에 큰 영향을 미치지 않으며, 특정 약물로 인한 기형 발생률은 전체 기형 중 1% 미만으로 매우 낮아요.\n\n그래도 마음이 불안하다면 산부인과 전문의 상담을 통해 정확하게 확인하고 안심하는 것이 가장 좋아요.",
          },
          {
            subTitle: "조심, 또 조심! 지금은 정말 중요한 시기예요",
            discribed:
              "5~8주차는 태아의 주요 장기 형성과 조직 분화가 활발하게 이루어지는 시기예요. 쌍둥이의 경우 태반과 양막이 각각 또는 함께 형성되면서 엄마 몸의 에너지 소모와 호르몬 변화도 더 커지기 때문에 스트레스나 무리한 활동이 더 민감하게 영향을 미칠 수 있어요.\n\n**주의사항**\n• 장시간 서 있거나 무리한 집안일은 피하기\n• 무거운 짐 들지 않기, 계단 조심\n• 장거리 여행 또는 장시간 운전은 되도록 삼가기\n• 반려동물이 있다면 화장실 청소는 아빠에게 맡기기! (톡소플라즈마증 감염 예방)",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "두 생명을 품은 엄마의 몸은 지금 하루하루가 변화의 연속이에요. 무리하지 말고, 스스로에게 다정한 한 주를 선물해주세요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "임신 극초기, 쌍둥이 엄마는\n두 배로 예민할 수 있어요.\n아빠도 조심, 또 조심!",
          discribed: "",
        },
        body: [
          {
            subTitle: "두 생명을 위한 시작, 아빠의 준비도 지금부터예요",
            discribed:
              "임신 사실을 알게 된 엄마는 기쁨과 동시에 걱정, 두려움, 책임감 등 복잡한 감정의 파도를 느끼기 시작해요. 특히 쌍둥이를 품게 되면 몸의 변화도, 부담감도 두 배 이상이 될 수 있어요.",
          },
          {
            subTitle: "엄마의 안정과 정서적 지지가 가장 중요해요!",
            discribed:
              '하루에도 몇 번씩 바뀌는 감정 기복, 입덧, 냄새에 대한 민감함, 피로감, 무기력감, 그리고 갑작스러운 눈물…\n\n이럴 때 가장 중요한 건 아빠의 따뜻한 말 한마디, 다정한 손길, 조용한 배려예요.\n\n"괜찮아", "내가 도와줄게", "쉬고 있어" - 이런 짧은 말이 엄마에게는 "당신은 혼자가 아니에요"라는 큰 위안이 된답니다.',
          },
          {
            subTitle: "아빠도 공부해요!",
            discribed:
              "좋은 아빠가 되기 위한 준비는 아기가 태어난 후에 시작하면 너무 늦어요.\n\n**함께 준비하기**\n• 임신, 출산, 양육에 관한 책 함께 읽기\n• 부모 역할을 다룬 강의나 클래스 참여해보기\n• 태교 콘텐츠를 함께 보고 이야기 나누기\n• 두 아기를 위해 어떤 환경을 만들 수 있을지 차근차근 생각해보기\n\n쌍둥이를 맞이할 준비는 두 배의 배려와 이해, 그리고 실천이 필요하답니다.",
          },
          {
            subTitle: "예비 부모님께 드리는 응원의 메시지",
            discribed:
              "이제 40주의 여정이 시작됐어요. 두 아기와 엄마의 길에 가장 든든한 동행자가 되어주세요.\n\n예비 아빠, 그리고 예비 엄마, 화이팅!",
          },
        ],
      },
    },
    {
      week: 6,
      baby: {
        head: {
          title: "콩콩, 두 개의 심장이 같은 시간에, 따로 또 같이 뛰고 있어요!",
          discribed: "각각 콩알만 한 크기에요!",
          size: "약 3~9mm",
        },
        body: [
          {
            subTitle: "심장이 뛰어요!",
            discribed:
              "이제 두 아기의 심장이 정식으로 박동을 시작하는 시기예요. 질 초음파 검사를 통해 두 개의 아기집과 심장 박동을 확인할 수 있어요.\n\n이 순간은 쌍태아 임신에서 가장 감동적인 시기 중 하나랍니다.",
          },
          {
            subTitle: "뇌와 신경계도 빠르게 발달 중이에요!",
            discribed:
              "6주차의 배아들은 뇌와 척수의 신경세포의 약 80% 이상이 만들어지고, 머리의 크기가 점점 커지며 뇌의 기초 구조가 형성돼요.\n\n또한 이 시기부터는 간이 혈구(적혈구)를 만들기 시작하고 뇌는 근육과 장기의 운동 조절 기능을 서서히 갖추기 시작해요. 뼈대의 중심축이 형성되며, 점차 사람의 형상에 가까워지는 과정에 들어서요.",
          },
          {
            subTitle: "두 아이는 각자의 속도로 성장해요!",
            discribed:
              "쌍태아라 하더라도 성장 속도는 아기마다 약간씩 다를 수 있어요. 어느 한 아기의 크기가 작다고 해서 무조건 걱정할 필요는 없어요.\n\n이 시기에는 초음파상 측정 오차도 존재하고, 개개인의 발달 속도가 다르기 때문이죠.",
          },
          {
            subTitle: "두 개의 작은 생명",
            discribed:
              "엄마의 심장이 뛰는 것처럼, 지금은 두 개의 작은 심장이 세상을 향해 콩콩콩 울리기 시작했어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "제가 대체 왜이럴까요?\n정답은 호르몬 때문에!",
          discribed: "호르몬의 영향이 점점 심해져요.",
        },
        body: [
          {
            subTitle: "배는 아직 눈에 띄지 않지만…",
            discribed:
              "쌍둥이를 품고 있어도 아직은 겉으로 큰 변화는 느껴지지 않을 수 있어요. 자궁은 임신 전보다 점점 커지고 있으며 지금은 달걀 크기에서 레몬 정도 크기까지 커졌지만, 복부 팽창은 아직 눈에 띄지 않아요.\n\n하지만 속에서는 두 아기의 공간을 만들기 위한 변화가 활발히 일어나는 중이에요.",
          },
          {
            subTitle: "입덧이 시작될 수 있어요!",
            discribed:
              "입덧은 보통 임신 4-5주부터 시작해 12-14주 이후 점차 사라지는 경향이 있어요. 특히 쌍태아의 경우, 호르몬 수치가 더 높게 분비되기 때문에 입덧이 더 빨리, 더 심하게 나타날 수 있어요.\n\n약간 메슥거리는 정도부터 음식 냄새나 물만 마셔도 구토하는 경우, 아예 음식을 거부하거나 반대로 '먹덧'이 나타나는 경우까지 다양해요.",
          },
          {
            subTitle: "입덧 관리 팁",
            discribed:
              "• 아침이나 공복 상태에서 입덧이 심할 수 있어요\n• 한 번에 많이 먹기보다 조금씩 자주 섭취하는 습관을 들여보세요\n• 너무 심할 경우 병원에 꼭 문의하세요!",
          },
          {
            subTitle: "화장실을 자주가요!",
            discribed:
              "쌍태아 임신에서는 사람 융모성 생식선 자극 호르몬의 수치가 더 높아져 골반 부위 혈류량이 급증하고 신장은 더 많은 노폐물을 걸러내게 돼요.\n\n또한 커진 자궁이 방광을 눌러 빈뇨 증상이 더 자주, 더 강하게 나타날 수 있어요.\n\n하지만 화장실을 줄이기 위해 물을 아예 안 마시는 건 금물! 지금은 체내 혈액량도 늘어나고 있기 때문에 충분한 수분 섭취가 꼭 필요해요.",
          },
          {
            subTitle: "감정은 롤러코스터처럼 오르락내리락…",
            discribed:
              "호르몬 변화로 인한 감정기복은 쌍태아 임신에서 더 민감하게 나타날 수 있어요. 사소한 일에도 눈물이 나고 갑자기 불안하거나 우울해지기도 하고 짜증이 평소보다 많아질 수도 있어요.\n\n이 모든 감정은 정상적인 임신 호르몬 반응이에요. 너무 당황하지 말고, 스스로를 다독여주세요. 필요하면 가까운 사람에게 지금 내 감정을 솔직히 말해보는 것도 좋아요.",
          },
          {
            subTitle: "미리미리 준비해요!",
            discribed:
              "**보건소 혜택 확인하기**\n주민등록 주소지 기준 보건소에서 임산부 등록, 엽산·철분 지원, 건강 상담 등의 서비스를 받을 수 있어요.\n\n**태아 보험, 미루지 마세요!**\n쌍태아는 검사나 관리 횟수가 더 많기 때문에 조기에 보험을 준비하는 것이 좋아요. 검진 과정에서 이상이 발견되면 가입이 어려워질 수 있으니 여러 상품을 비교해보고, 빠르게 가입해 두는 것이 안전합니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "두 아기를 위한 준비는 조금 더 빨리, 조금 더 꼼꼼히 시작하는 것이 좋아요. 내 몸의 신호에 귀 기울이면서 오늘도 천천히, 부드럽게 하루를 보내보세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠의 역할이 중요해요!",
          discribed:
            "갑작스러운 변화들로 힘들어하는 아내를\n두 배로 따뜻하게 도와주세요.",
        },
        body: [
          {
            subTitle: "감동의 순간들을 기록으로 남겨보세요!",
            discribed:
              "혹시 두 아이의 심장 소리를 들으셨나요? 작고 미세한 '콩콩콩' 소리가 세상의 첫 인사처럼 들리죠.\n\n그 경이로운 순간을 사진이나 짧은 글, 목소리 녹음 등으로 기록해보세요. 태교일기를 따로 쓰지 않아도 괜찮아요. 짧은 메모 한 줄, 병원 앞 셀카 한 장, 초음파 사진 하나도 충분해요.\n\n이런 기록은 아내에게 정서적 안정감을 주고, 미래의 두 아이에게는 무조건적인 사랑의 증거로 남을 거예요.",
          },
          {
            subTitle: "아빠가 할 수 있는 일, 지금 바로 시작해요!",
            discribed:
              "쌍태아 임신은 단태아보다 더 세심한 관심과 철저한 준비가 필요해요. 아내는 두 아기를 위해 몸과 마음 모두를 온전히 내어주는 중이에요.",
          },
          {
            subTitle: "지금 아빠가 할 수 있는 구체적인 일들",
            discribed:
              '**같이 걱정하고, 같이 준비하기**\n"걱정하지 마" 대신 "같이 생각해보자"가 더 큰 힘이 돼요.\n\n**병원 일정 관리하기**\n아내의 병원 일정을 미리 체크하고 리마인드 해주기. "다음 진료는 언제더라?"를 아빠가 먼저 물어보면 정말 든든해요.\n\n**진료 동행은 선택이 아닌 기본!**\n같이 손을 잡고 진료실 앞에 앉아 있는 것만으로도 아내는 큰 안심을 느낄 수 있어요.\n\n처음부터 능숙하지 않아도 괜찮아요. 중요한 건 노력! 실수해도 진심으로 다가가면 엄마는 다 느껴요.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 사람이 함께 만드는 임신여정, 당신의 작은 시도가 아내에게는 큰 사랑으로 느껴져요. 지금 이 시간부터, 함께 해요.",
          },
        ],
      },
    },
    {
      week: 7,
      baby: {
        head: {
          title: "이제는 제법 사람의 모습이에요!",
          discribed: "각각 크랜베리 한 알만 한 크기에요!",
          size: "약 1.0~1.5cm",
        },
        body: [
          {
            subTitle: "이제 제법 머리와 몸통이 구별돼요!",
            discribed:
              "7주차에 들어선 쌍둥이들은 형태만 있었던 얼굴이 점차 사람의 얼굴을 닮아가기 시작해요. 이마는 약간 불룩하고, 코는 아직 납작하지만 눈, 콧구멍, 입 등이 작게 자리 잡고 있어요.\n\n눈에는 수정체가 생기며, 빛을 느낄 준비를 시작하고 머리와 뇌도 빠르게 커지면서 머리가 척추 위에 곧게 올라오고 있어요. 아기 시절 특징이던 '꼬리'는 점점 사라지고 있답니다.",
          },
          {
            subTitle: "팔다리가 자라기 시작해요!",
            discribed:
              "쌍둥이들은 서로 다른 속도로 팔다리가 자라기 시작해요. 이 시기 초음파에서는 팔과 다리, 손, 어깨 부분이 작은 혹처럼 볼록하게 튀어나와 있는 모습이 보일 수 있어요.\n\n하지만 한 달쯤 지나면, 이 작은 팔다리로 자유롭게 움직이며 자궁 속을 탐험하게 될 거예요.",
          },
          {
            subTitle: "내부 기관도 빠르게 형성되고 있어요!",
            discribed:
              "두 아기의 심장은 이미 완전히 형성되어 꾸준히 박동 중이에요. 간 돌기가 나타나 간 기능의 기초가 만들어지고 폐에서는 기관지가 생기며 호흡을 위한 준비를 해요.\n\n위, 창자, 췌장, 맹장도 하나둘 자리 잡고 있어요. 아기들은 아직 작고 여리지만 각자의 방식으로 아주 치열하게 생명으로 완성되어 가는 중이랍니다.",
          },
          {
            subTitle: "두 개의 작은 생명체",
            discribed:
              "두 개의 작은 몸 안에서 심장은 뛰고, 뇌는 성장하며, 작지만 완전한 생명의 형체가 만들어지고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "기분도 몸 상태도 오락가락!",
          discribed:
            "호르몬의 영향으로 찾아오는 다양한 변화들, 지금은 무리하지 말고 조심조심!",
        },
        body: [
          {
            subTitle: "조금씩 증상들이 더 분명해져요!",
            discribed:
              "아직 겉보기엔 배가 많이 나오지 않아 주변에서 임신 사실을 알아채기 어렵지만, 엄마의 몸속에서는 두 아기를 위한 변화가 눈에 띄게 가속화되고 있어요.\n\n지금까지 느껴졌던 증상들이 더 강해지거나 지속되고 체중이 서서히 증가하며 불편함도 눈에 띄게 느껴지기 시작해요. 쌍태아를 품은 몸은 단태아보다 더 많은 에너지와 호르몬 반응을 동반하기 때문에 그만큼 증상도 더 뚜렷하게 나타날 수 있어요.",
          },
          {
            subTitle: "입덧이 심해지고 있어요!",
            discribed:
              "7주차는 입덧이 가장 심해지는 시기로, 냄새만 맡아도 구역질이 나거나, 음식을 잘 먹지 못하는 경우가 많아요.\n\n특히 쌍태아의 경우, 융모성 생식선 자극 호르몬 (hCG) 수치가 더 높아 입덧이 더 빠르고 더 심하게 나타나는 경향이 있어요. 아예 음식 냄새조차 싫거나 반대로 특정 음식만 먹고 싶은 '먹덧'이 나타나기도 해요.\n\n입덧이 심할수록 탈수 예방과 최소한의 영양 섭취는 꼭 신경 써야 해요! 자신에게 맞는 음식, 냄새, 시간대를 찾아 조금씩 자주 먹는 습관을 유지해보세요.",
          },
          {
            subTitle: "배변활동에 변화가 생겨요!",
            discribed:
              "호르몬 변화로 인해 장운동이 느려지고, 입덧으로 식사량이 줄면서 변비나 소화 불량이 생기기 쉬워요.\n\n**완화를 위한 식이 요령**\n• 식이섬유가 풍부한 곡물, 해조류, 뿌리채소, 과일 섭취\n• 충분한 수분 섭취\n• 규칙적인 가벼운 걷기 운동\n\n변비약은 꼭 담당 의사와 상담 후에 복용하세요.",
          },
          {
            subTitle: "피부 트러블도 나타날 수 있어요!",
            discribed:
              "호르몬 변화는 피부 유분 증가나 여드름, 붉은기 등을 유발할 수 있어요. 이런 변화는 자연스러운 임신 반응이니 너무 스트레스 받지 않아도 괜찮아요.\n\n자극이 적은 보습 위주의 스킨케어로 진정에 집중해 주세요.",
          },
          {
            subTitle: "가슴의 변화도 더 뚜렷해져요!",
            discribed:
              "유선 발달과 혈류 증가로 가슴이 커지고 묵직한 느낌이 들어요. 유두가 예민해지고 색이 진해질 수 있어요.\n\n살짝 스치기만 해도 통증을 느낄 수 있지만, 이는 모유 수유를 위한 자연스러운 준비 과정이에요. 마사지나 미온찜질로 불편함을 완화해보세요.",
          },
          {
            subTitle: "체중 변화, 어떻게 관리할까요?",
            discribed:
              '쌍태아 임신은 단태아보다 총 체중 증가 권장량이 더 큽니다. 하지만 임신 초기(12주까지)는 전체 체중 증가량 중 일부만 증가해야 해요.\n\n**임신 초기 권장 체중 증가**: 약 0.5~2kg\n\n쌍태아라도 초기 과도한 체중 증가는 고혈압·당뇨 등 합병증 위험을 높일 수 있어요. 특히 체질량지수가 높은 경우, 체중 관리에 더 적극적인 주의가 필요해요.\n\n지금은 "먹어야 하니까 먹는다"보다 "나와 아기를 위해 좋은 걸 조금씩 먹는다"는 마음으로 천천히 접근해보세요.',
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "당신의 몸이, 당신의 하루가 조금씩 바뀌고 있어요. 그 변화는 두 생명을 지키고 있다는 가장 확실한 증거랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧이 심한 아내를 위해!",
          discribed: "이 시기에는 아빠의 도움이 절실해요.",
        },
        body: [
          {
            subTitle: "집안일, 지금은 아빠의 역할이에요!",
            discribed:
              "쌍둥이를 임신한 아내는 몸의 변화가 단태아보다 더 빠르고 강하게 나타나요. 특히 입덧이 심하거나 기운이 빠져서 간단한 집안일조차 큰 부담이 될 수 있어요.\n\n임신 초기(특히 5~8주)는 유산 가능성이 상대적으로 높은 시기이기 때문에 무리한 움직임, 스트레스, 과로를 피하는 게 가장 중요해요.\n\n이럴 때 아빠가 할 수 있는 가장 확실한 역할은 '집안 실천'입니다.",
          },
          {
            subTitle: "아빠가 맡아야 할 집안일들",
            discribed:
              "**아내의 입덧을 위해 꼭 해주세요**\n• 음식물 쓰레기 버리기 (입덧 유발 원인 1위!)\n• 냉장고 정리 및 청소\n• 욕실 환기, 강한 냄새 나는 제품 사용 피하기\n• 간단한 식사 준비\n\n특히 후각이 민감해진 아내를 위해 향이 강하거나 느끼한 음식은 피하고, 상쾌하고 담백한 재료 위주로 다양한 요리를 시도해보세요.",
          },
          {
            subTitle: "소통이 중요해요!",
            discribed:
              '식사를 준비하며 "이건 어때?", "혹시 이건 먹기 괜찮아?" 이런 소통이 아내에게는 정서적 지지와 실질적 도움이 동시에 되는 순간이랍니다.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "아내가 입덧으로 힘들어할 때, 말없이 손을 내밀어 함께해주는 그 마음이 이미 훌륭한 아빠의 출발이에요.",
          },
        ],
      },
    },
    {
      week: 8,
      baby: {
        head: {
          title: "지난 일주일 사이, 두 아기 모두 두 배 이상 쑥쑥 자랐어요!",
          discribed: "각각 곰젤리만 한 크기",
          size: "약 1.6~2.2cm",
        },
        body: [
          {
            subTitle: "이제 점점 사람의 형태가 되어가요!",
            discribed:
              "8주차부터는 배아가 아닌 '태아'로 불릴 수 있어요. 쌍둥이 모두가 각자의 속도와 개성으로 점점 사람의 형태에 가까운 모습을 갖춰가고 있답니다.\n\n태아의 몸이 길어지고, 척추가 곧아지며 머리를 들고 몸을 세우는 자세가 가능해져요. 팔다리가 뚜렷하게 구분되고, 아직은 물갈퀴 같은 형태지만 손가락과 발가락이 하나씩 나뉘는 중이에요.",
          },
          {
            subTitle: "초음파에서 움직임이 보이기 시작해요!",
            discribed:
              "이제 초음파에서 보면 두 아기의 작은 움직임과 형태 변화가 조금씩 더 실감 나게 보이기 시작해요.",
          },
          {
            subTitle: "피부는 아직 반투명하지만, 생명의 흐름이 선명해요",
            discribed:
              "피부는 아직 얇고 투명해서 혈관이 그대로 비치고, 목 주변에서는 귓바퀴의 외형이 형성되고 있어요. 얼굴도 점점 뚜렷해져 눈꺼풀, 코, 윗입술 등이 자리 잡고 있어요.",
          },
          {
            subTitle: "태반과 탯줄도 점점 강력해져요",
            discribed:
              "두 아기 각각이 자신만의 태반과 탯줄을 가지거나, 공유하는 구조를 갖고 있을 수도 있어요. 이제부터는 태반을 통해 엄마로부터 영양소와 산소, 면역물질이 전달되며 아기들의 생명 유지 시스템이 자립적인 구조로 바뀌는 중요한 시기예요.\n\n또, 아기 시절 잠깐 있었던 '꼬리'는 거의 사라지고 자연스럽게 엉덩이 형태로 정리돼요.",
          },
          {
            subTitle: "두 생명의 놀라운 발달",
            discribed:
              "쌍둥이의 발달은 놀라울 만큼 섬세하고, 서로 다른 두 생명이 각자의 리듬으로 생명을 완성해가고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "아기가 쑥쑥 자라면서 자궁의 크기도 빠르게 커지고 있어요!\n겉으론 큰 변화가 없어 보여도, 엄마 몸속에서는 지금도 쉼 없이 변화가 진행 중이에요.",
          discribed: "자궁이 자몽만큼 커져서 골반 밖으로 나와요.",
        },
        body: [
          {
            subTitle: "자궁이 커지고 몸무게도 서서히 늘어나요",
            discribed:
              "임신 전 달걀 크기였던 자궁은 이제 주먹 크기 이상으로 커졌어요. 쌍둥이를 품고 있는 경우에는 자궁이 단태아보다 더 빠른 속도로 확장되기 때문에 허리선이 빨리 사라지고, 기존 옷이 갑자기 답답하고 조이는 느낌이 들 수 있어요.\n\n겉으론 아직 티가 나지 않을 수 있지만:\n• 배가 단단하고 약간 불러온 느낌\n• 가슴의 팽창감과 묵직한 통증\n\n이 모든 건 정상적인 변화의 과정이랍니다.",
          },
          {
            subTitle: "계속되는 입덧… 정점에 가까워지고 있어요",
            discribed:
              "이 시기에는 입덧이 가장 심해질 수 있어요. 쌍태아의 경우에는 호르몬 수치가 더 높기 때문에 아침에 특히 심하게 울렁거리고 냄새에 민감하게 반응하며 먹고 나서 바로 토해버리는 일도 흔해요.",
          },
          {
            subTitle: "입덧 관리 방법",
            discribed:
              "**이럴 땐 이렇게!**\n• 하루 종일 공복을 피하고, 조금씩 자주 먹기\n• 냄새 강한 음식 피하기\n• 입덧 심한 시간대 파악 후, 먹는 시간 조절\n\n너무 힘들 땐 병원 진료와 약 처방을 망설이지 마세요. 입덧이 심해져 수분과 영양을 섭취하지 못할 정도라면 아기에게도 영향을 줄 수 있으니 꼭 진료가 필요해요.",
          },
          {
            subTitle: "외음부와 질 분비물 변화",
            discribed:
              "임신하면 질과 외음부로 가는 혈류량이 급격히 늘어나 색이 짙어지고, 점액성 분비물도 늘어나요. 이 분비물은 감염을 막아주는 방어막 역할을 하며 정상적인 변화예요.\n\n**다음과 같은 경우에는 질염일 수 있으니 반드시 병원을 방문하세요:**\n• 분비물의 색이 회색, 초록빛으로 변함\n• 악취가 나거나 심한 가려움이 동반됨\n• 따가움, 배뇨통 등의 이상 증상이 있음",
          },
          {
            subTitle: "위생 관리 꿀팁",
            discribed:
              "• 속옷은 땀 흡수가 잘되는 면 소재로 자주 갈아입기\n• 샤워는 외음부까지만, 질 내부 세정은 삼가야 해요!\n• 자극적인 세정제 사용은 피하고, 미지근한 물로 부드럽게 씻어요",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "지금 당신의 몸은 두 생명을 위한 집을 더 넓고 안전하게 만들고 있어요. 겉으론 작아 보일 수 있어도, 안에서는 세상이 만들어지고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "아빠의 노력은 아내에게 큰 힘이 돼요.\n이제는 두 사람이 함께 노력해야 할 때예요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "이제 우리는 임신가정!",
            discribed:
              "이제 우리는 단순한 부부를 넘어서 '쌍둥이를 품은 임신가정'이라는 새로운 팀이 되었어요. 그동안 각자의 역할을 잘 해왔던 아내와 나는 지금부터는 이전과 다른 방식으로 함께 움직여야 해요.\n\n아내는 더 이상 모든 일을 이전처럼 해낼 수 없어요. 두 생명을 품고 있는 몸은 조금만 움직여도 피곤하고, 감정의 변화도 더 빠르게 찾아올 수 있어요.",
          },
          {
            subTitle: "아빠가 나누어 맡아야 할 일들",
            discribed:
              "그렇기 때문에 이제는 아내가 도맡아왔던 일들 중 일부는 자연스럽게 남편인 내가 익히고 나누어야 할 시점이에요.\n\n**아빠의 새로운 영역**\n• 설거지, 청소, 빨래 같은 집안일\n• 병원 일정 체크, 식사 챙기기, 감정 변화 살피기\n• 태아 보험, 보건소 서비스 등 정보 찾아보기\n\n이 모든 것이 이제는 아빠의 영역이기도 합니다.",
          },
          {
            subTitle: "처음부터 완벽할 필요는 없어요",
            discribed:
              '익숙하지 않고 어색할 수도 있어요. 하지만 중요한 건 시작하려는 마음, 그리고 지속적인 실천이에요.\n\n작은 행동 하나가 아내에게는 큰 위로가 되고, "같이 하고 있어"라는 감각은 두 사람 모두에게 더 단단한 가족의 느낌을 선물해줘요.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 사람이 함께 만드는 임신가정, 당신의 작은 시도가 아내에게는 큰 사랑으로 느껴져요. 지금 이 시간부터, 함께 해요.",
          },
        ],
      },
    },
    {
      week: 9,
      baby: {
        head: {
          title: "이제는 배아가 아닌 태아!",
          discribed: "각각 올리브 한 알만 한 크기",
          size: "약 2.3~3.0cm",
        },
        body: [
          {
            subTitle: "팔다리가 길어지고, 손가락 발가락도 생겨요!",
            discribed:
              "9주차부터는 두 아기 모두 꼬리가 사라지고, 등이 곧게 펴지며 사람다운 형태를 갖추기 시작해요.\n\n팔은 점점 길어지고, 팔꿈치를 구부릴 수 있게 돼요. 손가락 사이의 막이 사라지며 지문도 만들어지고 있어요. 다리는 허벅지, 종아리, 발로 구분되고, 발가락도 뚜렷해져요.",
          },
          {
            subTitle: "초음파에서 움직임을 볼 수 있어요!",
            discribed:
              "이 시기 초음파에서는 두 아기의 작고 미세한 움직임도 관찰할 수 있어요!",
          },
          {
            subTitle: "얼굴과 생식기도 발달 중이에요",
            discribed:
              "얼굴에는 안면 뼈 구조가 잡히고, 표정을 위한 근육도 생겨요. 생식기가 형성되며 여아는 난소, 남아는 정소가 서서히 자라기 시작해요.\n\n아직 성별은 초음파로 확인하긴 이르지만, 두 생명이 각자의 길로 분화되는 신비로운 과정이 지금도 진행 중이랍니다.",
          },
          {
            subTitle: "두 개의 작은 존재",
            discribed:
              "초음파 화면 속, 두 개의 작은 존재가 각자의 리듬으로 팔다리를 움직이며 '나'를 만들어가고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "쉽게 짜증이나고 피로해져요!",
          discribed: "지금 엄마의 몸속에서 아기가 쑥쑥 자라고 있어요.",
        },
        body: [
          {
            subTitle: "감정기복이 심해져요",
            discribed:
              "쌍둥이를 임신하면 호르몬 변화가 더 커지기 때문에 감정기복도 심해지고 작은 일에도 눈물이 날 수 있어요. 여기에 입덧까지 심해지면 몸과 마음이 더 힘들게 느껴지죠.\n\n불안하고 울적한 감정이 드는 건 자연스러운 현상이에요. 그럴 땐 혼자 참지 말고 남편이나 가족, 믿을 수 있는 사람에게 속마음을 털어놓아 보세요.",
          },
          {
            subTitle: "가슴에 변화가 생겨요!",
            discribed:
              "가슴이 점점 단단해지고 유두와 유륜 색이 짙어져요. 스치기만 해도 아프고, 유두를 누르면 기름 같은 분비물이 나올 수 있어요.\n\n이 모든 건 모유 수유를 위한 자연스러운 준비 과정이에요.",
          },
          {
            subTitle: "피로가 늘었어요!",
            discribed:
              "쌍태아 임신은 에너지 소모가 더 많아 하루 종일 피곤하고 졸음이 쏟아질 수 있어요. 지금은 몸이 두 아기를 위한 태반을 만들기 위해 열심히 일하는 중이에요.\n\n혼자 무리하지 말고, 필요한 건 주변의 도움을 받는 것도 용기랍니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "당신의 몸과 마음이 조금씩 흔들리는 건, 지금 두 아이를 품고 있기 때문이에요. 조심스럽고 천천히, 오늘 하루도 잘 해내고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "취미생활은 잠시 안녕, 지금은 아내가 가장 먼저예요.\n쌍둥이를 품은 아내에게는 더 세심한 관심과 배려가 필요해요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "아내를 이해하고, 다독여주세요!",
            discribed:
              "쌍태아 임신은 단태아보다 신체 변화도 크고 감정기복도 더 격해질 수 있어요. 오늘은 웃다가도 내일은 눈물을 흘리고 말 한마디에도 예민하게 반응할 수 있어요.\n\n이건 호르몬 변화 때문이지, 아내의 잘못이 절대 아니에요. 지금 아내는 몸도 마음도 낯설고 복잡한 시기를 지나고 있답니다.",
          },
          {
            subTitle: "아빠가 할 수 있는 것들",
            discribed:
              '**아빠가 할 수 있는 건?**\n• 아내의 말에 귀 기울이기\n• 아내의 표정과 행동을 눈여겨보기\n• "왜 그래?"보다는 "괜찮아?"라는 말로 다가가기\n\n이 시기를 함께 잘 지나면 두 사람의 유대감은 훨씬 깊어지고, 아내는 "혼자가 아니구나"라는 안도감을 느끼게 될 거예요.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "쌍둥이를 기다리는 시간은 부부가 서로를 더 잘 알아가는 기회이기도 해요. 당신의 배려는 아내에게 큰 힘이 돼요.",
          },
        ],
      },
    },
    {
      week: 10,
      baby: {
        head: {
          title: "손가락 발가락이 또렷하게 보여요!",
          discribed: "각각 엄지손가락만 한 크기",
          size: "약 3.1~4.0cm",
        },
        body: [
          {
            subTitle: "본격적인 태아기에 접어들었어요!",
            discribed:
              "수정 후 8주가 지나면서 두 아기 모두 본격적인 태아기에 접어들었어요. 아직 몸무게는 10g도 채 되지 않지만 몸의 구조는 이미 사람과 비슷한 모습을 하고 있답니다.\n\n꼬리는 완전히 사라지고 손가락과 발가락 사이의 막도 점차 사라지며 작은 손과 발의 형태가 또렷해지고 있어요.",
          },
          {
            subTitle: "몸 안의 기관들도 점차 자리를 잡고 있어요",
            discribed:
              "몸은 곧게 펴지고 점점 길어지며 얼굴에는 턱, 뺨, 입술, 눈꺼풀이 형성되고 유치와 머리카락의 기초 구조도 만들어지는 중이에요.\n\n지금은 쌍둥이 각각이 자기만의 속도로 사람다움을 완성해가는 시기예요. 초음파로 보면 서로 다른 방향을 바라보거나 작은 움직임을 보여주는 순간도 관찰할 수 있답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "엄마를 괴롭히는 입덧!",
          discribed: "입덧 증상이 최고조에 달해요.",
        },
        body: [
          {
            subTitle: "입덧, 조금만 힘내요!",
            discribed:
              "몇 주 전부터 이어진 입덧이 지금 가장 강하게 느껴지는 시기일 수 있어요. 쌍둥이를 임신한 경우, 호르몬 수치가 더 높기 때문에 입덧이 조금 더 오래가거나 심하게 나타날 수 있답니다.\n\n하지만 대부분은 이번 주를 기점으로 점차 완화되기 시작해요. 1~2주 내로 증상이 사라지며 식욕도 조금씩 돌아올 거예요.\n\n아직은 힘들어도 한 번에 많이 먹기보다 소량씩 자주 먹는 습관을 유지해보세요.",
          },
          {
            subTitle: "아랫배에 콕콕, 통증이 느껴져요",
            discribed:
              "아랫배가 뻐근하거나 찌르듯 아픈 느낌이 있다면 그건 자궁이 커지면서 주위 근육과 인대를 당기고 눌러서 생기는 통증이에요.\n\n쌍태아의 경우 자궁 확장 속도도 더 빠르기 때문에 이런 통증을 더 자주, 강하게 느낄 수 있어요. 걱정할 필요 없는 자연스러운 증상이에요.\n\n하지만 통증이 지속되거나 너무 심할 땐 꼭 병원에 문의해 주세요.",
          },
          {
            subTitle: "핏줄이 도드라져 보여요",
            discribed:
              "태아 두 명을 위한 혈액량을 공급해야 하다 보니 엄마의 혈관이 더 확장되고 피부 아래 핏줄이 도드라져 보일 수 있어요. 특히 가슴, 배, 허벅지 쪽에서 잘 보일 수 있어요.\n\n출산 후 수유 기간이 끝나면 자연스럽게 사라지거나 흐려지니 걱정 마세요!",
          },
          {
            subTitle: "영양 관리가 중요해요!",
            discribed:
              "**칼슘과 수분 섭취를 꼭 신경 써주세요!**\n쌍둥이는 골격 형성과 치아 발달에 필요한 칼슘이 더 많이 필요해요. 우유, 치즈, 멸치, 두부 등을 꾸준히 섭취해 주세요.\n\n또한 입덧으로 인해 수분이 부족해지기 쉬운 시기니 미지근한 물이나 전해질 음료 등으로 자주 수분을 보충해 주세요.",
          },
          {
            subTitle: "국민행복카드, 잊지 않으셨죠?",
            discribed:
              "앞으로 정기검진, 정밀초음파, 영양검사 등 다양한 산전검사가 예정돼 있어요.\n\n아직 국민행복카드(다태아: 140만 원 지원)를 발급받지 않았다면 지금 바로 신청하세요! www.voucher.go.kr에서 확인할 수 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧으로 힘들어하는 아내, 그런데 나도 왜 이럴까요?",
          discribed: "함께 고통받는 '쿠바드 증후군'일 수 있어요!",
        },
        body: [
          {
            subTitle: "쿠바드증후군이란?",
            discribed:
              '\'쿠바드(Couvade)\'는 프랑스어로 "알을 품다" 혹은 "부화하다"라는 뜻이에요.\n\n아내의 임신으로 인해 남편도 입덧, 메스꺼움, 불면, 식욕 변화 같은 신체적·심리적 증상을 함께 경험하는 현상을 쿠바드 증후군이라고 불러요.',
          },
          {
            subTitle: "혹시 이런 증상 느끼셨나요?",
            discribed:
              "• 이유 없이 속이 메스껍고 피곤하다\n• 감정 기복이 생기고 잠이 잘 안 온다\n• 예민해지거나, 식욕이 없어졌다\n\n통계에 따르면 임산부 남편의 약 3분의 1 정도가 쿠바드 증후군을 경험한다고 해요.\n\n특히 쌍둥이를 기다리는 경우엔 '두 아이의 아빠가 된다는 부담감'과 '아내의 고통에 대한 공감'이 더 크게 작용해 이런 증상이 더욱 뚜렷하게 나타날 수 있어요.",
          },
          {
            subTitle: "정말 신기한 사실!",
            discribed:
              "쿠바드 증후군을 겪는 남성은 실제로 호르몬 변화도 함께 경험한다고 해요:\n\n• **프로락틴 수치 상승** (양육 본능과 연관)\n• **테스토스테론 수치 하락** (공격성 감소)\n\n즉, 몸이 자연스럽게 '아빠의 준비'를 시작하고 있는 거예요.",
          },
          {
            subTitle: "어떻게 대처하면 좋을까요?",
            discribed:
              '이럴 땐 혼자 끙끙 앓기보다, 아내와 함께 미래의 이야기를 나누며 두 아이와의 새로운 삶을 따뜻하게 상상해보는 대화가 도움이 돼요.\n\n**이런 대화를 나눠보세요:**\n• "우리 아기들이 태어나면 어떤 모습일까?"\n• "나는 어떤 아빠가 되고 싶지?"\n• "요즘 가장 기대되는 순간은 뭐야?"\n\n이런 대화는 불안을 해소해줄 뿐 아니라 부부 사이의 유대감을 깊게 해주는 연결점이 될 거예요.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "당신이 느끼는 작은 변화들도 두 아이를 품은 이 여정을 함께하고 있다는 증거입니다.",
          },
        ],
      },
    },
    {
      week: 11,
      baby: {
        head: {
          title: "두 아기 모두 4배 가까이 성장했어요!",
          discribed: "각각 계란만 한 크기",
          size: "약 4.1cm~5.2cm",
        },
        body: [
          {
            subTitle: "머리, 몸통, 다리가 뚜렷해졌어요!",
            discribed:
              "이제 두 아기의 몸은 머리와 몸통, 팔다리가 확실히 구분되는 삼등신 비율의 태아다운 모습이에요.\n\n손목, 손가락, 허벅지, 종아리, 발이 세분화되고 피부엔 아주 미세한 솜털(체모)도 생기기 시작해요. 심장, 간, 비장, 맹장, 내장 등 모든 주요 기관이 제자리를 잡아가고 있어요.",
          },
          {
            subTitle: "아기들은 이제 숨쉬기 연습도 시작해요!",
            discribed:
              "횡격막이 형성되면서 양수를 삼키고 소변으로 배출하는 초기 '호흡+소화' 훈련을 시작했어요.\n\n또한 머리카락, 유치, 손톱·발톱의 자리도 준비되고 있으며, 곧 외부 생식기도 형성되어 성별 구분이 가능한 시점으로 다가오고 있어요.",
          },
          {
            subTitle: "각자의 속도로 성장하는 두 생명",
            discribed:
              "똑같이 자라고 있는 듯 보여도, 두 아기는 각자의 속도와 방식으로 하루하루 세상을 준비하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "엄마의 혈액량이 더 많이 늘었어요!\n자궁이 커지면서 두 아기를 위한 혈류 공급도 더 많아져요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "어지러움, 빈혈 조심!",
            discribed:
              "쌍태아 임신은 단태아보다 혈류 요구량이 더 크기 때문에, 빈혈 증상이 조금 더 빨리 또는 강하게 나타날 수 있어요.\n\n임신 중에는 자궁과 태반의 혈관이 늘어나며 전체 혈액량이 증가하지만, 적혈구 양은 상대적으로 덜 증가하기 때문에 혈액이 묽어지고 빈혈 증상이 나타날 수 있어요.",
          },
          {
            subTitle: "빈혈 증상과 예방법",
            discribed:
              "**빈혈 증상**\n• 극심한 피로감, 어지럼증, 현기증\n• 손발이 차거나 두근거림\n\n**철분 섭취가 중요해요!**\n쌍태아 임신의 경우 하루 약 30-60mg의 철분이 필요하며, 붉은 고기, 생선, 가금류, 짙은 잎채소, 콩류, 견과류, 철분 보충제도 도움이 돼요!",
          },
          {
            subTitle: "질 분비물이 늘었어요!",
            discribed:
              "에스트로겐 분비가 증가하고 골반 내 혈류가 활발해지면서 질 분비물도 눈에 띄게 늘어날 수 있어요. 약간 끈적하고, 시큼한 냄새가 나는 분비물이 나타나기도 해요.\n\n이 분비물은 산도를 보호하고 태아가 감염되지 않도록 도와주는 역할을 해요. 갑작스러운 분비물 증가에 놀랄 수 있지만 이는 정상적인 변화예요.",
          },
          {
            subTitle: "언제 병원에 가야 할까요?",
            discribed:
              "**다음 증상이 있다면 병원 상담이 필요해요:**\n• 색이 노랗거나 초록빛을 띠는 분비물\n• 냄새가 심하거나 가려움증이 있는 경우\n\n**관리 팁**\n• 속옷은 땀이 덜 차는 면 소재로 자주 갈아입기\n• 몸에 꼭 맞는 옷보다 통풍 잘되는 여유 있는 옷 착용",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "두 아기를 품고 있는 몸은 생각보다 훨씬 많은 일을 매일 하고 있어요. 지금 느끼는 모든 변화는 잘 자라고 있다는 증거랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "입덧으로 고생하는 아내를 위한 남편의 노력!",
          discribed: "입덧 극복, 얼마 남지 않았어요. 조금만 더 화이팅!",
        },
        body: [
          {
            subTitle: "입덧 극복을 위하여!",
            discribed:
              "쌍둥이를 품고 있는 아내는 지금도 몸과 마음 모두와 싸우고 있는 중이에요. 입덧이 심할수록 하루하루가 고비처럼 느껴질 수 있어요.\n\n개인차는 있지만 보통 입덧은 12주쯤부터 서서히 가라앉기 시작하니 조금만 더, 함께 힘내주세요!",
          },
          {
            subTitle: "아내의 음식 요청에 진심으로 응답해주세요",
            discribed:
              '아내가 "이거 먹고 싶다"는 말은 단순한 식욕이 아니라 필사의 요청일 수 있어요.\n\n**아빠가 할 수 있는 것들:**\n• 어떤 음식이든 귀찮게 여기지 말고 진심으로 들어주기\n• 구하기 어려운 음식이라도 노력하는 모습을 보여주기\n• 아내가 놀라거나 감동할 만큼의 정성이 큰 위로가 될 수 있어요',
          },
          {
            subTitle: "함께하는 산책의 힘",
            discribed:
              "시원한 공기와 가벼운 산책은 입덧을 잠시 잊게 해주는 좋은 방법이기도 해요.\n\n저녁 무렵, 조용한 길을 천천히 함께 걸어보는 것만으로도 아내는 큰 위안을 느낄 수 있답니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "입덧은 흔한 증상이지만, 그로 인한 삶의 질 저하는 결코 흔하지 않아요. 지금 아내의 하루를 지켜주는 가장 든든한 존재는 바로 당신이에요.",
          },
        ],
      },
    },
    {
      week: 12,
      baby: {
        head: {
          title: "팔다리가 쑥쑥, 이제 머리와 몸의 비율이 제법 그럴듯해 보여요!",
          discribed: "각각 키위만 한 크기",
          size: "약 5.4~6.6cm",
        },
        body: [
          {
            subTitle: "태아의 급성장!",
            discribed:
              "12주차에 접어든 두 아기 모두 임신 10~12주 사이에 급속도로 성장 중이에요. 몸길이는 두 배 가까이 커지고 얼굴 윤곽도 또렷해지고 있어요.\n\n몇 주 전부터 형성된 신체 기관들은 점점 기능적으로 안정화되고 근육이 발달하면서 양수 속에서 팔, 다리를 자유롭게 움직일 수 있게 되었어요.",
          },
          {
            subTitle: "다양한 반사작용이 나타나요!",
            discribed:
              "손가락과 발가락 사이가 벌어지고 손톱이 자라기 시작해요. 모근이 생기고, 피부 감각도 점차 깨어나요.\n\n하품을 하거나 손가락을 빨고, 양수를 삼키는 반사 신경도 발달 중이에요.",
          },
          {
            subTitle: "성별 구분도 가능해져요!",
            discribed:
              "이제 내부 생식기가 어느 정도 자리 잡으면서 남녀 성별을 초음파로 확인할 수 있는 시기에 가까워지고 있어요.\n\n물론 쌍둥이의 경우, 각각의 위치와 자세에 따라 한쪽만 먼저 확인되는 경우도 흔하니 너무 조급해하지 않아도 괜찮아요.",
          },
          {
            subTitle: "서로 다른 리듬으로 성장하는 두 생명",
            discribed:
              "두 생명은 함께 자라고 있지만, 서로 다른 리듬으로 자신만의 모습을 완성해가고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "자궁이 점점 커지고 있어요!",
          discribed: "자궁이 자몽만큼 커져서 골반 밖으로 나와요.",
        },
        body: [
          {
            subTitle: "자궁이 커졌어요!",
            discribed:
              "쌍둥이를 품고 있다면 자궁의 성장 속도는 단태아보다 더 빠르답니다. 이제 자궁은 자몽 크기만큼 커지며 골반 위로 올라와 아랫배가 조금씩 볼록하게 보일 수 있어요.\n\n커진 자궁이 방광을 눌러 소변이 자주 마려울 수 있고, 자궁을 지지하는 인대가 늘어나 아랫배나 사타구니에 찌릿한 통증이 느껴질 수도 있어요.",
          },
          {
            subTitle: "자궁 확장으로 인한 통증은 정상이에요",
            discribed:
              "이런 통증은 정상적인 생리적 변화예요. 하지만 통증이 오래가거나 너무 심할 땐 병원을 방문하세요.",
          },
          {
            subTitle: "얼굴과 목에 갈색반이 생기기도 해요!",
            discribed:
              "임신 호르몬의 영향으로 멜라닌 색소가 증가하면서 얼굴이나 목 주변에 기미, 잡티, 불규칙한 반점이 생길 수 있어요. 이런 증상을 '임신 가면' 또는 '갈색반'이라고 해요.\n\n대부분은 출산 후 1년 이내에 서서히 옅어지고 사라지니 걱정 마세요!",
          },
          {
            subTitle: "1차 기형아 검사를 진행해요!",
            discribed:
              "임신 12주차는 1차 기형아 검사 시기에 해당해요. 태아의 목덜미 두께(NT)를 측정해 다운증후군 등 염색체 이상 가능성을 확인하는 검사예요.\n\n**검사 정보**\n• **검사 대상**: 임신 10~13주 사이\n• **검사 방법**: 초음파 + 혈액검사\n• **준비사항**: 특별한 준비는 필요 없어요\n\n편안한 마음으로 검사받으시면 됩니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "두 아기를 위한 공간이 점점 넓어지고 있어요. 몸의 변화는 작지만, 그 안의 성장 속도는 놀랍도록 빠르답니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "이제 안정기에 접어들고 있어요!",
          discribed: "불안해하는 아내를 따뜻하게 지지해주세요!",
        },
        body: [
          {
            subTitle: "큰 산 하나를 넘었어요!",
            discribed:
              '쌍둥이를 품은 아내와 함께 12주차라는 중요한 시점에 도달했어요. 아직은 조심스러운 시기지만 이제부터는 안정기에 접어드는 길목이에요.\n\n아내에게 "정말 수고 많았어" 이 한마디, 꼭 건네주세요. 물론 남편인 당신도 충분히 잘 해오셨고 그 자체로 대단합니다.',
          },
          {
            subTitle: "1차 기형아 검사 시기, 아내의 마음을 이해해주세요",
            discribed:
              "이제 1차 기형아 검사도 진행되는 시기예요. 아내는 여러 생각으로 마음이 복잡할 수 있어요.\n\n결과에 대한 불안, 두 아기의 상태에 대한 걱정, 여전히 이어지는 입덧과 피로... 지금 아내가 바라는 건 완벽한 해답보다 묵묵히 곁에 있어주는 든든한 존재감이에요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "둘이 함께여서 여기까지 왔고, 앞으로도 함께라면 어떤 길도 거뜬히 완주할 수 있어요. 쌍둥이와 함께 걷는 여정, 이제 본격적인 시작입니다.",
          },
        ],
      },
    },
    {
      week: 13,
      baby: {
        head: {
          title: "이제는 3등신이에요!",
          discribed: "각각 작은 사과만 한 크기",
          size: "약 6.7~7.5cm",
        },
        body: [
          {
            subTitle: "신체기관들이 제자리로!",
            discribed:
              "쌍둥이 모두의 신체 조직과 장기는 더욱 활발하게 발달하며 제자리를 찾아가고 있어요. 커다란 탯줄 안에 있던 장기들은 점차 복부 안쪽으로 들어오고 있답니다.\n\n눈은 이마에서 콧등으로 가까워지며 귀도 머리 옆으로 이동해 얼굴 윤곽이 완성되어가요. 눈꺼풀은 아직 닫혀 있지만, 그 아래에서는 이미 완성된 눈 구조가 자라고 있어요.",
          },
          {
            subTitle: "숨 쉬는 연습도 시작했어요!",
            discribed:
              "아기들은 지금 양수를 마시고 뱉는 호흡 연습을 통해 폐를 부풀리고 수축시키며 실제 호흡에 필요한 근육을 훈련하고 있어요.\n\n지금 이 시기의 쌍둥이는 각자의 공간 안에서 작은 몸으로 분주하게 움직이며 자신만의 생명 시스템을 만들어가고 있답니다.",
          },
          {
            subTitle: "각자의 리듬으로 성장하는 두 생명",
            discribed:
              "서로 다른 속도로, 다른 자세로 두 아기가 각자의 리듬에 따라 생명을 완성해가는 중이에요.",
          },
        ],
      },
      mom: {
        head: {
          title: "입맛이 돌아오고 있어요!",
          discribed:
            "이제부터는 본격적으로 영양을 따지며 건강한 식생활을 해야할 때!",
        },
        body: [
          {
            subTitle: "입덧이 많이 사그라들어요!",
            discribed:
              "한동안 괴롭혔던 입덧이 13주차를 기점으로 차츰 가라앉고 있어요. 입맛이 돌아오고, 그동안 먹지 못했던 음식들이 눈에 들어오고 입에 당기기 시작하죠.\n\n하지만 쌍태아의 경우 과도한 체중 증가는 임신중독증, 임신성 당뇨 등 임신 중 합병증 위험을 높일 수 있어요.",
          },
          {
            subTitle: "건강한 체중 관리가 중요해요",
            discribed:
              "**건강한 체중 증가 목표**\n• 주당 500g, 한 달에 2kg 이하\n• 다양한 영양소를 고르게 포함한 식단\n• 짜고 자극적인 음식은 피하기\n• 식사 후 가벼운 산책도 도움이 돼요!",
          },
          {
            subTitle: "눈이 건조해져요!",
            discribed:
              "호르몬 변화로 인해 눈물 분비가 줄어들면서 눈이 뻑뻑하고 건조하게 느껴질 수 있어요.\n\n자연스러운 증상이지만, 일상에 불편을 줄 정도라면 안과 진료를 받아보세요.",
          },
          {
            subTitle: "배와 허벅지, 엉덩이에 임신선이 생기기도 해요!",
            discribed:
              "쌍태아를 품은 경우 복부 팽창이 더 빠르게 진행되기 때문에 임신선이 더 일찍, 혹은 더 도드라지게 나타날 수 있어요.\n\n보통은 체중이 갑자기 늘어날 때 생기며 출산 후 옅어지지만 완전히 사라지진 않아요.",
          },
          {
            subTitle: "임신선 관리 주의사항",
            discribed:
              "**주의할 점**\n• 스테로이드 성분이 포함된 연고·화장품은 사용하지 않기\n• 임신선 부위에 강한 마사지는 피하기 (자궁 수축 유발 가능)\n\n대신, 보습제를 부드럽게 발라 피부가 건조해지지 않도록 관리해 주세요.",
          },
          {
            subTitle: "이제는 기쁜 소식을 전해도 될 때!",
            discribed:
              "그동안 조심하느라 주변에 임신 사실을 알리지 못했죠. 이제는 안정기에 접어들었으니, 마음 편하게 기쁜 소식을 전할 수 있어요.\n\n특히 일을 하고 있는 워킹맘이라면, 이 시기에 직장에 임신 사실을 알리고 출산휴가 및 육아휴직에 대해 미리 상의해보는 것도 좋아요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "입덧은 가라앉고, 식욕은 돌아오고, 기쁜 소식을 나눌 수 있는 시기. 지금 이 순간도 잘 해내고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "엄마와 뱃속의 아기까지 케어하는 아빠는 슈퍼맨!",
          discribed: "엄마와 아기의 건강을 위해 식단 조절을 도와주세요!",
        },
        body: [
          {
            subTitle: "이미 육아는 시작됐어요!",
            discribed:
              "벌써 임신 넉 달차에 접어들었어요. 쌍둥이 모두가 빠르게 자라며 몸의 기본 구조가 완성되는 시기에 도달했죠.\n\n지금 이 순간, 아내와 함께 아기의 건강을 위해 신경 쓰고, 조심하고, 도와주는 모든 행동이 이미 '육아'의 시작이자 훈련이랍니다.",
          },
          {
            subTitle: "입덧이 사그라든 아내를 위해 식단 도우미가 되어주세요!",
            discribed:
              "한동안 힘들게 했던 입덧이 차츰 가라앉고 있어요. 이제는 슬슬 입맛이 돌아오고, 오랜만에 식사다운 식사를 하고 싶어할 시기예요.\n\n하지만! 쌍태아 임신은 체중 관리가 더욱 중요해요.",
          },
          {
            subTitle: "아빠가 해줄 수 있는 것들",
            discribed:
              "**아빠가 해줄 수 있는 것:**\n• 아내의 입맛을 고려한 건강한 메뉴 준비\n• 영양소 균형을 고려해 식단 구성\n• 너무 많이 먹지 않도록 식사량 조절 함께 도와주기\n\n이제부터 아빠는 단순한 동행이 아닌 '식사 페이스메이커'이자 건강 지킴이예요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "입덧이 가라앉은 지금이 몸을 회복하고 건강을 챙길 최고의 찬스! 함께하는 식탁이 두 아이의 튼튼한 시작이 될 수 있어요.",
          },
        ],
      },
    },
    {
      week: 14,
      baby: {
        head: {
          title: "아기와 엄마가 탯줄로 단단히 연결되어 있어요!",
          discribed: "각각 엄마의 주먹만 한 크기",
          size: "약 9~10cm",
        },
        body: [
          {
            subTitle: "태반이 완성되었어요!",
            discribed:
              "이제 두 아기 모두가 완성된 태반을 통해 엄마와 본격적으로 연결됐어요. 탯줄을 통해 산소, 영양분, 면역 성분을 받아 두 생명이 더 빠르고 안정적으로 성장할 수 있는 기반이 마련된 거예요.\n\n쌍태아의 경우 각각 자신만의 태반을 갖거나, 하나의 태반을 함께 쓰는 구조일 수 있어요. 하지만 어떤 구조이든 이제부터는 엄마의 영양과 컨디션이 더 중요해지는 시기랍니다.",
          },
          {
            subTitle: "몸 전체에 솜털이 나기 시작했어요!",
            discribed:
              "태아의 살결을 따라 소용돌이 모양의 미세한 솜털이 나기 시작했어요. 이 솜털은 태아의 피부를 감싸며 피부 온도 조절, 감각 보호, 자극 완충의 역할을 해요.\n\n아직 작고 보이지 않지만 두 아기 모두 자신만의 외형을 완성해가는 중이에요.",
          },
          {
            subTitle: "뇌가 좌뇌와 우뇌로 나뉘고 있어요!",
            discribed:
              "그동안 공처럼 둥글던 태아의 뇌가 좌뇌와 우뇌로 나뉘고, 점점 주름이 생기며 사람의 뇌 형태로 발달하고 있어요.\n\n신경회로가 복잡하게 만들어지고 감각에 반응할 수 있는 반사 작용도 활발해지는 시기! 지금 두 아기는 양수 속에서 움찔거리거나, 손을 펴고 오므리며, 반응하는 능력을 하나씩 익히고 있어요.",
          },
          {
            subTitle: "엄마와 한 몸이 된 두 생명",
            discribed:
              "두 아기는 이제 엄마와 한 몸처럼 연결되어 더욱 빠르게, 더욱 정교하게 자기만의 생명을 완성해가고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 중기, 새로운 전환점!",
          discribed: "천천히, 그리고 확실하게 배가 불러오고 있어요.",
        },
        body: [
          {
            subTitle: "아랫배가 나오기 시작해요",
            discribed:
              "자궁이 점점 더 커지고 양수의 양도 늘어나면서 아랫배가 부풀고 임산부 티가 나기 시작했어요. 쌍둥이를 품고 있다면 복부 팽창이 더 빠르게 나타날 수 있어요.\n\n임부복은 더 이상 선택이 아닌 필수! 몸에 맞지 않는 옷은 혈액순환을 방해하고 불편함을 유발할 수 있어요.",
          },
          {
            subTitle: "골반과 사타구니 통증이 생길 수 있어요",
            discribed:
              "또한 자궁이 골반 뼈를 밀어내면서 사타구니 통증이나 골반 압박감이 생길 수 있어요. 바른 자세와 스트레칭으로 무리 없이 몸을 지켜주세요.",
          },
          {
            subTitle: "피부 트러블이 생길 수 있어요",
            discribed:
              "호르몬 변화로 인해 유두 주변, 겨드랑이, 허벅지 안쪽 등이 진갈색으로 변하거나, 기미나 색소 침착이 올라올 수 있어요.\n\n이런 피부 변화는 출산 후 점차 사라지니 너무 걱정하지 않아도 괜찮아요. 자극적인 스킨케어 제품은 피하고, 저자극 보습 위주로 피부를 진정시켜 주세요.",
          },
          {
            subTitle: "영양소는 골고루, 체중은 천천히",
            discribed:
              "이 시기는 태아가 본격적으로 성장하는 시기! 쌍둥이의 성장을 위해 영양소 공급이 더욱 중요해요.\n\n**건강한 식생활 가이드**\n• 한 번에 많이 먹기보다는 작게, 자주, 천천히 먹기\n• 물은 하루에 8잔 이상 마시기\n• 비타민, 단백질, 칼슘, 철분, 엽산 모두 고루 챙기기\n• 과식은 금물! 주기적인 체중 측정과 기록으로 급격한 체중 증가 조절하기",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "배는 조금씩 불러오고, 두 생명은 눈부시게 자라고 있어요. 몸의 작은 변화들 속에서 '잘 해내고 있다'는 사실을 잊지 마세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "튼 살 관리는 미리미리!",
          discribed: "사랑이 담긴 마사지는 아내와 아기에게 큰 선물이 돼요.",
        },
        body: [
          {
            subTitle: "튼 살, 지금부터 관리해볼까요?",
            discribed:
              "튼살은 보통 임신 중기 이후부터 복부, 가슴, 엉덩이, 허벅지 등 피부가 얇고 팽창이 심한 부위에 잘 생겨요.\n\n쌍둥이를 임신한 경우에는 피부가 더 빠르게 늘어나기 때문에 튼살이 더 빨리, 더 넓게 생기기 쉬워요. 튼살은 한 번 생기면 완전히 없애기 어렵기 때문에 초기부터의 예방 관리가 핵심이에요!",
          },
          {
            subTitle: "아빠가 해줄 수 있는 튼살 관리법",
            discribed:
              "**아빠가 해줄 수 있는 것:**\n• 샤워 후 물기가 남아 있을 때 튼살 크림이나 오일을 부드럽게 마사지하며 발라주기\n• 아침에는 로션, 저녁에는 크림을 사용해 피부에 충분한 유분과 보습을 전달하기\n\n단순한 피부 관리가 아닌 사랑의 스킨십으로 느껴질 수 있도록 아내의 감정까지 함께 케어해주세요!",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "작은 손길 하나에도 아내는 위로를, 아기는 따뜻한 사랑을 느낄 수 있어요. 지금 이 마사지는 튼살 예방을 넘어, 가족이 함께하는 태교의 시작입니다.",
          },
        ],
      },
    },
    {
      week: 15,
      baby: {
        head: {
          title: "열심히 꼼지락 꼼지락!",
          discribed: "각각 아보카도만 한 크기",
          size: "약 10cm, 100g",
        },
        body: [
          {
            subTitle: "근육을 움직일 수 있어요!",
            discribed:
              "쌍둥이 모두 근육이 발달하면서 초음파를 통해 작은 움직임을 또렷하게 관찰할 수 있어요.\n\n주먹을 꽉 쥐거나 눈을 가늘게 뜨고 눈살을 찌푸리기도 해요. 손가락, 발가락을 오므리고 팔다리를 활발하게 휘젓는 모습도 보일 수 있어요.",
          },
          {
            subTitle: "아직 엄마가 느끼기엔 이른 시기",
            discribed:
              "이 시기의 움직임은 대부분 엄마가 직접 느끼기엔 아직 이르지만, 초음파에서는 두 아기가 각자의 공간에서 분주하게 꼼지락거리는 장면이 펼쳐지곤 해요.",
          },
          {
            subTitle: "성별을 구분할 수 있어요!",
            discribed:
              "15주차에는 외부 생식기가 거의 완성되어 초음파로 성별을 확인할 수 있는 시기에 들어섰어요.\n\n하지만 쌍태아의 경우엔... 아기들의 자세나 위치가 겹치거나 가려져 있으면 한쪽만 확인되거나 둘 다 판별이 어려운 경우도 있어요.\n\n성별이 확실하게 보이지 않더라도 걱정하지 마세요! 20주차쯤 진행하는 정밀 초음파 검사에서 보다 정확하게 확인할 수 있어요.",
          },
          {
            subTitle: "서로 다른 리듬으로 움직이는 두 생명",
            discribed:
              "두 아기는 같은 자궁 안에서 서로 다른 리듬으로 팔다리를 움직이며 작은 몸으로 세상을 준비하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "체중이 본격적으로 늘어나요!",
          discribed: "점점 완전한 D라인에 가까워지고 있어요.",
        },
        body: [
          {
            subTitle: "아랫배가 눈에띄게 나와요!",
            discribed:
              "자궁이 더 커지면서 골반 안에 있던 자궁이 배 위쪽으로 올라오고 있어요. 쌍둥이를 품고 있는 경우 복부 팽창이 더욱 빠르고 확연하게 나타나요.\n\n자궁이 위로 올라오면서 방광 압박이 줄어들어 빈뇨 증상은 다소 완화되지만, 커진 자궁이 심장으로 가는 정맥을 누르기 때문에 다리가 붓거나 쥐가 나기도 해요.",
          },
          {
            subTitle: "통증과 주의사항",
            discribed:
              "또한 자궁을 받치는 인대가 늘어나 사타구니나 아랫배에 뻐근한 통증이 생길 수 있어요.\n\n**주의사항**\n• 갑작스러운 움직임보다는 천천히, 부드럽게 움직이기\n• 격한 운동이나 장시간 외출은 자궁 수축 위험이 있으니 주의하기",
          },
          {
            subTitle: "기초체온이 낮아지고 있어요",
            discribed:
              "임신 초기 높았던 체온이 이제 점차 낮아지기 시작해요. 몸이 임신에 적응하면서 초기의 나른함이나 피로감도 점점 줄어들고, 감정적으로도 안정감이 찾아오는 시기랍니다.",
          },
          {
            subTitle: "잇몸 건강을 지켜주세요",
            discribed:
              "쌍둥이를 임신한 경우 호르몬 변화가 더 크기 때문에 잇몸 염증이나 출혈, 부종 증상이 더 두드러질 수 있어요.\n\n침 분비량이 줄고, 수면 시간이 길어지면서 입안이 세균 증식에 더 취약한 환경이 되기 쉬워요. 지금은 안정기에 해당하는 시기로, 치과 치료를 받기에 적절한 시기예요.\n\n치과 진료가 필요하다면 망설이지 말고 받아보세요!",
          },
          {
            subTitle: "두 번째 기형아 검사를 준비해요",
            discribed:
              "16주 전후에는 2차 기형아 검사를 받게 돼요. 이는 다운증후군 등 염색체 이상 여부를 확인하는 검사예요.\n\n특별한 준비 없이 편안한 마음으로 검사받으시면 됩니다. 이상 소견이 있을 경우, 정밀 초음파나 양수 검사 등이 추가로 진행될 수 있어요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "복부는 커지고 몸무게도 늘지만, 지금 이 변화는 두 아이를 품은 증거예요. 천천히, 하지만 꾸준히 잘 해내고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "부부사이의 소통이 중요해요!",
          discribed: "서로의 마음을 진심으로 나눌 수 있는 시간을 가져보세요.",
        },
        body: [
          {
            subTitle: "남편의 소외감, 자연스러운 감정이에요",
            discribed:
              '쌍둥이를 임신한 아내를 바라보며 기쁨과 설렘을 느끼는 한편, 남편 자신은 조금씩 멀어지는 듯한 외로움을 느끼는 순간이 찾아올 수 있어요.\n\n모든 관심이 아내와 아기에게 쏠리고 주변에서도 "아빠"보다는 "엄마"의 상태를 더 묻고 정작 본인은 뒤에 남겨진 느낌이 들기도 하죠.\n\n이런 감정은 부자연스러운 것이 아니라, 지극히 자연스러운 현상이에요. 중요한 건, 서로 미리 알고 이해하는 것, 그리고 대화로 풀어가는 것이랍니다.',
          },
          {
            subTitle: "진심 어린 대화가 필요해요",
            discribed:
              '아내는 여전히 입덧이나 통증, 변화 속에서 지쳐 있을 수 있어요. 하지만 남편이 겪는 감정도 충분히 소중해요.\n\n둘만의 시간을 내어 편안한 분위기에서 솔직한 이야기를 나눠보세요. "나도 이런 감정이 있어"라고 말해주는 것만으로도 서로를 더 깊이 이해할 수 있게 됩니다.',
          },
          {
            subTitle: "선배 아빠들의 조언을 들어보세요",
            discribed:
              "선배 아빠들의 조언을 듣는 것도 큰 도움이 돼요! 비슷한 시기를 지나온 사람들의 경험은 지금 느끼는 감정을 다독여주는 현실적인 조언이 되어줄 거예요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "지금 이 시간은 엄마와 아빠가 서로를 더 이해하고, 부부로서의 유대를 더 깊이 다질 수 있는 소중한 기회예요.",
          },
        ],
      },
    },
    {
      week: 16,
      baby: {
        head: {
          title: "아기는 지금 열심히 움직이는 중이에요!",
          discribed: "각각 참외만 한 크기",
          size: "약 11~12cm, 140g",
        },
        body: [
          {
            subTitle: "활발하게 움직여요!",
            discribed:
              "쌍둥이 모두 움직임이 점점 더 활발해지고 있어요. 초음파로 보면 머리를 흔들거나 손발을 쭉 뻗고 오므리며 자기만의 운동 시간을 즐기고 있답니다.\n\n지금 자궁은 두 아기에게 충분한 공간을 제공하고 있어서 아기들은 마치 양수 속을 헤엄치듯 자유롭게 움직이며 근육과 골격을 발달시키고 있어요.\n\n이 움직임은 아직은 엄마가 직접 느끼기 어렵지만, 조만간 태동의 첫 느낌으로 다가올 수 있어요!",
          },
          {
            subTitle: "빛과 소리에 반응하고, 딸꾹질도 시작돼요!",
            discribed:
              "자궁 밖에서 들어오는 빛에 민감하게 반응하고 숨쉬기 전 단계인 딸꾹질을 시작하기도 해요.\n\n아직 아기의 폐는 액체로 차 있기 때문에 딸꾹질 소리는 들리지 않지만, 초음파에서 리듬감 있는 움직임으로 확인할 수 있어요.",
          },
          {
            subTitle: "각자의 리듬으로 세상을 준비하는 두 생명",
            discribed:
              "두 아이는 각자의 공간에서 팔을 뻗고, 머리를 돌리고, 다리를 구부리며 자기만의 리듬으로 세상을 준비하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "이제 정말 '임산부다운' 몸이 되었어요! 입덧과는 작별하고, 두 아기처럼 엄마도 활기차게 지내보세요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "완전한 임산부의 모습이에요!",
            discribed:
              "16주차에 접어든 지금, 배는 한눈에 봐도 제법 불러온 모습이 되었을 거예요. 쌍태아의 경우 단태아보다 복부 팽창이 더 빠르고 크기 때문에 허리 통증이 느껴질 수 있어요.\n\n배가 앞으로 무게를 더하면서 허리에 부담이 생기기 쉬워요. 이럴 때일수록 바른 자세 유지와 가벼운 스트레칭, 임산부용 운동이 도움이 된답니다!",
          },
          {
            subTitle: "안정기에 접어들었지만, 여전히 조심은 필요해요!",
            discribed:
              '태반이 완전히 자리 잡으면서 유산의 위험은 크게 줄어들었고, 입덧, 피로, 감정 기복 등 초기 증상도 한결 가라앉아 컨디션이 좋아진 시기예요.\n\n하지만! "이제 괜찮겠지" 하는 마음으로 무리한 활동이나 격한 운동을 하게 되면 자궁 수축이나 몸의 과부하가 생길 수 있어요. 쌍태아의 경우 몸에 가해지는 부담이 크기 때문에 더 조심해야 해요.',
          },
          {
            subTitle: "운동 가이드",
            discribed:
              "**OK한 운동**: 걷기, 요가, 스트레칭\n**피해야 할 활동**: 등산, 댄스, 무거운 물건 옮기기",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "안정기에 들어선 지금이야말로 '몸을 믿고 아기들을 믿으며' 하루하루를 건강하고 편안하게 보내야 할 시기예요.",
          },
        ],
      },
      dad: {
        head: {
          title: "안정기에 접어들면, 부부관계를 가져도 괜찮아요!",
          discribed: "관계시 배를 누르지 않도록 주의가 필요해요.",
        },
        body: [
          {
            subTitle: "임신 중 성관계, 괜찮을까요?",
            discribed:
              "임신 초기(1~12주)에는 자궁이 불안정하기 때문에 성관계를 피하는 것이 원칙이에요. 특히 착상 직후나 입덧이 심한 시기에는 자궁 수축이나 불쾌감을 유발할 수 있어요.\n\n하지만 지금은 임신 16주차, 중기에 접어든 시점이에요. 입덧도 잦아들고 몸 상태도 안정되어 적절한 주의만 한다면 관계가 가능한 시기입니다.",
          },
          {
            subTitle: "쌍태아일 때는 더 조심해야 해요",
            discribed:
              "쌍둥이를 품고 있는 경우 자궁이 더 빠르게 커지고 민감해지기 때문에 배에 압력이 가해지지 않도록 특히 주의해야 해요.",
          },
          {
            subTitle: "관계 시 주의사항",
            discribed:
              "**기본 원칙**\n• 배를 누르지 않는 체위를 선택하세요\n• 무리하거나 강한 움직임은 피하고\n• 아내의 몸 상태를 지속적으로 확인해 주세요",
          },
          {
            subTitle: "반드시 기억할 주의사항",
            discribed:
              "**유두 자극은 피하세요!**\n자궁 수축을 유도하는 옥시토신 분비가 증가해 조산 위험을 높일 수 있어요.\n\n**외음부 감염 주의**\n임신 중에는 면역력이 낮아지고 질 내 산성도도 변화해 세균 감염 위험이 높아요. 부부 모두 청결을 유지하고, 질 내 손 삽입, 구강성교는 피해주세요.",
          },
          {
            subTitle: "반드시 콘돔을 착용하세요!",
            discribed:
              "정액 속 프로스타글란딘은 자궁을 수축시킬 수 있어요. 또한 감염 예방을 위해서도 콘돔은 필수입니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "신체적으로 허락되는 시기라 해도 가장 중요한 건 아내의 컨디션과 감정입니다. 서로의 마음을 나누며 조심스럽게 다가가는 것, 그게 진짜 배려예요.",
          },
        ],
      },
    },
    {
      week: 17,
      baby: {
        head: {
          title: "신경이 발달하고, 태어나기 위한 준비를 해요!",
          discribed: "각각 사과만 한 크기",
          size: "약 13cm, 160g",
        },
        body: [
          {
            subTitle: "청각 기관이 발달해요!",
            discribed:
              "이 시기 두 아기 모두 청각 기관이 빠르게 발달하고 있어요. 귓속의 작은 뼈들이 단단해지기 시작하면서 점차 소리를 들을 수 있는 능력이 생기고 있답니다.\n\n엄마의 심장 박동, 혈류 소리, 소화기 소리는 물론 외부에서 들리는 말소리, 음악 소리도 감지할 수 있어요.",
          },
          {
            subTitle: "소리에 따른 아기의 반응",
            discribed:
              "듣는 소리에 따라 아기의 반응이 달라질 수 있어요. 따뜻한 목소리, 부드러운 음악은 두 아기에게 정서적 안정감을 줄 수 있답니다.",
          },
          {
            subTitle: "태아는 지금 열심히 연습 중!",
            discribed:
              "두 아기 모두 순환계와 비뇨기계가 활발하게 작동하고 있어요. 필요한 산소는 태반을 통해 공급받고 양수를 들이마셨다 내쉬며 숨 쉬는 연습을 하고 있어요.\n\n이 과정을 통해 소화기 계통도 함께 발달하며 태어날 준비를 하나씩 차근차근 해나가는 중이에요.",
          },
          {
            subTitle: "세상을 준비하는 두 생명",
            discribed:
              "두 아기는 지금 세상의 소리에 귀 기울이고, 자신의 몸을 하나하나 준비해가며 조용하지만 부지런히 성장하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "몸무게가 자꾸자꾸 늘어나요!",
          discribed: "태반이 완성되면서 두 아기가 빠르게 성장 중이에요.",
        },
        body: [
          {
            subTitle: "태동이 느껴지기 시작했어요!",
            discribed:
              '이 시기에 처음 태동을 느낀 엄마들은 "이게 아기 움직임이 맞나?" 하고 헷갈릴 수 있어요. 물방울이 톡톡 튀거나, 장이 꾸르륵 하는 듯한 미세한 움직임이 태동일 수 있답니다.\n\n쌍둥이를 임신한 경우 두 아기의 움직임이 교차되기도 하고, 위치에 따라 한쪽 태동만 먼저 느껴질 수도 있어요.\n\n조금씩 느껴지는 생명의 움직임을 차분히 느껴보세요 — 이건 엄마만이 누릴 수 있는 특별한 경험이에요.',
          },
          {
            subTitle: "체중 증가 속도가 빨라졌어요",
            discribed:
              "입덧이 완화되면서 식욕이 확 늘어난 시기죠. 특히 쌍태아 임신은 영양 요구량이 크기 때문에 몸무게가 더 빠르게 늘어날 수 있어요.\n\n하지만! 한 달에 2kg 이상 증가하지 않도록 규칙적인 식사, 가벼운 산책, 야식 줄이기 등 작은 실천들이 중요해요.",
          },
          {
            subTitle: "변비가 심해질 수 있어요",
            discribed:
              "쌍둥이로 인해 자궁이 더 커지고 장을 눌러 소화기관이 느려지며 변비가 심해지기 쉬워요.\n\n**변비 완화 방법**\n• 물 많이 마시기\n• 식이섬유 풍부한 음식 섭취\n• 가능한 가벼운 움직임 유지\n\n약 복용이 필요할 정도라면 반드시 산부인과 전문의와 상담 후 복용하세요.",
          },
          {
            subTitle: "철분 섭취는 꼭! 필수예요",
            discribed:
              "쌍둥이를 위해 필요한 혈액량은 단태아보다 훨씬 많아요. 따라서 철분 보충은 철저히 신경 써야 할 항목이에요.\n\n**철분 섭취 가이드**\n• 하루 권장량: 60~100mg 이상\n• 철분과 함께 비타민C가 풍부한 과일 섭취 시 흡수율 증가\n• 유제품이나 커피, 녹차는 철분 흡수를 방해하므로 시간차를 두고 복용",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "태동이 느껴지고, 몸이 더 무거워지며 하루하루가 '엄마'라는 이름에 더 가까워지고 있어요. 잘 하고 있어요. 지금도 충분히요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "검사 일정이 많아지는 시기예요!\n정신없는 아내를 위해 남편이 먼저 챙겨주세요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "검사를 미리미리 체크하세요!",
            discribed:
              "17주차에 접어들면 쌍태아 임신부에게는 정기검진 외에도 다양한 추가 검사들이 예정돼 있어요. 혈액검사, 초음파, 2차 기형아 검사 등 산전 관리가 더 촘촘해지는 시기죠.\n\n이럴 땐 남편의 역할이 정말 중요해요.",
          },
          {
            subTitle: "아빠가 해줄 수 있는 것들",
            discribed:
              "**검사 관리 도우미 되기**\n• 다음 진료일, 검사 항목, 장소 등 스케줄을 메모하거나 캘린더에 정리해두기\n• 아내가 잊지 않도록 부드럽게 리마인드해 주기\n• 병원 동행은 물론, 검사 전후의 감정적인 지원도 필요해요",
          },
          {
            subTitle: "검사 불안도 함께 나누세요",
            discribed:
              '아내는 검사 자체보다 "혹시 결과가 안 좋으면 어쩌지"라는 불안감에 감정적으로 지쳐 있을 수 있어요.\n\n"괜찮아, 우리 함께하니까", "걱정되는 거 있어? 같이 이야기해볼까?" - 이런 말 한마디가 검사보다 더 힘든 \'기다림의 시간\'을 견디게 해주는 힘이 됩니다.',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "검사를 챙기는 건 단순한 일정 관리가 아니라 부부가 함께 아이를 지켜나가는 마음의 표현이에요. 곁에 있는 것만으로도 큰 힘이 된다는 걸 잊지 마세요.",
          },
        ],
      },
    },
    {
      week: 18,
      baby: {
        head: {
          title: "근육이 붙고 움직임이 활발해지고 있어요!",
          discribed: "각각 배만 한 크기",
          size: "약 14~15cm, 200g",
        },
        body: [
          {
            subTitle: "본격적인 태동이 시작돼요!",
            discribed:
              "두 아기 모두 자궁 속에서 더 많은 공간과 힘을 얻어 이제는 자유자재로 움직일 수 있어요. 머리를 돌리거나 손발을 구부리고 펴고 가끔은 엄마 배를 툭툭 차며 존재를 알리기도 해요.\n\n지금은 본격적인 태동의 시작 시기예요! 한 명의 움직임인지, 두 명이 번갈아 움직이는 건지 혼동될 수 있지만, 두 아이 모두 열심히 활동 중이랍니다.",
          },
          {
            subTitle: "태지가 아기의 몸을 감싸고 있어요",
            discribed:
              "이제 두 아기의 피부 위로 얇은 기름막인 '태지'(vernix caseosa)가 생성되기 시작해요. 흰색 크림 같은 물질로 피부를 부드럽게 감싸며 보호막 역할을 해요.\n\n자궁 안 양수 속에서도 피부가 건조하거나 손상되지 않도록 지켜준답니다. 태지는 출산 직전까지 아기를 보호하며, 출산 시 아기 피부에 희끄무레하게 남아 있는 모습으로 확인되기도 해요.",
          },
          {
            subTitle: "존재를 알려오는 두 생명",
            discribed:
              "자신의 존재를 툭툭 알려오는 두 생명, 움직임 하나하나가 점점 더 또렷해지고 있어요. 이제는 진짜로 '함께 있다'는 느낌이 와닿을 거예요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "아기들이 움직이는 걸 느끼기 시작했어요!\n두 아기가 함께하고 있다는 사실이 점점 더 실감나기 시작하죠!",
          discribed: "",
        },
        body: [
          {
            subTitle: "질 분비물이 증가해요",
            discribed:
              "쌍둥이를 품은 엄마의 몸은 더 많은 혈류량과 에스트로겐 분비로 인해 질 분비물도 더욱 많아질 수 있어요.\n\n이 분비물은 태아를 감염으로부터 보호하고 출산 시 산도를 부드럽게 만드는 중요한 역할을 해요.",
          },
          {
            subTitle: "질염 주의사항",
            discribed:
              "**다음과 같은 경우에는 질염을 의심해야 해요:**\n• 분비물 양이 갑자기 많아지고\n• 색이 노랗거나 녹색이며\n• 가려움증이나 악취가 동반될 경우\n\n이럴 땐 꼭 의사와 상담해주세요.",
          },
          {
            subTitle: "가슴이 커지고 분비물이 나와요",
            discribed:
              "유선 발달이 활발해지면서 유방이 커지고 유두에서 분비물이 나올 수 있어요. 쌍둥이 임신의 경우 유선 자극도 빠르게 나타나 속옷이 갑자기 맞지 않게 느껴질 수 있어요.\n\n임산부 전용 브라나 수유 브라를 착용하고 유두 분비물은 짜지 말고 거즈로 가볍게 닦아주세요.",
          },
          {
            subTitle: "다리에 경련이 생길 수 있어요",
            discribed:
              "두 아기를 위해 더 많은 칼슘, 마그네슘이 필요해지면서 엄마의 몸은 상대적으로 영양소 부족, 혈액순환 저하를 겪게 돼요.\n\n특히 종아리에 경련이 잘 생기는데, 자기 전 스트레칭, 가벼운 마사지를 꾸준히 해보세요.",
          },
          {
            subTitle: "심스 자세로 숙면을 도와주세요",
            discribed:
              "쌍둥이를 품은 몸은 빠르게 무거워지고 잠자기조차 힘들어질 수 있어요.\n\n이럴 땐 왼쪽으로 누운 후 오른쪽 다리를 살짝 들어 올린 심스 자세가 좋아요. 혈액순환 개선, 자궁 무게 완화, 요통 감소와 숙면 유도에 도움이 된답니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "몸이 보내는 작은 변화에 귀 기울이며 두 아기와 나, 모두가 편안한 하루를 만들어가요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "아기들에게 아빠의 목소리를 들려주세요!\n쌍둥이 모두에게 아빠의 목소리는 특별하게 다가가요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "태동을 느끼며 아기들과 대화해보세요!",
            discribed:
              "태아에게 가장 먼저 발달하는 감각은 바로 청각이에요. 그리고 아빠의 중저음 목소리는 엄마의 고음보다 자궁 속 아기에게 더 또렷하게 전달된답니다.\n\n두 아이 모두 아빠의 목소리를 들으며 안정감을 느끼고, 태명이나 애칭을 반복해서 듣는 것을 통해 애착이 깊어질 수 있어요.",
          },
          {
            subTitle: "아빠 목소리의 놀라운 효과",
            discribed:
              "연구에 따르면 아기가 듣는 소리는 두뇌 발달에 영향을 주고, 음성 자극의 빈도와 톤에 따라 감정 조절 능력에도 영향을 줄 수 있다고 해요.",
          },
          {
            subTitle: "처음엔 어색해도, 꾸준히가 중요해요!",
            discribed:
              "아직 세상 밖으로 나오지 않은 두 아기에게 말을 거는 것이 어색하게 느껴질 수 있어요. 하지만 꾸준히 말을 걸다 보면 아빠 자신에게도 태아가 더 '실제'처럼 느껴지고, 정서적 연결이 훨씬 깊어질 수 있어요.",
          },
          {
            subTitle: "이렇게 시작해보세요",
            discribed:
              '**아기들에게 건네는 따뜻한 말들**\n• "우리 아기들 잘 자고 있니?"\n• "아빠는 너희를 만나게 될 날이 정말 기대돼."\n• "오늘은 엄마가 피곤하대. 우리 힘내자!"',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 생명이 아빠의 목소리를 통해 세상과 처음 연결되는 지금, 그 따뜻한 소리가 두 아이의 마음에도 차곡차곡 쌓이고 있어요.",
          },
        ],
      },
    },
    {
      week: 19,
      baby: {
        head: {
          title: "엄마 아빠의 목소리, 이제 잘들려요!",
          discribed: "각각 바나나 한 송이만 한 크기",
          size: "약 16~17cm, 250g",
        },
        body: [
          {
            subTitle: "뇌가 활발하게 발달했어요!",
            discribed:
              "이제 두 아기의 뇌가 빠르게 성장하며 엄마, 아빠의 목소리를 기억할 수 있는 능력도 생겼어요. 특히 간뇌가 발달해 엄마의 감정 상태에 따라 태아의 반응도 달라질 수 있어요.\n\n뇌에서 근육으로 연결되는 운동신경도 활발히 형성되며 태아는 점차 자신의 의지대로 움직일 수 있게 돼요.",
          },
          {
            subTitle: "초음파에서 다양한 모습이 보여요",
            discribed:
              "초음파를 통해 보면 쌍둥이 각각이 스스로 몸을 움직이는 모습이 포착될 수 있어요. 발로 차고, 몸을 구부렸다 펴고, 때론 엄지손가락을 빨기도 하죠.\n\n이 시기는 아기의 움직임과 청각 반응이 눈에 띄게 늘어나는 시기예요. 따뜻한 목소리로 말 걸기, 음악 듣기 등 감성 자극 태교를 시작해보세요.",
          },
          {
            subTitle: "세상과 교감하는 연습을 하는 두 생명",
            discribed:
              "두 아이는 엄마 아빠의 목소리를 기억하고, 스스로를 움직이며 세상과 교감하는 연습을 하고 있어요. 조용하지만 부지런한 성장의 시간입니다.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "엄마의 몸은 계속해서 변화하고 있어요!\n임신 전과는 확연히 달라진 점들을 느낄 수 있어요.",
          discried: "",
        },
        body: [
          {
            subTitle: "가슴에 변화가 생겼어요!",
            discribed:
              "호르몬의 작용으로 유륜이 넓어지고, 유두의 색이 점점 짙어지는 변화가 나타나요. 유선이 본격적으로 발달하면서 유즙이 소량 배출되기도 해요.\n\n유두가 따끔거리거나 가려운 듯한 감각이 생기기도 하고 속옷이 조이는 느낌이 불편하게 느껴질 수 있어요.\n\n**주의사항**: 유즙이 나와도 억지로 짜지 마세요. 거즈나 부드러운 수건으로 살짝 닦아내는 것이 가장 좋아요.",
          },
          {
            subTitle: "갑자기 코를 골기 시작했어요?",
            discribed:
              "임신 전엔 코를 골지 않았는데 임신하고부터 코골이를 경험하는 경우가 많아요. 쌍둥이를 임신한 경우, 체중 증가 속도가 더 빠르기 때문에 기도 압박도 더 강하게 나타날 수 있어요.",
          },
          {
            subTitle: "코골이의 원인과 주의사항",
            discribed:
              "**코골이 발생 원인**\n• 늘어난 체중이 기도를 좁게 만들어 코골이 유발\n• 코점막이 충혈되어 호흡을 어렵게 만들기도 해요\n\n**특히 주의할 점은 수면 무호흡증이에요**\n수면 중 갑자기 숨이 멎거나 자주 깨는 경우, 수면 중 산소 공급이 줄어들어 엄마와 아기 모두에게 위험할 수 있어요.\n\n증상이 심할 경우엔 산부인과 또는 이비인후과와 상담 후 검사를 받아보세요. 적절한 자세 교정, 수면 환경 개선 등으로 도움을 받을 수 있어요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "몸이 보내는 신호에 귀 기울이는 시기. 변화는 불편할 수 있지만, 그건 두 아이를 품고 있다는 가장 확실한 증거예요.",
          },
        ],
      },
      dad: {
        head: {
          title: "빠르게 변화하는 아내의 몸, 남편의 서포트가 중요해요!",
          discribed: "지금 가장 필요한 건 남편의 따뜻한 서포트예요.",
        },
        body: [
          {
            subTitle: "최고의 태교는 아내의 행복!",
            discribed:
              "두 아기의 태동은 점점 뚜렷해지고, 아내의 배는 하루가 다르게 불러오고 있어요. 쌍둥이를 품고 있는 엄마의 몸은 단태아보다 훨씬 더 빠르게 변화하고 피로해질 수 있어요.\n\n지금 태아의 간뇌가 활발히 발달하면서 엄마의 감정에 더 민감하게 반응하는 시기예요. 따라서 이 시기의 가장 좋은 태교는 아내를 안정적이고 행복하게 해주는 것이랍니다.",
          },
          {
            subTitle: "반쯤 온 여정, 아내와 함께 걸어주세요",
            discribed:
              "어느덧 40주 중 절반에 가까워진 시점, 몸의 무게도, 감정의 무게도 점점 더 커지고 있어요.",
          },
          {
            subTitle: "지금 아빠가 할 수 있는 것들",
            discribed:
              '**아내를 위한 작은 배려들**\n• 아내의 불편함에 귀 기울이기\n• 짧은 산책, 간단한 스트레칭 함께하기\n• 힘든 하루 끝에는 "고마워, 잘하고 있어" 한마디 잊지 않기',
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 아이를 품고 하루하루 달라지는 몸을 견디고 있는 아내, 그리고 조용히 움직이며 생명을 준비하는 아기들. 그 모두를 응원하는 아빠의 따뜻한 말 한마디가, 지금 가장 큰 힘이 돼요.",
          },
        ],
      },
    },
    {
      week: 20,
      baby: {
        head: {
          title: "감각기관 발달의 절정기에요!",
          discribed: "각각 당근만 한 크기",
          size: "약 24cm, 300g",
        },
        body: [
          {
            subTitle: "모든 감각기관이 활발하게 발달해요!",
            discribed:
              "20주차는 두 아기의 감각기관 발달이 최고조에 이르는 시기예요. 이제 거의 모든 신경세포의 기본 구조가 완성되고, 앞으로는 그 세포들이 점점 더 크고 복잡하게 자라나게 돼요.\n\n시각, 청각, 미각, 촉각, 후각 등 사람이 갖추어야 할 오감의 신경계가 본격 작동을 시작해요.\n\n이 시기부터는 음악을 들려주거나 이야기를 들려주는 자극이 더 풍부한 감각 발달에 도움이 될 수 있어요!",
          },
          {
            subTitle: "성별을 확실히 알 수 있어요!",
            discribed:
              "15주차에 초음파로 성별을 확인하지 못했더라도 이제는 정밀 초음파를 통해 비교적 확실히 확인할 수 있어요.\n\n**쌍둥이의 경우**\n• 한쪽은 잘 보이고, 다른 한쪽은 여전히 확인이 어려운 경우도 있어요\n• 그러나 대부분은 이번 시기쯤 성별이 판별된답니다\n\n다만 초음파 결과에 따라 100% 단정짓기보다는 담당 의료진의 설명을 함께 듣는 것이 중요해요.",
          },
          {
            subTitle: "활짝 열린 두 아이의 감각",
            discribed:
              "두 아이의 뇌와 감각이 활짝 열리고 있어요. 엄마와 아빠의 따뜻한 말 한마디, 지금 그 모든 것을 기억하고 반응하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "쉽게 붓고 뻐근해지는 하반신!",
          discribed: "자궁이 커지면서 혈액순환에 어려움이 생겨요.",
        },
        body: [
          {
            subTitle: "이제 절반이 지나갔어요!",
            discribed:
              '40주간의 여정 중 이제 반환점을 막 돌았어요. 두 아이와 함께 여기까지 잘 걸어온 엄마, 정말 수고 많았어요.\n\n조금 숨이 찰 수도 있지만, 이제부터는 축복과 기대의 시간이에요. "잘 버텨왔고, 앞으로도 잘 해낼 거야." - 스스로를 꼭 안아주는 말 한마디, 잊지 마세요.',
          },
          {
            subTitle: "다리 부종과 하지정맥류에 주의하세요",
            discribed:
              "쌍둥이를 품고 있는 자궁은 단태아보다 훨씬 빨리 커지며 복부 깊숙한 곳의 하대정맥을 눌러 다리와 발이 쉽게 붓거나 저릴 수 있어요.\n\n또한 호르몬 변화로 인해 정맥 벽이 약해지고 압력이 높아지면서 하지정맥류(혈관이 튀어나오는 증상)가 생기기 쉬워요.",
          },
          {
            subTitle: "부종 완화를 위한 팁",
            discribed:
              "**증상 완화를 위한 팁**\n• 오랫동안 같은 자세로 앉아 있지 않기\n• 1시간에 한 번씩 가볍게 걷기\n• 다리를 심장보다 높게 올려 쉬기\n• 압박스타킹 착용도 추천돼요",
          },
          {
            subTitle: "배꼽이 튀어나올 수 있어요",
            discribed:
              "자궁이 위로 커지면서 복부 압력이 증가해 배꼽이 바깥쪽으로 튀어나올 수 있어요.\n\n놀라지 마세요! 이는 매우 자연스러운 현상이며 출산 후 시간이 지나면 대부분 다시 들어가요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "조금 불편하더라도 내 몸이 두 생명을 품기 위해 변화하고 있다는 것, 그 자체로 대단한 일이에요. 엄마, 지금도 충분히 잘하고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "우리 아기는 어떻게 생겼을까요?",
          discribed: "아기의 얼굴을 확인해요!",
        },
        body: [
          {
            subTitle: "정밀 초음파로 아기의 얼굴을 볼 수 있어요!",
            discribed:
              "드디어 정밀 초음파 또는 3D 초음파를 통해 두 아기의 얼굴과 몸을 보다 선명하게 볼 수 있는 시기예요.\n\n눈, 코, 입, 윤곽이 드러나며 구순구개열(입술 갈림), 손가락·발가락 구조 등도 확인할 수 있어요.",
          },
          {
            subTitle: "쌍둥이 초음파의 특징",
            discribed:
              "**쌍둥이의 경우**\n한 아기의 얼굴이 조금 가려져 있을 수도 있지만, 움직임에 따라 두 아이 모두의 모습을 차례차례 관찰할 수 있어요.\n\n이번 초음파는 단순한 진단을 넘어서 '우리 아이들이 어떤 모습일지' 실감하게 되는 순간이에요.",
          },
          {
            subTitle: "감동의 순간을 기록해보세요",
            discribed:
              "초음파 사진을 보며 '이마는 아빠 닮았나?', '코는 엄마 쪽인가?' 웃으며 이야기 나눠보세요.\n\n감동적인 이 순간, 사진이나 영상으로 꼭 기록해 두는 것도 추천드려요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 생명의 모습을 처음 눈으로 확인하는 순간, 그 감동은 말로 표현할 수 없을 만큼 커요. 이제, 진짜 부모가 되었다는 실감이 시작될지도 몰라요.",
          },
        ],
      },
    },
    {
      week: 21,
      baby: {
        head: {
          title: "골격은 거의 자리잡았지만, 피부는 아직 쪼글쪼글해요!",
          discribed: "각각 멜론만 한 크기",
          size: "약 25cm, 380g",
        },
        body: [
          {
            subTitle: "맛을 느낄 수 있어요!",
            discribed:
              "두 아기 모두 입 안에 미각 봉우리가 생겨나면서 양수의 맛을 느낄 수 있게 되었어요. 양수는 엄마가 섭취한 음식의 맛을 따라 조금씩 바뀌기 때문에, 아기들은 이미 다양한 '미각 경험'을 하고 있는 중이에요.\n\n또한 이제는 소화기관도 많이 발달되어, 양수를 삼키며 그 속의 물과 당분을 흡수하는 능력도 생겼어요. 지금 이 시기의 양수 삼키기 훈련은 태어난 후 '먹고 소화하는 능력'을 기르는 데 중요한 과정이에요.",
          },
          {
            subTitle: "피부는 아직 반투명하고 주름져 있어요",
            discribed:
              "쌍둥이 모두 골격과 신체 구조는 이제 거의 사람의 모습과 흡사하지만, 피하지방이 적어서 아직은 피부가 얇고 붉고 주름져 있어요.\n\n피부는 반투명하고 혈관이 비쳐 보이기도 하고 피하지방이 서서히 형성되며 점차 탄력을 갖추게 돼요. 이 시기의 피부는 아직 매우 연약하기 때문에 양수와 태지가 피부를 보호해주는 중요한 역할을 한답니다.",
          },
          {
            subTitle: "",
            discribed:
              '"두 아기의 몸은 하루하루 섬세하게 완성되어가고 있어요.\n\n맛을 보고, 삼키고, 자라나는 그 모든 순간이 생명으로 이어지는 놀라운 여정이에요."',
          },
        ],
      },
      mom: {
        head: {
          title:
            "빠르게 늘어나는 체중, 부풀어오르는 배!\n갑작스럽게 커진 몸 때문에 몸을 가누기 힘들 수 있어요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "숨 쉬기 힘들고 자주 피곤해요",
            discribed:
              "쌍둥이를 품고 있는 자궁은 단태아보다 훨씬 빠르게 커지면서 폐를 위쪽에서 압박하게 돼요. 조금만 움직여도 숨이 차고 복식호흡이 어렵게 느껴질 수 있어요.\n\n또한 임신 중에는 갑상선 기능이 활발해지기 때문에 평소보다 땀을 더 많이 흘리게 되고 쉽게 지치기도 해요. 계단 오르기, 무리한 외출, 높은 곳 오르기 등은 가급적 삼가고 충분한 휴식을 자주 가져주세요.",
          },
          {
            subTitle: "배 뭉침이 느껴질 수 있어요",
            discribed:
              "자궁이 커지면서 하루 2~3회 정도의 불규칙한 자궁 수축이 생길 수 있어요. 이걸 보통 '배가 뭉친다'라고 표현해요. 태동이 활발할 때 무리한 활동 후 피로가 누적됐을 때도 뭉침이 더 자주 나타날 수 있어요.\n\n가만히 누워 쉬거나, 복부를 부드럽게 마사지해주면 많은 경우 자연스럽게 풀리기도 해요. 하지만! 배 뭉침이 너무 자주 나타나거나 통증이 강하고 오래 지속된다면 반드시 병원을 찾아 진료를 받아보세요.",
          },
          {
            subTitle: "불안한 감정, 자연스러운 거예요",
            discribed:
              "배는 매일 더 커지고, 태동도 강하게 느껴지고… 그러다 보면 누구나 걱정과 불안을 느끼게 돼요.\n\n이럴 때는 감정을 억누르지 말고 자연스럽게 받아들이고, 공유하는 것이 중요해요. 같은 경험을 해본 선배맘에게 털어놓거나 일기나 기록을 통해 정리해보거나 무엇보다 남편과 진솔하게 이야기 나눠보세요. 지금 불안한 건 엄마만이 아니에요. 아빠도 같은 시기를 함께 걷고 있으니까요.",
          },
          {
            subTitle: "",
            discribed:
              "불안도 두려움도 성장의 일부예요.\n\n지금의 이 모든 감정은 두 생명을 품고 있기 때문에 가능한 기적 같은 흔들림이에요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "남편의 따뜻한 말 한마디가\n아내에게는 큰 위로와 에너지가 돼요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "신체적인 변화로 혼란스러워하는 아내를 위해...",
            discribed:
              "지금 가장 필요한 건 남편의 안정감이에요.\n\n임신 21주, 두 아기를 품고 있는 아내의 몸은 하루가 다르게 빠르게 변하고 있어요. 예전엔 혼자 거뜬히 하던 일도 이제는 도움 없이는 힘들어졌고 몸이 낯설고, 예민해지고, 때로는 내 몸 같지 않다는 느낌에 혼란스럽기도 해요.\n\n이런 감정은 지극히 자연스러운 거예요. 하지만 아내 스스로 감정을 정리하고 회복하기란 쉽지 않아요. 이럴 때 꼭 필요한 건 남편의 따뜻한 지지와 공감이에요.",
          },
          {
            subTitle: "아내에게 따뜻한 말을 아끼지 마세요",
            discribed:
              '"너무 고생하고 있어. 고마워."\n"지금도 충분히 아름다워."\n"혼자 아니야. 내가 곁에 있어."\n\n이런 말 한마디는 아내의 혼란스러운 마음을 눈에 보이지 않게 단단히 지탱해줘요. 특히 쌍둥이 임신은 신체적 피로뿐 아니라 감정적 피로도 더 크기 때문에, 남편의 따뜻한 말과 손길이 무엇보다 큰 힘이 됩니다.',
          },
          {
            subTitle: "",
            discribed:
              '"지금 아내가 듣고 싶은 말은 정답이 아니라 "내가 너의 곁에 있다는 사실"이에요.\n\n그 말이 아내에게 가장 큰 응원이 돼요."',
          },
        ],
      },
    },
    {
      week: 22,
      baby: {
        head: {
          title: "이제는 아기도 밝고\n어두운 것을 구별할 수 있어요!",
          discribed: "각각 양배추만 한 크기",
          size: "약 27~28cm, 500g",
        },
        body: [
          {
            subTitle: "밤과 낮을 구분할 수 있어요!",
            discribed:
              "쌍둥이 모두의 시각 감각이 한층 발달했어요.\n이제 자궁 너머의 빛을 느끼고, 조용하고 어두운 밤과, 활동적인 낮을 구별할 수 있을 만큼 예민한 감각을 갖추었답니다.\n엄마가 규칙적인 생활을 하면 두 아기 또한 점차 일정한 생활 리듬을 갖게 돼요.",
          },
          {
            subTitle: "눈썹과 눈꺼풀, 손톱도 거의 완성됐어요",
            discribed:
              "눈꺼풀이 거의 닫힌 상태로 자리 잡았고 눈썹이 나고, 손톱은 손가락 끝을 덮을 정도로 자라났어요.\n곧 눈을 뜨고 감는 움직임도 가능해질 거예요!\n이 모든 변화는 곧 엄마와 아빠를 보고 인식할 준비가 되고 있다는 뜻이기도 해요.",
          },
          {
            subTitle: "골격과 관절이 또렷해졌어요",
            discribed:
              "이제 두 아기의 뼈 구조와 관절이 뚜렷하게 발달하면서 초음파나 X-ray 상에서도 두개골, 갈비뼈, 팔다리뼈를 분명하게 볼 수 있어요.\n아기들은 손가락을 빠는 연습을 하거나 얼굴을 쓰다듬고, 발을 만지며 스스로를 만지는 움직임도 활발히 보여요.",
          },
          {
            subTitle: "",
            discribed:
              "\"두 아기 모두 밤낮의 빛을 느끼고, 손가락과 관절을 움직이며 세상과의 첫 교감을 시작하고 있어요.\n아직은 엄마 뱃속이지만, 그 안에서 자꾸만 '사람다워지는' 중이에요.\"",
          },
        ],
      },
      mom: {
        head: {
          title: "몸이 점점 둔해지는 느낌!",
          discribed: "배가 불러오면서 몸은 둔해지고, 동작이 서툴러져요!",
        },
        body: [
          {
            subTitle: "몸을 가누기가 힘들어져요!",
            discribed:
              "쌍둥이를 품은 배는 단태아보다 더 빠르게, 더 많이 불러오며 몸의 무게중심이 앞으로 쏠리게 돼요.\n\n무의식중에 몸을 뒤로 젖히는 자세를 취하면서 허리에 부담이 가고 요통이 심해질 수 있어요.\n\n발이 잘 안 보이고 균형감각도 흐려지기 때문에 넘어질 위험이 커지는 시기예요.\n\n지금은 특히 조심이 필요한 시기예요: 편안하고 미끄럽지 않은 신발 신기, 계단, 어두운 장소, 젖은 바닥 피하기\n\n혹시 넘어진 경우에도 배로 충격이 크지 않았다면 대부분은 괜찮아요. 하지만 배뭉침이 지속되거나 출혈, 통증이 느껴지면 꼭 병원에 방문하세요.",
          },
          {
            subTitle: "자궁경관무력증이란?",
            discribed:
              "자궁경관무력증은 자궁경부의 구조나 기능에 약함이 있어 진통 없이 자궁문이 열리는 증상을 말해요.\n\n쌍둥이 임신은 자궁의 압력이 크기 때문에 이 증상이 나타날 가능성이 더 높아질 수 있어요.\n\n보통 임신 20~25주 전후에 나타날 수 있고, 다음과 같은 증상이 동반될 수 있어요: 배가 자주 뭉치고, 갑작스럽게 냉이 많아지거나 출혈이 생기고, 양막이 아래로 불룩 튀어나오는 느낌\n\n이런 증상이 있다면 절대 참지 말고, 즉시 병원에 내원해서 진료를 받아야 해요.",
          },
          {
            subTitle: "",
            discribed:
              '"조심한다고 해서 불안해지기만 할 필요는 없어요.\n내 몸을 더 잘 이해하고, 변화에 귀 기울이면 무리 없이 두 아이와의 여정을 이어갈 수 있어요."',
          },
        ],
      },
      dad: {
        head: {
          title:
            "변화하는 엄마와 함께,\n이제는 아빠도 한 걸음씩 변화를 시작할 때예요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "변화는 태아 건강의 증거!",
            discribed:
              "엄마의 변화는 아기의 건강한 성장 신호예요. 임신이 진행되면서 아내의 몸은 눈에 띄게 달라지고 있어요.\n\n배는 불러오고, 자세가 달라지고, 익숙했던 일상이 조금씩 변해가고 있죠. 하지만 그 변화는 모두 두 아기가 건강하게 자라고 있다는 증거예요.\n\n몸이 변하지 않는다면 새로운 생명이 자랄 수 없어요.",
          },
          {
            subTitle: "이제는 아빠도 함께 변해야 해요",
            discribed:
              '아내만 달라질 수는 없죠. 아빠도 변화해야 해요.\n좀 더 배려하고 좀 더 주의 깊게 듣고 좀 더 빠르게 행동하고\n\n"지금 내가 할 수 있는 건 뭘까?"\n질문을 던지고, 답을 찾아보는 그 자세만으로도\n이미 좋은 아빠의 시작이에요.',
          },
          {
            subTitle: "곧 만나게 될 두 아이와의 삶을 상상해보세요",
            discribed:
              "아내와 함께 아이의 이름을 불러보고 태어난 후의 하루를 그려보며 대화를 나눠보세요.\n\n이런 상상과 말들이 아내에게도, 아빠 자신에게도 부모가 되어가고 있다는 믿음과 설렘을 심어줄 거예요.",
          },
          {
            subTitle: "",
            discribed:
              '"엄마의 변화에 맞춰\n든든한 내편이 되어주는 아빠의 변화,\n지금이 바로 그 시작입니다."',
          },
        ],
      },
    },
    {
      week: 23,
      baby: {
        head: {
          title: "이제 두 아기의 모습이\n신생아와 거의 흡사해졌어요!",
          discribed: "각각 가지 한 개만 한 크기",
          size: "약 29~30cm, 530g",
        },
        body: [
          {
            subTitle: "심장 박동이 또렷해졌어요",
            discribed:
              "이제 두 아기 모두 심장 박동이 강하고 또렷하게 들리는 시기예요. 산부인과에서는 청진기로도 두 아기의 심장 소리를 개별적으로 들을 수 있을 만큼 힘찬 소리를 내요.\n\n또한 청각이 많이 발달해 자궁 밖 소리도 잘 듣게 되는 시기라 너무 큰 소음이나 자극적인 음악은 아기들에게 스트레스가 될 수 있어요.\n\n부드럽고 일정한 목소리로 말을 걸어주세요. 두 아기에게 안정감을 주는 좋은 자극이 됩니다.",
          },
          {
            subTitle: "신체 균형과 얼굴 표정이 뚜렷해졌어요",
            discribed:
              "이제 쌍둥이 모두의 몸과 얼굴에 균형이 생기기 시작했어요. 아직 지방질은 부족해 피부는 주름져 있지만, 입술선, 눈꺼풀, 눈썹, 치아 싹까지 점점 또렷해지고 있어요.\n\n신경계가 발달하면서 단순한 움직임이 아닌 표정 짓기, 자극에 대한 반응이 가능해져요.\n\n엄지손가락을 빠는 아기, 웃는 듯한 표정을 짓는 아기, 몸을 살짝 비트는 아기… 초음파에서 보이는 장면 하나하나가 더욱 생생해질 수 있어요!",
          },
          {
            subTitle: "교감하는 존재로 변해가는 두 생명",
            discribed:
              "이제 두 아기는 단순히 '성장 중인 생명'이 아닌 사람답게 반응하고 교감하는 존재로 변해가고 있어요. 엄마의 감정과 아빠의 목소리에 귀 기울이며 조용히 세상을 준비하는 중이에요.",
          },
        ],
      },
      mom: {
        head: {
          title: "임신 후 찾아온 치질과 가려움증!",
          discribed: "임신 전에는 없었던 증상들이 나타날 수 있어요.",
        },
        body: [
          {
            subTitle: "치질이 생길 수 있어요!",
            discribed:
              "쌍둥이를 품고 있다면 자궁의 크기가 더 빨리 커지고 대장 운동이 더욱 느려져 변비와 치질 위험이 높아질 수 있어요.\n\n황체호르몬이 증가하면서 장의 운동력이 줄고 배변 시 힘을 많이 주게 되면 항문 부위 혈관이 압박되면서 치질 증상(통증, 출혈, 부기 등)이 나타나기 쉬워요.",
          },
          {
            subTitle: "치질 관리법",
            discribed:
              "**이렇게 관리해보세요**\n• 식이섬유가 풍부한 음식 섭취하기 (채소, 통곡물, 과일 등)\n• 하루 2리터 이상의 수분 섭취\n• 가벼운 걷기 운동으로 장운동 도와주기\n\n**증상이 생겼다면**\n따뜻한 좌욕(5-10분)을 하루 1-2회 해보세요. 혈액순환을 도와 증상이 완화될 수 있어요.",
          },
          {
            subTitle: "임신 소양증(임신 중 가려움증)이 생길 수 있어요",
            discribed:
              "임신 중기에는 호르몬 변화나 땀 분비 증가로 인해 피부에 가려움증(임신 소양증)이 생기기 쉬워요.\n\n복부, 허벅지, 팔 안쪽, 가슴 등에 건조함과 가려움이 나타날 수 있어요. 피지 분비 감소와 피부 민감도가 원인 중 하나로 알려져 있어요.",
          },
          {
            subTitle: "가려움증 관리법",
            discribed:
              "**이렇게 관리해보세요**\n• 물로만 샤워하거나, 자극 없는 저자극 비누 사용하기\n• 샤워 후에는 보습제를 꼭 바르기\n• 순면 소재의 옷 입기\n• 수시로 물 마시기로 피부 수분 유지\n\n증상이 심해서 잠을 설칠 정도거나 피부가 벗겨질 정도의 긁힘이 있다면 피부과나 산부인과에서 진료를 받아보세요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "불편한 증상이 생기면 '참아야 한다'보다 '관리하고 도움받아야 한다'고 생각해 주세요. 엄마의 건강이 곧 두 아기의 환경이니까요.",
          },
        ],
      },
      dad: {
        head: {
          title: "태교여행을 계획해보세요!",
          discribed: "둘만의 특별한 시간을 만들어 보아요.",
        },
        body: [
          {
            subTitle: "둘만의 낭만, 지금이 기회예요",
            discribed:
              "쌍둥이 임신은 단태아보다 몸이 더 빠르게 무거워지고, 출산 후에는 산후 회복과 육아로 온전히 둘만의 시간을 갖기 어려워져요.\n\n지금은 비교적 컨디션이 좋은 임신 중기, 두 사람만의 작은 일탈을 즐기기 가장 좋은 시기예요.",
          },
          {
            subTitle: "꼭 여행이 아니어도 괜찮아요",
            discribed:
              "**작고 조용한 시간들**\n• 가까운 곳으로 당일치기 드라이브\n• 좋아하는 음식 먹으며 조용한 식사\n• 감동적인 영화 한 편 함께 보기\n• 태명 부르며 아기와 함께하는 대화 시간\n\n이처럼 작고 조용한 시간도 아내에게는 큰 안정과 기쁨이 될 수 있어요.",
          },
          {
            subTitle: "태교여행 시 주의사항",
            discribed:
              "**안전한 여행을 위해**\n• 병원과 너무 멀지 않은 거리\n• 장시간 걷거나 무리하는 일정은 피하기\n• 차 안에서는 정기적으로 스트레칭하고 휴식 취하기\n• 숙소는 엘리베이터·욕조·난방 상태 등 편안함 위주로 체크하기",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "곧 다가올 부모로서의 첫 시작을 앞두고 지금 이 순간, 둘만의 시간을 가슴에 새겨두세요. 그 기억은 아내에게도, 아빠 자신에게도 오래도록 따뜻한 힘이 되어줄 거예요.",
          },
        ],
      },
    },
    {
      week: 24,
      baby: {
        head: {
          title:
            "일찍 태어나더라도 생존을 기대할 수 있는 최소한의 주수에 도달했어요!",
          discribed: "각각 농구공만 한 크기",
          size: "약 31cm, 600g",
        },
        body: [
          {
            subTitle: "폐 속 혈관이 발달하고 있어요",
            discribed:
              "이번 주부터는 폐 속 혈관이 급속도로 자라나며, 태어난 직후 첫 호흡을 가능하게 해줄 '계면활성물질'(서팩턴트)이 조금씩 분비되기 시작해요.\n\n이 시기는 쌍둥이에게도 의미 있는 전환점이에요: 만약 조산을 하더라도 자발적 호흡이 가능한 최소한의 주수로 평가되기 때문에 의학적 생존 가능성이 생기는 시기랍니다.",
          },
          {
            subTitle: "호흡과 먹이 반사를 연습해요",
            discribed:
              "아기들은 입을 벌려 양수를 마시고 뱉으며 작은 숨쉬기 연습을 하기도 해요. 탯줄이나 손가락이 얼굴 근처에 닿으면 자연스럽게 얼굴을 돌리며 먹이 반사를 연습한답니다.",
          },
          {
            subTitle: "외부 소리에 훨씬 민감해졌어요!",
            discribed:
              "쌍둥이 모두 청각이 매우 예민해지는 시기예요. 이제는 단순히 소리를 '듣는' 것뿐 아니라, 익숙한 소리와 낯선 소리를 구분하기도 해요.\n\n엄마의 심장소리, 장 소리, 목소리는 익숙하고 편안한 자극, 갑작스럽고 큰 소음은 놀람 반응을 보이기도 해요.\n\n이 시기부터는 규칙적인 목소리 자극, 음악, 책 읽어주기 등 정서적 태교도 훨씬 더 효과적으로 전달된답니다.",
          },
          {
            subTitle: "생존력과 감각이 깨어나는 두 생명",
            discribed:
              "이제 두 아이는 생존력과 감각이 동시에 깨어나는 시기에 있어요. 작고 조용한 몸짓 속에서, 스스로 세상과 연결되려는 준비가 차근차근 시작되고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "어느덧 임신한 지 만 6개월!",
          discribed: "자궁이 배꼽까지 올라오고, 배와 가슴이 많이 커졌어요!",
        },
        body: [
          {
            subTitle: "임신성 당뇨 검사를 꼭 받아야 해요",
            discribed:
              "임신 24~28주 사이에는 임신성 당뇨 여부를 확인하는 포도당 검사를 받게 돼요. 쌍둥이를 임신한 경우는 호르몬 변화가 더 크고 태반도 2배라 고혈당 위험이 더 높아질 수 있어요.\n\n임신성 당뇨는 출산 후 사라지기도 하지만 임신 중에는 산모와 태아 모두에게 위험할 수 있어요. 특히 쌍태아의 경우 거대아, 조산, 양수과다증 위험이 더 커지기 때문에 꼭 검사를 받고, 식단 관리와 체중 조절에 신경 써주세요.",
          },
          {
            subTitle: "다리에 쥐가 나고 저려요",
            discribed:
              "자궁이 커지며 하체 정맥을 눌러 혈액순환이 원활하지 않게 되고, 무거워진 체중이 다리 근육을 압박하면서 쥐가 나거나 저린 증상이 더 자주 나타나요.\n\n특히 밤에 잠을 자다가 갑작스러운 다리 통증으로 깨는 경우도 많아요. 가벼운 스트레칭, 따뜻한 물로 마사지, 잘 때 다리 밑에 쿠션을 괴는 습관이 도움돼요.",
          },
          {
            subTitle: "잇몸에서 피가 나요?",
            discribed:
              "쌍태아 임신은 호르몬 변화가 더 극심하기 때문에 잇몸이 붓고 양치할 때 피가 나기 쉽고, 잇몸 염증(임신성 치은염) 발생 위험도 높아져요.\n\n치은염은 방치 시 혈류를 통해 태아에게도 영향을 줄 수 있기 때문에 중기에 치과 검진을 꼭 받아보는 것이 좋아요. 부드러운 칫솔로 꼼꼼히 양치하고, 필요시 잇몸 전용 가글이나 치실을 병행해요.",
          },
          {
            subTitle: "조산 주의! 지금부터는 더 민감하게 살펴야 해요",
            discribed:
              "이제부터는 '유산'이 아니라 '조산'의 가능성에 대비해야 할 시기예요. 쌍둥이 임신은 단태아보다 조산 확률이 높기 때문에, 배뭉침, 출혈, 양수샘 징후 등에 더욱 민감하게 관찰해야 해요.",
          },
          {
            subTitle: "즉시 병원에 연락해야 할 증상들",
            discribed:
              "**다음과 같은 증상이 보이면 즉시 병원에 연락하세요:**\n• 배뭉침이 자주 오고 규칙적일 때\n• 질 분비물 증가와 함께 묽거나 피가 섞인 분비물이 나올 때\n• 허리가 뻐근하고 하복부가 묵직하게 당길 때",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "지금 엄마는 두 아이를 품은 만큼 조금 더 신중하게, 조금 더 부드럽게 하루를 보내야 할 시간이랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "한발 빠르게, 말없이 내미는 손길이 아내에게는 가장 큰 힘이 돼요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "아내는 작지만 결정적인 도움이 필요해요",
            discribed:
              "쌍둥이를 품은 아내의 몸은 예상보다 훨씬 더 빠르게 무거워지고, 몸의 균형을 잡기도 어려워져요.\n\n장바구니 들기, 신발끈 묶기, 바닥에 떨어진 물건 줍기 - 이런 작은 일들이 아내에게는 '도움을 요청해야 하나'라는 고민으로 다가올 수 있어요.\n\n요청하지 않아도 먼저 알아채고 손 내밀어주는 것, 그게 바로 지금 아내에게 필요한 '배려'예요.",
          },
          {
            subTitle: "놓아야 할 것들과 다가올 삶을 준비해요",
            discribed:
              "아이가 태어나면 지금까지 당연히 누려왔던 많은 것들을 조금은 놓아야 할 수도 있어요.\n\n주말 늦잠, 즉흥적인 취미 생활, 홀가분한 외출, 평소 즐기던 커피 한 잔까지도... 지금부터는 몸뿐 아니라 마음의 준비도 함께 해야 할 시기예요.\n\n그러나 이 모든 변화는 비교할 수 없는 새로운 행복의 시작이기도 해요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "도움은 요청받기 전에 내미는 손끝에서 시작되고, 부모가 되는 마음은, 조금씩 내려놓는 연습에서 자라나요. 조금 더 다정한 남편, 조금 더 준비된 아빠로 한 걸음 더 가까이 가보세요.",
          },
        ],
      },
    },
    {
      week: 25,
      baby: {
        head: {
          title: "바깥의 소리에 귀를 기울이며 엄마 아빠와 교감하고 있어요!",
          discribed: "각각 2L 생수병만 한 크기",
          size: "약 34cm, 700g",
        },
        body: [
          {
            subTitle: "폐가 활발하게 성장 중이에요!",
            discribed:
              "쌍둥이 모두 이제 호흡을 위한 마무리 준비를 열심히 하고 있어요. 폐포가 형성되고 폐 안에서는 계면활성물질(서팩턴트)이 꾸준히 분비되고 있어요.\n\n이제는 콧구멍도 열려 코를 이용한 호흡운동 연습도 가능해졌어요. 이 모든 과정은 태어난 직후 첫 울음과 첫 호흡을 위해 꼭 필요한 준비랍니다.",
          },
          {
            subTitle: "엄마 아빠의 목소리에 가장 큰 반응을 보여요",
            discribed:
              "이제 두 아기는 주변의 다양한 소리 중에서도 엄마의 말소리, 아빠의 낮은 목소리에 가장 뚜렷하게 반응해요. 심장 박동이 빨라지거나 몸을 살짝 움직이며 의미 있는 교감을 시작한 거예요.\n\n지금처럼 꾸준히 태명을 부르고, 말을 걸고, 음악을 들려주면 아기들에게 안정감과 친밀감을 줄 수 있어요.",
          },
          {
            subTitle: "두 아이의 청각 발달",
            discribed:
              "쌍둥이 모두가 '준비된 귀'로 세상을 향해 귀를 기울이고 있어요. 엄마와 아빠의 따뜻한 목소리는 두 아이의 감정과 두뇌에 가장 깊이 남는 자극이 된답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "배가 훨씬 무거워졌어요!",
          discribed: "자궁도, 양수도, 체중도 쑥쑥 늘어나는 시기예요.",
        },
        body: [
          {
            subTitle: "숨차고 답답하고… 몸의 불편이 커지고 있어요",
            discribed:
              "쌍둥이의 성장 속도는 단태아보다 빠르기 때문에 자궁의 크기도 더 커지고, 그에 따라 위와 폐가 압박되며 호흡곤란이나 소화불량이 나타날 수 있어요.\n\n조금만 먹어도 더부룩하고, 잠을 자기 힘들 만큼 배가 팽창돼 있을 수 있어요.",
          },
          {
            subTitle: "식사 관리 팁",
            discribed:
              "• 식사는 조금씩 자주 나누어 섭취하고, 자극적인 음식은 가급적 피하도록 해요\n• 식사 후에는 바로 눕지 말고 가볍게 앉아 쉬는 것이 좋아요",
          },
          {
            subTitle: "임부복, 지금이 준비할 타이밍이에요",
            discribed:
              "점점 커지는 배와 가슴은 일반 옷으로 감당하기 어려워지는 시점이에요. 혈액순환을 방해하지 않도록 신축성 있고 통기성 좋은 임부복을 착용하세요.\n\n브래지어는 앞후크형 수유브라로 미리 준비하면 출산 후에도 유용하게 쓸 수 있어요.",
          },
          {
            subTitle: "눈이 뻑뻑하고 예민해졌나요?",
            discribed:
              "호르몬 변화로 안구건조증이 심해질 수 있어요. 눈이 건조하거나 빛에 민감, 모래가 들어간 듯한 느낌이 들기도 해요.\n\n인공눈물이나 식염수를 사용할 수 있고 간식으로는 비타민 A가 풍부한 당근을 챙겨보세요! 당근은 태아 눈 건강과 세포 성장에도 좋아요.",
          },
          {
            subTitle: "임신선이 생겼어요!",
            discribed:
              "쌍태아 임신은 복부 확장이 더 빠르기 때문에 배, 엉덩이, 가슴 등에 붉거나 갈색의 임신선이 더 잘 생길 수 있어요.\n\n임신선은 출산 후 시간이 지나면 점차 연해지거나 거의 사라지니 너무 걱정하지 마세요. 샤워 후 보습 크림이나 오일을 꾸준히 발라주면 가려움증 완화와 피부 탄력 유지에 도움이 돼요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "불편해진 몸이 말해주는 건, 지금 두 아이가 건강하게 자라고 있다는 신호예요. 하루하루 변화하는 내 몸에, 따뜻한 수고 인사를 건네보세요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "두 아이 모두, 지금 엄마 아빠의 목소리에 귀를 쫑긋 세우고 있어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "태아에게 꾸준히 태담을 들려주세요",
            discribed:
              "쌍둥이 모두에게 엄마 아빠의 목소리는 세상에서 가장 따뜻한 자극이에요. 지금부터 매일 꾸준히 태담(태아와의 대화)을 나눠보세요.\n\n오늘 날씨 이야기, 아빠가 좋아하는 계절, 태어난 뒤 함께 하고 싶은 일들 - 이런 사소한 이야기들도 아기들에게는 정서적 안정과 인지 자극이 돼요.\n\n특히 아빠의 굵고 낮은 목소리는 엄마의 배를 통해 가장 잘 전달되는 음색이에요.",
          },
          {
            subTitle: "아기의 이름을 고민해볼까요?",
            discribed:
              "출산까지 시간이 남았지만, 지금이 바로 태명의 의미를 진짜 이름으로 연결해볼 시기예요.\n\n각각의 아이에게 어울리는 이름은? 함께 부르기 좋은 소리와 뜻은? 아내와 함께 천천히, 즐겁게 고민해보세요.",
          },
          {
            subTitle: "이름 짓기 팁",
            discribed:
              "아직 결정하지 않아도 괜찮아요. 이름을 떠올리며 대화하는 그 자체가 아이들과 교감하는 소중한 태교가 된답니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "쌍둥이와 나누는 대화는 아빠가 아이들과 맺는 첫 관계의 시작입니다. 이제는 귀로 듣고, 감정으로 받아들이는 시기. 당신의 목소리가, 두 생명에게 가장 따뜻한 음악이 될 거예요.",
          },
        ],
      },
    },
    {
      week: 26,
      baby: {
        head: {
          title: "아기는 엄마의 감정을 공유해요!",
          discribed: "각각 둥근 베개만 한 크기",
          size: "약 35cm, 750g",
        },
        body: [
          {
            subTitle: "손과 발을 정교하게 움직일 수 있어요",
            discribed:
              "쌍둥이 모두 움직임이 더 활발해지고 있어요! 이제는 단순히 발차기만 하는 것이 아니라, 손을 오므렸다 펴고, 탯줄을 잡아당기며 놀기도 해요.\n\n서로를 터치하거나 몸을 쓰다듬는 듯한 움직임도 관찰될 수 있어요. 손가락, 발가락 움직임이 더 섬세해지고 자신의 얼굴을 만지거나 몸을 쓰다듬는 행동도 보여요.",
          },
          {
            subTitle: "태동 관찰 시간",
            discribed:
              "보통 오전 7시~10시 사이가 쌍둥이 모두 가장 활발히 움직이는 시간대예요. 이 시간대에 태동을 느끼고 기록해보면 변화도 잘 관찰할 수 있답니다.",
          },
          {
            subTitle: "두 아기 모두, 엄마의 감정을 함께 느껴요",
            discribed:
              "이제는 감정 교감 능력도 크게 발달된 시기예요. 엄마가 긴장하거나 스트레스를 받을 때, 두 아기의 심박수가 빨라지고 움직임이 예민해질 수 있어요.\n\n반대로 엄마가 편안하게 쉬거나 웃을 때, 아기들도 그 감정을 그대로 함께 느껴요.",
          },
          {
            subTitle: "정서적 태교의 중요성",
            discribed:
              "이 시기엔 정서적인 태교가 특히 중요해요:\n• 좋아하는 음악 듣기\n• 편안한 향기 맡기\n• 태담 나누기\n• 아기에게 인사 건네기",
          },
          {
            subTitle: "두 아이와의 감정 교류",
            discribed:
              "엄마의 웃음, 아빠의 다정한 말 한마디는 쌍둥이들에게는 세상에서 가장 따뜻한 안정감이랍니다. 오늘도 마음을 다해, 두 아이와 감정을 나눠보세요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "배가 더 무겁고, 움직임이 훨씬 불편해졌어요!\n몸의 균형을 잡는 것도 점점 어려워지고 있어요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "갈비뼈가 쑤시고 아랫배가 따끔거려요",
            discribed:
              "쌍둥이를 품은 자궁은 단태아보다 훨씬 빠르게 커지기 때문에 위와 폐를 위쪽에서 강하게 압박하게 돼요. 갈비뼈 아래쪽이 밖으로 벌어지며 통증이 생기기도 하고 위장이 눌려 속쓰림, 소화 불량이 잦아져요.\n\n자궁 근육이 팽창하면서 아랫배에 따끔한 통증도 종종 나타나요.",
          },
          {
            subTitle: "불편함 완화 방법",
            discribed:
              "• 가볍게 몸을 늘려주기\n• 식사량을 나눠 먹기\n• 식후엔 바로 눕지 않기",
          },
          {
            subTitle: "몸의 중심이 앞으로 쏠려요",
            discribed:
              "배가 많이 나오면서 몸의 균형이 급격히 앞으로 쏠리게 돼요. 무의식적으로 상체를 뒤로 젖히게 되는데 이 자세는 허리에 큰 부담을 줘서 요통이나 골반통을 유발할 수 있어요.\n\n자세를 자주 교정하고 가볍게 요통 완화 스트레칭, 짧은 산책도 효과적이에요. 계단이나 미끄러운 곳에선 발 아래를 꼭 확인하고 천천히!",
          },
          {
            subTitle: "악몽을 꾸거나, 불안한 꿈이 많아졌나요?",
            discribed:
              "임신 후반기로 접어들수록 많은 엄마들이 가위눌림, 추락, 쫓김 같은 꿈을 경험해요. 이는 무의식 속에서 엄마가 되는 것에 대한 불안, 출산에 대한 두려움, 몸의 급격한 변화 등이 반영된 거예요.\n\n너무 걱정하지 마세요. 이는 자연스러운 심리 반응이랍니다.",
          },
          {
            subTitle: "마음 안정 방법",
            discribed:
              "따뜻한 차 한 잔, 긍정적인 음악, 아기에게 말을 걸며 마음을 안정시켜 보세요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "엄마가 웃으면 두 아이도 함께 웃어요. 혼란과 불편 속에서도, 하루 한 번은 꼭 웃어보세요. 그 미소 하나가 아기들에게는 세상에서 가장 따뜻한 신호랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "이제 100일도 남지 않았어요!\n쌍둥이 출산, 지금부터 차근차근 준비하세요",
          discribed: "",
        },
        body: [
          {
            subTitle: "쌍둥이 출산은 더 이른 시기에 올 수 있어요",
            discribed:
              "쌍태아는 단태아보다 조산 확률이 더 높기 때문에 출산 준비를 조금 더 빨리, 더 철저히 시작하는 것이 좋아요.",
          },
          {
            subTitle: "지금부터 준비해야 할 것들",
            discribed:
              "**출산 예정 병원 위치와 가는 경로 체크**\n• 자차로 몇 분? 택시를 부르면 어디로 오게 할지?\n• 출근시간·야간 시간대의 교통 상황도 파악해보기\n\n**입원 시 챙겨야 할 산모 가방 리스트 정리**\n• 기본 준비물 외에도 쌍태아 출산에 필요한 용품 고려하기",
          },
          {
            subTitle: "가진통과 진진통, 아빠가 구별할 수 있어야 해요",
            discribed:
              "아내는 진통이 시작되면 혼란스럽고 판단이 어려울 수 있어요. 이럴 때 아빠의 차분한 관찰과 판단이 큰 힘이 돼요.",
          },
          {
            subTitle: "진통 구별법",
            discribed:
              "**가진통**: 수축이 불규칙하고 강도·빈도 변화 없음\n• 움직이면 사라지기도 해요\n\n**진진통**: 점점 강해지고 간격이 짧아짐\n• 휴식해도 멈추지 않고 규칙적으로 찾아와요\n\n진통 시간 간격을 스마트폰으로 기록해보세요. 5분 간격 이하로 규칙적인 통증이 반복된다면 바로 병원에 연락하세요!",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "엄마는 진통을 견디고, 아빠는 그 곁에서 시간과 안전을 지키는 사람입니다. 이제부터는 '아빠의 준비력'이 두 생명을 맞이할 첫 걸음을 여는 열쇠가 될 거예요.",
          },
        ],
      },
    },
    {
      week: 27,
      baby: {
        head: {
          title:
            "눈꺼풀이 완성되고,\n이제 세상을 향해 천천히 눈을 뜨기 시작했어요!",
          discribed: "각각 작은 곰인형만 한 크기",
          size: "약 37cm, 900g",
        },
        body: [
          {
            subTitle: "양수를 마시며 폐를 키워요",
            discribed:
              "쌍둥이 모두는 지금 자신만의 호흡 연습을 열심히 하고 있어요. 계속해서 양수를 마시고 내뱉으며 횡격막 운동을 반복하고 있어요. 이 과정은 태어난 직후 첫 울음과 폐 확장을 위한 준비랍니다.\n\n폐포는 지금부터 활발하게 만들어지고 있으며 태어난 뒤에도 8세까지 계속 발달해요. 폐포 주변의 미세혈관도 기하급수적으로 증가하며 자율적인 호흡을 위한 기반이 마련되고 있어요.",
          },
          {
            subTitle: "눈을 깜빡이고, 시야를 연습해요",
            discribed:
              "이제 눈꺼풀이 갈라지면서 두 아기 모두 눈을 뜰 수 있게 되었어요! 눈을 뜨고 감는 깜빡임 운동을 시작하며 태어난 뒤 세상을 바라볼 준비를 차근차근 하고 있어요.\n\n지금의 눈동자는 아직 맑고 투명해요. 출생 후 몇 개월이 지나야 자신만의 눈동자 색이 자리잡는답니다.",
          },
          {
            subTitle: "두 아기의 놀라운 발달",
            discribed:
              "두 아기는 지금 숨쉬는 연습을 하고, 세상을 바라볼 준비를 하고 있어요. 보이지 않지만, 하루하루 그들의 세계는 깊어지고 넓어지고 있답니다.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "이제 곧 임신 중기를 마무리하고,\n출산이 가까워지는 임신 후기로 접어들어요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "다리가 붓고 쥐가 나요",
            discribed:
              "쌍둥이를 품은 몸은 혈액량도, 체중도 훨씬 빠르게 늘어나요. 그만큼 하체 정맥에 부담이 커져서 부종, 저림, 쥐가 자주 생길 수 있어요.\n\n특히 밤에 잠을 잘 때 종아리가 뻣뻣하게 굳고 쥐가 나는 경우가 많아요.",
          },
          {
            subTitle: "다리 부종 완화 방법",
            discribed:
              "• 자기 전 따뜻한 물로 다리를 마사지해주기\n• 가벼운 스트레칭 하기\n• 쿠션으로 다리를 살짝 올려 자는 습관 갖기",
          },
          {
            subTitle: "임신중독증(전자간증)을 조심해야 해요",
            discribed:
              "쌍태아 임신은 고혈압성 임신합병증 발생 위험이 더 높아요. 따라서 임신중독증(전자간증)에 특히 유의해야 해요.",
          },
          {
            subTitle: "전자간증 주의 증상",
            discribed:
              "**전자간증이 의심되는 주요 증상:**\n• 심한 두통이나 시야 흐림\n• 급격한 체중 증가\n• 상복부 통증, 메스꺼움\n• 손·발·얼굴의 부기\n• 혈압 상승\n• 소변에서 단백질 검출\n\n전자간증은 산모뿐 아니라 태아 성장 지연, 조산, 사망 등 위험한 결과를 초래할 수 있어요. 현재까지의 유일한 치료법은 출산이기 때문에 조기 발견과 관리가 무엇보다 중요해요.",
          },
          {
            subTitle: "조기 발견의 중요성",
            discribed:
              "몸이 평소보다 무겁고 이상하다고 느껴진다면 주저하지 말고 병원에 연락하세요. 쌍둥이 엄마인 당신은 늘 한 발 앞서 살피는 감각이 필요해요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "지금의 무거움은 두 아이가 건강하게 자라고 있다는 증거예요. 하지만 작은 이상 신호도 놓치지 않고 살피는 지혜가 지금 엄마에게 필요한 힘이랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "몸도 마음도 힘든 아내,\n지금 가장 기대고 싶은 존재는 바로 당신이에요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "달라진 몸, 낯설고 두려운 감정",
            discribed:
              "쌍둥이를 품은 아내는 지금 단태아보다 더 빠르게, 더 크게 변화하는 몸을 경험하고 있어요. 급격히 불러온 배, 짙어지는 임신선, 가슴의 변화, 부종, 통증…\n\n이 모든 변화는 새 생명을 품은 증거지만 그 변화에 가장 당황스럽고 낯설어하는 사람은 아내 자신이에요.",
          },
          {
            subTitle: "아내에게 필요한 것",
            discribed:
              "지금 아내에게 필요한 건 외모에 대한 평가가 아니라, 있는 그대로의 존재를 사랑받고 있다는 확신이에요.\n\n'고생 많았어', '여전히 예뻐'라는 따뜻한 말 한마디가 누구보다 큰 위로가 될 수 있어요.",
          },
          {
            subTitle: "종아리 마사지, 아내를 위한 최고의 저녁 루틴",
            discribed:
              "자궁이 커지고 하체 혈류가 줄면서 아내의 다리는 매일같이 붓고, 밤마다 쥐가 나기도 해요. 이럴 땐 로션이나 오일을 발라서 종아리를 가볍게 마사지해 주세요.\n\n아내는 스스로 손이 닿기 어렵고 체력이 떨어져 피로 회복도 쉽지 않아요. 하루 10분, 따뜻한 손길로 '수고했어'라고 말하며 다리를 풀어주세요.\n\n이 짧은 시간이 아내에게는 가장 확실한 사랑 표현이 될 거예요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "지금 아내는 두 생명을 품고 하루하루 고군분투 중이에요. 힘든 몸과 마음을 말없이 안아줄 사람, 그건 바로 남편이라는 당신입니다.",
          },
        ],
      },
    },
    {
      week: 28,
      baby: {
        head: {
          title: "머리카락이 자라는 동안,\n뇌도 빠르게 성장하고 있어요!",
          discribed: "각각 무릎 길이 장화만 한 크기",
          size: "약 38cm, 1kg",
        },
        body: [
          {
            subTitle: "뇌가 커지고, 조직이 복잡하게 발달해요",
            discribed:
              "쌍둥이 모두는 이제 자궁 안 공간을 꽉 채울 만큼 빠르게 자라고 있어요. 이 시기 가장 눈에 띄는 변화는 바로 '뇌 발달'이에요!\n\n뇌의 크기가 눈에 띄게 커지고 주름과 홈, 신경회로, 신경전달 물질 등이 복잡하게 형성되며 뇌세포와 신경계가 연결되어 활동을 시작해요.",
          },
          {
            subTitle: "뇌 발달을 위한 태교",
            discribed:
              "이 시기에는 엄마 아빠의 목소리, 음악, 리듬, 따뜻한 말 한마디가 태아의 뇌에 직접적인 자극으로 작용한답니다.\n\n오늘도 인사 한마디, 음악 한 곡이 뇌를 자라게 해요.",
          },
          {
            subTitle: "두 아기 모두, '하루의 리듬'을 만들고 있어요",
            discribed:
              "28주차가 되면 태아는 스스로 규칙적인 생활 패턴을 만들어가기 시작해요. 일정한 시간에 깨어 움직이고 일정한 시간에 자며, REM 수면(꿈꾸는 수면)도 가능해져요.\n\n엄마의 일상도 규칙적으로 유지해보세요. 같은 시간에 자고 일어나고, 같은 시간에 산책하고 식사하며 아기들에게 안정된 하루 리듬을 선물해주세요.",
          },
          {
            subTitle: "두 아이의 뇌 발달",
            discribed:
              "두 아이의 머릿속은 지금, 세상을 배울 준비로 분주하게 움직이고 있어요. 가장 좋은 뇌 자극은 바로 지금 이 순간, 엄마와 아빠의 다정한 목소리랍니다.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "임신 후기로 접어들었어요!\n출산까지 두 달 남짓, 지금부터는 실질적인 준비가 필요해요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "초유가 만들어지기 시작했어요",
            discribed:
              "쌍둥이 엄마의 가슴에서는 노르스름하고 진한 '초유'가 조금씩 만들어지고 있어요. 초유는 신생아에게 꼭 필요한 면역 성분과 풍부한 영양소를 담고 있어요.\n\n빠르면 지금부터 가슴에서 초유가 흘러나올 수도 있어요. 이럴 때를 대비해 수유패드를 준비해두면 좋아요.",
          },
          {
            subTitle: "기억력이 흐릿해졌나요?",
            discribed:
              "쌍태아 임신 후반기에는 수면 부족, 호르몬 변화, 체력 저하로 종종 '임신 건망증'을 경험할 수 있어요.",
          },
          {
            subTitle: "건망증 대처 방법",
            discribed:
              "• 중요한 약속이나 병원 일정은 메모해두는 습관 갖기\n• 자책하지 말고, 가족의 도움을 받기\n• 아무렇지 않게 넘기지 말고, 무리하지 말고, 마음을 편히 가지기",
          },
          {
            subTitle: "좌골신경통이 생겼다면?",
            discribed:
              "배가 더 커지며 자궁이 좌골신경을 압박해 엉덩이, 허리, 다리까지 이어지는 통증이 생길 수 있어요. 특히 쌍둥이를 품은 경우 통증이 더 빠르고 강하게 나타날 수 있어요.",
          },
          {
            subTitle: "좌골신경통 완화 방법",
            discribed:
              "• 온찜질, 따뜻한 샤워\n• 스트레칭\n• 무게를 분산하는 골반 벨트 착용\n• 바른 자세 유지와 짧고 자주 걷기\n\n너무 심하면 반드시 진료를 받아야 해요.",
          },
          {
            subTitle: "혹시 Rh- 혈액형이신가요?",
            discribed:
              "Rh- 혈액형인 산모는 28주에 로감(RhoGAM) 주사를 맞아야 해요. 이 주사는 아기와 산모 간 혈액형 불일치로 생길 수 있는 항체 형성을 막아주는 예방주사예요.\n\n아직 주사에 대해 설명을 못 들으셨다면, 다음 검진 때 꼭 문의해보세요!",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "지금의 변화는 곧 새로운 만남이 다가오고 있다는 신호예요. 조금씩 불편하지만, 그만큼 준비된 엄마로 성장하고 있다는 증거랍니다.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "조금은 서툴고, 자꾸 깜빡해도 괜찮아요.\n아내 뒤에는 늘 당신이 있다는 걸 보여주세요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "건망증 많은 아내를 부드럽게 안아주세요",
            discribed:
              "쌍둥이를 품은 아내는 체력, 수면, 호르몬 변화로 인해 최근 들어 더 자주 깜빡깜빡 잊는 일이 많아졌을 거예요. 약속을 잊거나 냉장고에 물건을 잘못 넣거나 자꾸 '어디 뒀더라…'를 반복하기도 해요.\n\n이럴 땐 지적보다 관찰과 배려가 먼저예요.",
          },
          {
            subTitle: "아내에게 해줄 수 있는 따뜻한 말",
            discribed:
              "• '내가 같이 찾아볼게'\n• '괜찮아, 누구나 그럴 수 있어'\n\n아내는 그 말 한마디에 안심하고 다시 웃을 수 있어요.",
          },
          {
            subTitle: "만삭 촬영, 지금이 딱 좋아요!",
            discribed:
              "하루가 다르게 커지는 배, 지금 이 순간은 다시는 돌아오지 않는 특별한 시간이에요. 보통 쌍둥이 임신은 단태아보다 더 빨리 배가 커지기 때문에 28~30주 전후가 만삭 촬영의 골든타임이에요.\n\n전문 스튜디오에서 촬영하거나, 집 안에서 자연스럽게 셀프 촬영을 해도 좋아요. 아이가 태어난 뒤, '이때 엄마가 너희를 품고 있었어'라고 이야기해줄 수 있는 따뜻한 기록이 되어줄 거예요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "쌍둥이를 품고 있는 지금의 아내는 하루하루를 버텨내고 있는 진짜 슈퍼우먼이에요. 그 옆에서 말없이, 다정하게 뒷받침하는 남편 당신이 있어 아내는 더 든든하답니다.",
          },
        ],
      },
    },
    {
      week: 29,
      baby: {
        head: {
          title: "지방이 쌓이면서 피부가 점점 보들보들해져요!",
          discribed: "각각 토끼만 한 크기",
          size: "약 39cm, 1.2~1.3kg",
        },
        body: [
          {
            subTitle: "자궁 밖의 빛을 인식할 수 있어요",
            discribed:
              "두 아기 모두 눈꺼풀과 눈동자가 완성되어 자궁 안에서 빛의 밝기와 방향을 감지할 수 있어요. 엄마 배에 손전등으로 빛을 비추면 아기들이 고개를 돌리며 반응할 수 있어요.\n\n눈을 뜨고 초점을 맞추는 연습도 시작돼요. 이 시기의 시각 자극은 자궁 속에서도 신경 발달에 긍정적인 자극이 된답니다.",
          },
          {
            subTitle: "부드러운 피부, 오동통한 몸으로 변화 중!",
            discribed:
              "몸을 감싸던 배내털(솜털)은 점점 줄어들고 어깨, 등 쪽에만 조금씩 남게 돼요. 동시에 지방이 피부 아래에 축적되면서 쪼글쪼글하던 모습에서 점점 탱글탱글 오동통한 형태로 변화하고 있어요.\n\n이 지방은 체온 유지, 에너지 저장, 출생 직후 수유까지 버틸 수 있는 힘이 돼요.",
          },
          {
            subTitle: "세상을 살아갈 준비",
            discribed:
              "아기들의 몸은 지금, 세상을 살아갈 준비로 하나하나 완성되어 가고 있어요. 빛을 느끼고, 지방을 채우며, 세상에 나올 날을 조용히 기다리고 있답니다.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "출산 준비가 본격적으로 시작되고 있어요!\n엄마의 몸은 아기를 맞이할 준비를 차근차근 하고 있어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "정기 검진은 2주에 한 번, 더 자주 병원을 방문해요",
            discribed:
              "쌍둥이를 품고 있는 엄마는 단태아보다 더 세밀하고 자주 상태를 확인해야 해요. 지금부터는 2주에 한 번 산전 검진이 이뤄지고, 의료진은 태아의 성장 속도, 양수량, 조기 진통 여부 등을 집중적으로 관찰해요.\n\n쌍둥이의 경우 조산 가능성이 높기 때문에 미리미리 병원 방문 시기, 증상 체크 포인트를 정리해 두는 게 좋아요.",
          },
          {
            subTitle: "자궁 수축이 자주 느껴져요",
            discribed:
              "29주쯤 되면 자궁이 뭉치는 느낌이 더 자주 찾아와요. 하루 4~5회 정도라면 자연스러운 수축일 수 있지만, 규칙적이고 강한 수축, 동반되는 통증, 복부 압박감이 반복된다면 반드시 병원에 연락하세요.\n\n조산 예방을 위해 무리한 활동은 피하고, 배가 뭉치면 바로 쉬는 습관을 들여보세요.",
          },
          {
            subTitle: "태동이 강해지고, 갈비뼈까지 차요",
            discribed:
              "쌍둥이 모두 활발히 움직이면서 엄마의 복부 위쪽, 갈비뼈 아래에 통증을 느끼는 경우가 많아져요. 발을 위로 뻗은 자세가 유지되면 갈비뼈를 차는 느낌, 숨쉬기 불편한 느낌도 동반될 수 있어요.\n\n잠자기 전 자세를 조정하고, 가벼운 스트레칭을 해보세요.",
          },
          {
            subTitle: "분비물 증가로 외음부 가려움이 생길 수 있어요",
            discribed:
              "출산 준비로 자궁경부에서 분비물이 더 많이 배출되며 외음부 습진, 가려움, 자극감이 생길 수 있어요. 쌍태아 임신의 경우, 자궁 확장과 호르몬 변화가 더욱 크기 때문에 청결관리에 더욱 신경 써야 해요.",
          },
          {
            subTitle: "청결 관리 방법",
            discribed:
              "• 면속옷 착용\n• 하루 1~2회 샤워\n• 속옷 자주 갈아입기\n• 향이 강한 비누는 피하기",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "출산까지 10주 남짓. 엄마의 몸은 놀라운 속도로 변화하고 있어요. 하루하루 다정하게 챙기며, 나와 두 아기를 다독여주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "출산까지 두 달 남짓!\n예비아빠로서 아기를 만날 준비를 해요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "예비 아빠 교육, 지금이 딱 좋아요!",
            discribed:
              "쌍둥이 출산은 예기치 못한 상황도 많기 때문에 출산 전 미리미리 지식과 실전감을 준비해두는 게 중요해요.",
          },
          {
            subTitle: "교육 프로그램 찾아보기",
            discribed:
              "**이런 것부터 시작해볼까요?**\n• 보건소, 산부인과, 산후조리원 등에서 진행하는 출산교실, 예비아빠 교육 프로그램 찾아보기\n• 온라인/오프라인 형태, 날짜와 위치, 강의 주제 등을 정리한 후 엄마와 함께 고르기\n• 기저귀 갈기, 수유 자세, 응급 대처법까지 미리 익혀두기\n\n출산 이후 당황하지 않고 자연스럽게 적응할 수 있어요.",
          },
          {
            subTitle: "정기검진, 함께 가는 것이 큰 힘이 돼요",
            discribed:
              "쌍태아 임신 후반기에는 검진 간격이 더 촘촘해지고 조기 진통, 태반 상태, 양수량, 태동 패턴 등 더욱 정밀하게 확인해야 할 사항이 많아져요.\n\n함께 가서 아내의 긴장을 덜어주고 직접 의사와 이야기를 나누며 궁금한 점을 확인할 수 있는 좋은 기회예요. 병원 방문 전 아내가 궁금해하는 것, 아빠가 걱정되는 부분 메모해 가는 것도 추천해요!",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "곧 두 아이의 아빠가 되는 당신. 지금의 준비는, 아내에게도 아이들에게도 크나큰 신뢰와 든든함이 되어줄 거예요.",
          },
        ],
      },
    },
    {
      week: 30,
      baby: {
        head: {
          title: "아기는 태어나기위해 열심히 준비중!",
          discribed: "각각 베개만 한 크기",
          size: "약 40cm, 1.4~1.5kg",
        },
        body: [
          {
            subTitle: "머리를 아래로! 출산 자세로 서서히 이동 중이에요",
            discribed:
              "쌍둥이 모두는 머리를 아래로 향하는 '두정위 자세'를 점차 취하기 시작해요. 머리가 아래, 엉덩이가 위로 출산 시 좁은 산도를 통과하기에 가장 적합한 자세예요.\n\n아직 자세가 바뀌지 않은 아기도 있을 수 있어요. 시간이 더 필요하니 지금은 지켜보는 것만으로도 충분해요.",
          },
          {
            subTitle: "분만 방법에 대한 정보",
            discribed:
              "쌍둥이의 경우 첫째 아기가 머리를 아래로 하고 있다면 자연분만도 가능해요. 둘 다 엉덩이부터 나오는 '둔위' 자세일 경우, 제왕절개를 고려하기도 하니 주치의와 미리 상의해두면 좋아요.",
          },
          {
            subTitle: "호흡 연습, 거의 마무리 단계예요!",
            discribed:
              "폐포(폐의 숨주머니)는 대부분 발달했고 아기들은 양수를 삼키고 내뱉으며, '호흡 흉내' 연습을 매일 반복하고 있어요. 이 연습은 태어난 직후 첫 울음과 정상 호흡을 가능하게 해주는 중요한 과정이에요.\n\n뇌 신경회로도 함께 정교해지고 있어 깨어 있을 때와 잠잘 때의 구분, 빛에 대한 반응, 자기 손가락을 빠는 태동 등도 점점 정교해져요.",
          },
          {
            subTitle: "출산을 향한 준비",
            discribed:
              "두 아이는 지금 자리를 잡고, 세상으로 나올 준비를 매일매일 착실히 해나가고 있어요. 엄마와 아빠의 다정한 응원이 그들에게 큰 힘이 되고 있답니다.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "배꼽을 훌쩍 넘은 자궁, 심장과 위, 방광까지 눌리며 몸 곳곳에서 불편함이 느껴지는 시기예요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "가슴이 갑갑하고 속도 쓰려요",
            discribed:
              "쌍태아 임신은 자궁의 크기가 더 빠르고 크게 자라기 때문에 심장과 위, 횡격막까지 강하게 압박돼요.\n\n**주요 증상들:**\n• 숨이 찬 느낌\n• 위산 역류나 속쓰림\n• 답답한 가슴이나 심호흡 곤란\n• 밤중에 자주 일어나는 빈뇨 증상",
          },
          {
            subTitle: "불편함 완화 방법",
            discribed:
              "• 자기 전 식사는 소량, 소화 잘 되는 음식 위주로\n• 야식은 피하고, 수면 중 상체를 약간 높인 자세로 눕기\n• 가급적 왼쪽 옆으로 눕는 심스 자세가 좋아요",
          },
          {
            subTitle: "몸이 무거워도, 가벼운 운동은 필요해요",
            discribed:
              "쌍둥이를 품은 임신부에게도 적절한 운동은 체력 유지와 스트레스 해소에 도움이 돼요.\n\n**추천 운동:**\n• 식후 10~15분 정도의 산책\n• 전문 강사가 진행하는 임산부 요가, 필라테스\n• 등, 골반, 하체 순환 개선을 위한 가벼운 스트레칭\n\n단, 배가 단단히 뭉치거나 피로감을 강하게 느낀다면 바로 휴식하세요. 무리하지 않는 선이 가장 중요해요!",
          },
          {
            subTitle: "본격적인 출산 준비, 지금부터 시작해요",
            discribed:
              "쌍태아는 보통 36~37주 사이에 출산하는 경우가 많아요. 그러니 30주인 지금부터는 출산 준비에 본격적으로 돌입해도 좋아요.",
          },
          {
            subTitle: "출산 준비 체크리스트",
            discribed:
              "• 분만 병원, 조산 위험 시 이송 병원 체크\n• 입원 가방, 산모·신생아 용품\n• 산후조리 준비\n• 쌍둥이 돌봄을 위한 가사·육아 지원 서비스 조사\n\n예상보다 빨리 진통이 시작될 수 있으니 필요한 물품은 미리 리스트화하고 한 번에 정리해두는 게 좋아요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "몸은 무겁고 숨은 차지만, 이 모든 변화는 두 생명을 세상에 맞이하기 위한 준비예요. 이제 출산이라는 마지막 여정을 향해 한 걸음씩 다가가고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "출산이 다가올수록 필요한 건, '같이' 준비하는 마음이에요.\n서류와 예산, 행정은 아빠의 몫으로!",
          discribed: "",
        },
        body: [
          {
            subTitle: "출산 관련 서류, 아빠가 챙겨주세요",
            discribed:
              "쌍둥이를 출산하는 경우 행정 절차와 지원 신청이 더욱 복잡하고 많아질 수 있어요.",
          },
          {
            subTitle: "대표적인 준비 서류",
            discribed:
              "• 출산 예정일 확인서 (병원 발급)\n• 건강보험 등재/변경 관련 서류\n• 국민행복카드 잔액 확인 및 사용 정리\n• 출산휴가/육아휴직 관련 회사 제출서류\n• 쌍태아 가정 대상 출산장려금, 양육수당, 돌봄서비스 신청\n\n엄마가 산모수첩을 챙기듯 아빠는 '출산 행정 수첩'을 만들겠다는 마음으로 꼼꼼하게 준비해보세요.",
          },
          {
            subTitle: "출산 예산을 미리 나눠서 계획해요",
            discribed:
              "쌍둥이 출산은 산후조리, 용품, 진료비, 예방접종 등 모든 항목이 2배로 들어갈 수 있어요.",
          },
          {
            subTitle: "예산 분류 항목",
            discribed:
              "**이런 항목부터 구분해보세요:**\n• 병원비(분만비 포함)\n• 산후조리원 또는 산후도우미 비용\n• 쌍둥이 유모차, 카시트, 이불 등 큰 비용이 드는 육아 용품\n• 기저귀, 분유, 젖병 등 소모품 정기구입 비용\n\n미리 분류하고 예산을 짜보면 예상보다 든든하고 차분한 마음으로 출산을 맞이할 수 있어요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "출산은 단지 병원에서 아이를 낳는 일이 아니라, 가족이 되는 첫 번째 공동 프로젝트예요. '엄마가 할 일, 아빠가 할 일'을 함께 나누며 가장 든든한 팀이 되어주세요.",
          },
        ],
      },
    },
    {
      week: 31,
      baby: {
        head: {
          title: "아기가 세상 밖으로 나올 날이 머지않았어요!",
          discribed: "각각 베개만 한 크기",
          size: "약 41~42cm, 1.7kg",
        },
        body: [
          {
            subTitle: "오감이 모두 발달해요!",
            discribed:
              "눈을 뜨고 감는 연습을 시작했어요. 자궁 밖의 밝고 어두운 빛을 구별하고, 배에 손전등을 비추면 고개를 돌리거나 손을 내미는 반응도 보여요.\n\n눈의 동공은 빛에 따라 수축하고 이완할 수 있으며, 시야는 약 20~30cm 정도로 가까운 거리의 움직임을 인식할 수 있어요. 마치 출산 후 엄마의 얼굴을 바라보는 그 거리와 비슷하죠.",
          },
          {
            subTitle: "쌍둥이끼리 교감도 가능해요!",
            discribed:
              "같은 자궁 속에서 함께 자라는 두 아기, 점점 움직임의 범위가 줄어들지만 서로 손을 마주치거나 등을 대고 움직이며 촉각을 통한 교감을 나누기도 해요.\n\n이 시기 두 아기의 뇌, 청각, 시각, 미각, 촉각은 거의 완성 단계이며 각각의 리듬으로 자고, 움직이고, 소리에 반응하는 패턴이 자리 잡고 있어요.",
          },
          {
            subTitle: "큰 세상을 향해",
            discribed:
              "작은 손과 발, 눈동자와 감각까지 모든 게 차곡차곡 완성되어 가는 지금. 두 아기는 엄마 뱃속이라는 작은 세상에서 곧 마주할 '큰 세상'을 향해 한 걸음씩 나아가고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "몸무게가 빠르게 늘고, 통증도 곳곳에 찾아오고 있어요.\n출산 준비에 앞서 내 몸부터 돌보는 시간이 필요해요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "요통과 어깨 결림, 더 깊어져요",
            discribed:
              "쌍둥이를 품고 있는 엄마는 단태아보다 자궁 크기와 체중 증가 속도가 더 빠르기 때문에 허리와 어깨 통증이 특히 심하게 느껴질 수 있어요.\n\n**주요 원인:**\n• 배를 지탱하기 위한 허리 근육의 피로\n• 커진 유방으로 인한 어깨 무게 부담\n• 인대와 관절의 이완으로 인해 자세가 흐트러지며 통증 심화",
          },
          {
            subTitle: "통증 완화 방법",
            discribed:
              "• 임산부 요가나 수영\n• 온찜질\n• 등·어깨 가볍게 마사지\n• 벽에 기대 선 채로 골반 중립 자세 유지 연습",
          },
          {
            subTitle: "잇몸 출혈, 치질, 정맥류… 호르몬 영향이에요",
            discribed:
              "출산을 앞두고 에스트로겐·프로게스테론 호르몬의 분비가 활발해지면서 모세혈관이 약해지고 순환이 느려져요.\n\n**주요 증상:**\n• 잇몸에서 피가 나는 현상\n• 항문 주변 혈관이 확장돼 치질 증상\n• 종아리 뒤쪽에 실핏줄처럼 부풀어오르는 정맥류\n\n청결 유지, 좌욕, 압박 스타킹 등으로 증상 완화에 도움을 줄 수 있어요.",
          },
          {
            subTitle: "요실금이 생겨요 – 너무 걱정하지 마세요",
            discribed:
              "쌍둥이로 인해 자궁의 무게가 방광을 강하게 압박하면서 기침·재채기·웃음만으로도 소량의 소변이 새어나오는 요실금 증상이 나타날 수 있어요.\n\n많은 임산부가 겪는 흔한 현상이며 출산 후에는 점차 회복돼요. 불편함이 크다면 팬티라이너 착용, 케겔운동을 통해 골반저근 강화를 시도해보세요.",
          },
          {
            subTitle: "몸무게가 더 빨리 늘고 있어요!",
            discribed:
              "쌍태아 임신 후반기에는 태아 두 명의 몸무게가 동시에 늘기 때문에 체중이 눈에 띄게 증가해요.",
          },
          {
            subTitle: "허리 부담 줄이는 방법",
            discribed:
              "• 한 동작 한 동작을 천천히 하기\n• 한쪽으로 오래 서있거나 앉는 자세 피하기\n• 미끄러지거나 넘어지지 않도록 보폭 작게 걷기",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "몸이 무겁고 피곤하지만, 이 모든 불편함은 두 생명이 건강하게 자라는 증거예요. 내 몸을 소중히 돌보는 것이 가장 근사한 출산 준비입니다.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "쌍둥이를 맞이할 날이 점점 다가오고 있어요.\n이제는 출산 이후의 생활까지 현실적으로 준비해야 할 시점이에요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "산후조리, 지금부터 상의해보세요",
            discribed:
              "쌍태아 출산 후에는 산모의 회복과 신생아 돌봄 모두 더 많은 시간과 체력이 필요해요.",
          },
          {
            subTitle: "산후조리 방법 선택 시 고려사항",
            discribed:
              "• **산후조리원 이용**: 쌍둥이 수용 가능한지 여부, 비용, 병원과의 거리 등\n• **산후도우미 지원 제도 활용**: 정부 지원 가능성 확인\n• **집에서 가족 중심 돌봄**: 가족 지원 체계 점검\n\n아내와 꼭 함께 상의해서 본인의 회복과 쌍둥이 돌봄이 모두 가능한 방식을 선택하세요.",
          },
          {
            subTitle: "두 아기를 위한 공간, 함께 꾸며보세요",
            discribed:
              "출산 후 육아는 준비된 공간에서 시작돼요. 쌍둥이를 위한 아기 침대, 기저귀 정리함, 수유 공간 등을 미리 고민하고 마련해보세요.\n\n작은 인형 하나, 모빌 하나부터 시작해도 괜찮아요. '여기에서 아기가 잠들겠구나.' '이 자리에 아내가 수유하겠지.' 상상만으로도 설레고, 준비의 의미가 더욱 깊어질 거예요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "곧 도착할 두 아기. 지금 준비하는 모든 것들이 그들을 가장 따뜻하게 맞이하는 방법이 될 거예요. 함께 꾸미는 '가족의 첫 공간', 시작해볼까요?",
          },
        ],
      },
    },
    {
      week: 32,
      baby: {
        head: {
          title: "피부가 본연의 색을 띠기 시작해요!",
          discribed: "각각 작은 배낭만한 크기",
          size: "약 42~43cm, 1.8kg",
        },
        body: [
          {
            subTitle: "태동 검사, 이제는 중요한 점검이에요",
            discribed:
              "쌍둥이는 공간이 좁아지면서 태동이 줄어드는 것처럼 느껴질 수 있어요. 이 시기부터는 태동 검사(NST)를 받게 돼요.",
          },
          {
            subTitle: "태동 검사의 중요성",
            discribed:
              "**태동 검사에서 확인하는 것들:**\n• 태아의 심장 박동이 정상적인지\n• 움직임에 따라 심박이 잘 반응하는지\n• 쌍둥이 중 한 아기의 성장 지연 가능성\n• 산소공급 이상 여부\n\n하루에 일정 시간, 태동 기록하기 습관을 들이면 엄마도 아이의 변화를 빠르게 느낄 수 있어요.",
          },
          {
            subTitle: "피부가 연한 핑크빛으로 변해요",
            discribed:
              "지방이 축적되면서 붉은빛이 돌던 피부가 연한 핑크색으로 변하고 있어요. 손발톱은 거의 끝까지 자라 두 아기의 손가락, 발가락이 신생아의 모습과 매우 흡사해졌어요.\n\n팔다리 비율도 드디어 완성! 머리와 몸이 균형을 이루는 단계랍니다.",
          },
          {
            subTitle: "거의 완성된 두 아이",
            discribed:
              "두 아이는 이제 신체적으로 거의 완성된 상태예요. 엄마의 목소리, 아빠의 손길을 기억하며 각자의 방식으로 세상에 나올 준비를 마치고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "임신 9개월차에 접어든 지금, 쌍둥이를 품은 몸은 하루가 다르게 무거워지고 있어요.\n움직임에 제한이 많지만, 이럴수록 영양과 수분 보충은 필수랍니다!",
          discribed: "",
        },
        body: [
          {
            subTitle: "관절이 뚝뚝… 자연스러운 변화예요!",
            discribed:
              "출산을 앞두고 호르몬의 영향으로 관절과 인대가 느슨해지고 유연해져요. 엉덩이, 골반, 무릎, 손목 관절에서 '뚝', '딸깍' 소리가 나기도 해요.\n\n큰 통증이 없고 반복적인 증상이 아니라면 걱정하지 않으셔도 됩니다.",
          },
          {
            subTitle: "관절 건강을 위한 주의사항",
            discribed:
              "• 좌식보단 의자 생활\n• 무거운 물건 들지 않기\n• 미끄럼 방지 실내화 신기\n\n이런 방법들로 안전하게 지내보세요.",
          },
          {
            subTitle: "배가 더 무겁고, 일상이 불편해져요",
            discribed:
              "설거지, 청소, 세수까지도 자꾸 배가 부딪히고 균형을 잡는 게 어렵게 느껴져요. 배에 음식물이 자주 묻고, 자세도 자주 무너져요.\n\n'나는 왜 이렇게 못하지?'라고 자책하지 마세요. 지금의 몸은 두 생명을 품고 있는 위대한 몸이에요. 불편함을 받아들이고 스스로를 다정하게 대하는 마음이 중요해요.",
          },
          {
            subTitle: "수분 + 영양 = 두 아기에게 전해지는 에너지!",
            discribed:
              "쌍둥이 임신은 대사량과 혈류량이 더 많아지기 때문에 더 많은 수분과 영양분이 필요해요.\n\n**필요한 영양소:**\n• 충분한 물 섭취\n• 소화가 쉬운 고단백식단\n• 철분 + 칼슘 + 오메가3\n\n과일, 죽, 구운 고기, 미음, 우유, 두유 등 가볍지만 영양가 높은 음식을 자주 섭취해주세요.",
          },
          {
            subTitle: "역아 걱정, 지금은 아직 괜찮아요!",
            discribed:
              "쌍둥이 중 한 명 또는 둘 다 역아(둔위)일 수 있어요. 하지만 아직 태아의 자세가 바뀔 여유는 남아있어요.\n\n'고양이 자세 체조'나 슬관절 높이기 운동, 왼쪽으로 눕는 심스 자세가 도움이 될 수 있어요.\n\n단, 쌍둥이의 위치나 태반 상태에 따라 체조를 피해야 할 수도 있으니 의사와 반드시 상의 후 진행하세요.",
          },
          {
            subTitle: "지금이 바로, 모유 수유 준비할 시기!",
            discribed:
              "함몰 유두가 있다면 유두 보호기나 교정기 사용을 고려해요. 유축기, 수유 브라, 수유 쿠션 등 쌍둥이 수유를 위한 도구들도 미리 준비해두세요.\n\n유선 마사지는 하루 1~2회 정도 부드럽게, 유두는 깨끗이 씻고 자연 건조! 모유 수유는 '노력'이 아니라 '연결'의 과정이에요.\n\n무리하지 말고, 내게 맞는 수유 방식을 찾아가려는 연습만으로도 충분해요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "조금 더 무겁고 조금 더 힘들지만, 지금 엄마의 하루하루는 두 아이에게 '가장 안전한 세상'이에요. 남은 시간도 스스로를 따뜻하게 보살피며 마지막 준비를 차근차근 해나가요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠의 몸도 출산 이후를 준비해야해요!",
          discribed: "아빠의 건강도 각별히 신경써주세요!",
        },
        body: [
          {
            subTitle: "임신과 출산은 체력전!\n아빠의 건강도 준비돼 있나요?",
            discribed:
              "쌍둥이 육아는 생각보다 훨씬 많은 체력을 요구해요. 특히 출산 직후는 수면 부족, 외부 활동 제한, 엄마의 회복 지원까지 아빠의 역할이 매우 커지죠.",
          },
          {
            subTitle: "지금부터 할 수 있는 작은 실천",
            discribed:
              "• 영양제 챙기기\n• 주 2~3회 가벼운 유산소 운동\n• 업무 스케줄 조정 및 출산휴가 준비\n• 감기, 허리 통증 등 미리 점검\n\n건강은 한순간에 생기지 않아요. 작은 피로도 무리하지 말고, '지금의 나'부터 관리해요.",
          },
          {
            subTitle: "모유수유, 아빠도 적극적으로 참여해야 해요!",
            discribed:
              "쌍둥이 수유는 시간·체력·심리적 지지 모두가 필요한 일입니다.",
          },
          {
            subTitle: "아빠가 할 수 있는 일",
            discribed:
              "• 수유 전용 공간 마련 (편안한 의자, 쿠션, 수건 등)\n• 한 명 수유 중 다른 아기 돌보기\n• 유축된 모유로 야간 수유 번갈아 하기\n• 수유 후 엄마 마사지 해주기\n• 물 건네주기, 트림시켜주기\n\n모유수유는 '엄마만의 몫'이 아니라 '아빠의 관심과 지원'이 더해질 때 지속 가능성이 높아집니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "이제부터 아빠도 실전 준비예요. 출산이라는 고비와, 두 생명을 함께 맞이할 설렘을 지치지 않고 견딜 수 있는 '든든한 아빠'로 거듭나봐요.",
          },
        ],
      },
    },
    {
      week: 33,
      baby: {
        head: {
          title: "두 아기 모두 생존을 위한 기본기능을 대부분 다 갖추었어요!",
          discribed: "각각 작은 배낭 만 한 크기",
          size: "약 44cm, 2kg",
        },
        body: [
          {
            subTitle: "태어날 준비, 열심히 진행 중이에요!",
            discribed:
              "이제 두 아기의 폐를 제외한 대부분의 장기들은 거의 다 발달을 마쳤어요. 폐포가 아직 열리지 않았기 때문에, 지금은 양수를 들이마시고 내쉬는 호흡 연습을 계속하며 태어날 날을 준비하고 있답니다.\n\n두 아기 모두 매일 약 0.5L의 소변을 배출해 양수를 순환시키고 있어요. 엄마의 자궁 안에서는 쌍둥이 각자의 작은 세상 속에서 건강하게 호흡 훈련을 이어가고 있어요.",
          },
          {
            subTitle: "성기 발달도 거의 마무리됐어요!",
            discribed:
              "남자 아기의 경우, 복부에서 음낭으로 고환이 서서히 내려오는 시기예요. 때로는 한쪽 또는 양쪽 고환이 아직 자리를 잡지 못한 경우도 있지만, 대부분 출생 후 첫돌 전까지는 제자리를 찾아가므로 너무 걱정하지 않아도 괜찮아요.\n\n여자 아기라면, 지금은 대음순이 뚜렷하게 발달하는 시기예요. 출생 직후에는 성기 주변이 조금 부어보일 수 있지만, 이 역시 성 호르몬의 영향으로 나타나는 일시적인 현상이니 걱정하지 않으셔도 돼요.",
          },
          {
            subTitle: "막바지 준비 단계",
            discribed:
              "쌍둥이 임신 33주차, 두 아기의 세상 밖 준비가 이제 막바지에 접어들고 있어요. 하나하나 완성되어 가는 아기들의 모습, 그 놀라운 성장에 귀 기울이며 따뜻하게 지켜봐 주세요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "배는 이미 단단히 부풀고, 몸 곳곳이 예전 같지 않아요.\n이제는 말 그대로 '움직임 하나하나가 쉽지 않은 시기'예요.",
          discribed: "",
        },
        body: [
          {
            subTitle: "자궁은 15배 이상! 몸이 무거워요",
            discribed:
              "쌍둥이를 품은 자궁은 단태아보다 훨씬 더 빠르게, 많이 커졌어요. 이제는 횡격막과 위, 방광까지 압박이 심해져 숨이 차고 속이 쓰리며 소변도 자주 마려워요.\n\n배꼽이 돌출되고 배가 딱딱하게 뭉치기도 해요. 앉았다 일어나는 동작, 계단 오르내리기가 어려워졌다면 자연스러운 변화랍니다.",
          },
          {
            subTitle: "소변이 잦고, 요실금도 생겨요",
            discribed:
              "방광이 자궁에 눌리면서 소변을 봐도 잔뇨감이 남고 재채기나 기침, 웃을 때 요실금 증상이 생겨요.\n\n출산 후 대부분은 자연스럽게 회복되니 너무 걱정하지 않으셔도 괜찮아요. 단, 통증이나 열, 소변 색깔 변화가 있다면 바로 진료를 받으세요!",
          },
          {
            subTitle: "깊은 잠이 어려워요",
            discribed:
              "쌍둥이의 태동은 활발하고, 배는 무겁고, 자주 깨는 밤이 반복돼요. 숙면이 어려운 건 엄마의 탓이 아니에요.",
          },
          {
            subTitle: "숙면을 위한 팁",
            discribed:
              "• 취침 전 가벼운 샤워와 스트레칭\n• 왼쪽으로 눕는 심스 자세\n• 다리 사이에 베개, 복부 아래 받침\n• 잠이 안 올 땐 억지로 누워 있지 말고 조용한 음악이나 태담하기\n\n무엇보다 중요한 건, 규칙적인 생활 리듬 유지랍니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "매일 새롭게 커지는 배와 싸우는 엄마. 불편함 속에서도 두 생명을 품고 있는 지금의 몸은 세상에서 가장 위대한 변화의 중심이에요. 조금 더 다정하게, 오늘의 나를 바라봐주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "쌍둥이를 위해 아내의 식사에 더욱 세심한 신경을 써주세요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "두 아기를 위한 영양소, 더 꼼꼼하게 챙겨야 해요",
            discribed:
              "쌍둥이를 품고 있는 아내의 몸은 지금 그 어느 때보다 많은 영양소를 필요로 해요.\n\n세 끼 식사만으로는 부족할 수 있기 때문에 건강한 간식이나 간단한 영양 보충제를 곁들여 에너지와 영양소가 고르게 공급될 수 있도록 도와주세요.",
          },
          {
            subTitle: "아내의 컨디션을 먼저 살펴보는 센스!",
            discribed:
              "요즘 아내는 쉽게 피로해지고 소화도 예전처럼 잘 되지 않을 수 있어요.\n\n먹고 싶은 것이 있으면 귀 기울여주시고, 소화가 잘 되는 음식, 부드럽고 따뜻한 음식 위주로 식사를 준비하는 것도 좋아요. 식사 시간이 스트레스가 아닌 '편안한 시간'이 될 수 있도록 아빠의 작은 배려가 큰 힘이 된답니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "두 아기의 건강한 성장, 그리고 아내의 평온한 하루를 위해 지금 아빠의 역할은 더욱 소중해요. 함께 만들어가는 이 시간, 멋진 아빠의 페이스를 계속 유지해봐요.",
          },
        ],
      },
    },
    {
      week: 34,
      baby: {
        head: {
          title: "세상 밖으로 나갈 준비, 두 아기 모두 착착 진행 중이에요!",
          discribed: "각각 큰 수박만 한 크기",
          size: "약 45cm, 2.1kg",
        },
        body: [
          {
            subTitle: "머리를 아래로, 태어날 자세를 준비해요",
            discribed:
              "이 시기의 태아는 머리를 자궁 아래쪽으로 향한 '분만 자세'를 잡는 경우가 많아요. 두개골은 아직 단단하게 붙지 않고 유연한 상태라, 태어날 때 산도를 잘 빠져나올 수 있도록 도와줘요.\n\n쌍둥이의 경우, 첫째 아기는 머리를 아래로, 둘째 아기는 다양한 위치를 취하는 경우도 많지만 지금은 서로의 공간을 조율하며 출산에 최적화된 자세를 찾아가는 과정 중이랍니다.",
          },
          {
            subTitle: "움직임은 계속, 준비는 차근차근",
            discribed:
              "두 아기는 아직도 양수 속에서 몸을 비트는 작은 움직임을 반복하며 출산 전 마지막 성장과 운동 연습을 하고 있어요.\n\n이제 각자 자리를 잡을 공간은 좁아졌지만, 심장은 튼튼하게 뛰고, 장기들은 거의 다 기능을 마무리하고 있어요.",
          },
          {
            subTitle: "새로운 공간을 향해",
            discribed:
              "두 아기 모두, 세상이라는 새로운 공간을 향해 한 걸음씩 나아가는 중이에요. 이 놀라운 여정에 함께하고 있는 지금 이 순간도, 무척 소중해요.",
          },
        ],
      },
      mom: {
        head: {
          title:
            "출산 준비, 이제는 정말 실전처럼 생각할 시기예요!\n출산 가방, 마음가짐, 체력 모두 차근차근 준비해봐요",
          discribed: "",
        },
        body: [
          {
            subTitle: "다리 쥐와 통증이 잦아졌어요",
            discribed:
              "점점 커지는 두 아이의 무게를 지탱하느라 다리에 무리가 오고 쥐가 나거나 사타구니, 골반 통증이 나타나기도 해요.\n\n장시간 서 있거나 무리한 움직임은 피하고, 다리를 심장보다 높게 하고 쉬는 자세를 자주 취해주세요. 특히 쌍둥이 엄마는 배 크기가 더 빠르게 증가하기 때문에 작은 통증이라도 신호에 귀 기울이며 과로하지 않는 것이 가장 중요해요.",
          },
          {
            subTitle: "출산 준비물, 미리 챙겨보세요",
            discribed:
              "이제부터는 언제 출산이 시작되어도 이상하지 않은 시기예요. 갑작스런 상황에 당황하지 않도록 출산 가방은 미리미리 준비해주세요.",
          },
          {
            subTitle: "산모 준비물",
            discribed:
              "• 산모수첩, 산모패드\n• 수유브라, 수유나시, 임부팬티\n• 세면도구, 꺾이는 빨대\n• 담요, 양말, 머리끈\n• 복대, 손목 보호대, 회음부 방석",
          },
          {
            subTitle: "아기 준비물 (쌍둥이 x2)",
            discribed:
              "• 가제손수건, 겉싸개, 속싸개\n• 배냇저고리, 기저귀\n• 아기 로션\n• 손싸개/발싸개\n\n쌍둥이인 만큼 준비물도 2배로, 꼼꼼히 챙겨주세요!",
          },
          {
            subTitle: "진통 시 호흡법, 지금부터 연습해요",
            discribed:
              "쌍태아의 경우 조기 진통 가능성도 더 높기 때문에 호흡법과 긴장 완화 훈련을 지금부터 반복해 익혀두는 것이 좋아요.\n\n막상 진통이 시작되면 너무 아파서 정신이 없을 수 있으니 의식하지 않아도 자연스럽게 나올 정도로 반복해서 연습해두세요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "출산이 머지않았어요. 아직 모든 것이 낯설고 긴장될 수 있지만, 준비해온 시간만큼 당신은 이미 충분히 멋진 엄마입니다. 하루하루 차근히, 용기와 믿음을 안고 걸어가요.",
          },
        ],
      },
      dad: {
        head: {
          title:
            "이제 출산이 정말 코앞!\n예비아빠의 본격적인 역할이 시작됩니다.",
          discribed: "",
        },
        body: [
          {
            subTitle: "만삭의 아내를 위해 세심한 케어를!",
            discribed:
              "두 아이를 품고 있는 아내는 더 빠르게 배가 불러오고, 소화불량이나 속쓰림, 울렁거림이 심해질 수 있어요.\n\n자극적인 음식은 피하고, 소화가 잘 되는 음식을 소량씩 자주 준비해 주세요. 피부는 당기고 가려울 수 있으니 수분크림, 오일로 부드럽게 마사지해 주세요.\n\n체중이 빠르게 늘어나는 시기이니, 식단 균형과 간식 조절도 함께 챙겨주세요.",
          },
          {
            subTitle: "아빠도 출산가방, 필수 준비 완료!",
            discribed:
              "출산 시 함께 입원하거나 대기할 수 있기 때문에, 아빠만의 출산 키트도 꼭 챙겨야 해요.",
          },
          {
            subTitle: "아빠용 출산 가방 체크리스트",
            discribed:
              "• 여벌 옷 (수면용/외출용)\n• 슬리퍼, 세면도구\n• 간단한 간식 (에너지바, 음료 등)\n• 충전기, 이어폰\n• 안대, 수면 용품\n\n차량 이동 예정이라면 가방은 미리 차에 실어두는 것도 추천드려요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "이제 언제 진통이 와도 이상하지 않은 시기예요. 아내가 안심할 수 있도록 실전 상황을 가정한 준비, 그리고 따뜻한 격려 한 마디까지 잊지 마세요. 아빠의 준비가 곧 아내의 안심입니다.",
          },
        ],
      },
    },
    {
      week: 35,
      baby: {
        head: {
          title: "이제는 자궁속에 남아있는 공간이 거의 없어요!",
          discribed: "각각 큰 수박만 한 크기",
          size: "약 47cm, 2.4~2.5kg",
        },
        body: [
          {
            subTitle: "거의 완전한 신생아!",
            discribed:
              "우리 아기들은 지금, 신생아와 거의 동일한 모습을 하고 있어요. 내장 기관은 대부분 성숙한 상태고, 만약 지금 태어난다 해도 대부분의 아기가 자립적으로 생존할 수 있을 만큼 건강한 몸을 갖추었어요.\n\n호흡만 원활하다면 바로 출산이 가능하답니다.",
          },
          {
            subTitle: "손발 끝까지 야무지게!",
            discribed:
              "발톱은 끝까지 다 자라고, 손톱도 작지만 선명하게 자리를 잡았어요. 성기도 거의 완성되었고, 몸 전체가 작지만 단단한 신생아의 모습으로 다듬어지고 있어요.",
          },
          {
            subTitle: "좁아진 공간 속에서",
            discribed:
              "공간이 좁아졌어요! 이제 두 아기가 움직일 수 있는 공간은 거의 다 찼다고 해도 과언이 아니에요. 그래도 아기들은 서로의 존재를 느끼며 따뜻하게 기대어 세상에 나갈 준비를 하고 있어요.",
          },
        ],
      },
      mom: {
        head: {
          title: "코앞으로 다가온 출산, 몸도 마음도 준비가 필요해요!",
          discribed:
            "어떤 상황이든 문제없이 대처할 수 있게 미리미리 점검해두어요!",
        },
        body: [
          {
            subTitle: "호흡법을 미리 연습해 볼까요?",
            discribed:
              "쌍태아 출산은 단태아보다 신체의 부담이 더 큰 만큼, 분만 중 체력 안배와 긴장 완화가 정말 중요해요. 가장 기본이자 효과적인 방법은 호흡법!",
          },
          {
            subTitle: "호흡법 종류",
            discribed:
              "• 짧고 가쁜 흉식 호흡\n• 깊고 천천히 내쉬는 복식 호흡\n• 진통 간격에 맞춘 리듬 호흡\n\n본인에게 맞는 호흡을 찾아 매일 조금씩 연습해보세요. 자연분만이든 제왕절개든 호흡은 통증 완화와 회복에 큰 도움이 돼요.",
          },
          {
            subTitle: "출산에 대한 마음의 준비도 필요해요",
            discribed:
              "쌍둥이를 출산한다는 건 신체적으로도, 감정적으로도 결코 가벼운 일이 아니에요. 출산에 대한 막연한 두려움은 자연스러운 감정이랍니다.\n\n그러니 자신을 다그치기보다는, \"나는 잘 해내고 있다\" \"나와 아기들은 최선을 다하고 있다\" 이런 식의 긍정적인 셀프 대화를 해보세요.",
          },
          {
            subTitle: "든든한 지원팀",
            discribed:
              "그리고 무엇보다, 지금 이 시기를 지나고 있는 엄마 자신의 몸과 마음을 따뜻하게 응원해주세요. 의료진, 남편, 가족은 든든한 팀원이랍니다.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "출산은 어느 날 갑자기 찾아올 수 있어요. 준비된 사람에게 두려움은 훨씬 작아진답니다. 오늘 하루도 엄마, 잘하고 있어요!",
          },
        ],
      },
      dad: {
        head: {
          title: "이제부터 눈치게임 시작!",
          discribed: "이제부터는 언제든지 진통이 시작될 수 있어요.",
        },
        body: [
          {
            subTitle: "언제든 병원으로! 미리미리 점검해요!",
            discribed:
              "쌍둥이는 단태아보다 조산 확률이 높기 때문에, 이 시기부터는 언제 진통이 와도 전혀 이상하지 않아요.",
          },
          {
            subTitle: "긴급 상황 대비책",
            discribed:
              "• 병원으로 가는 이동 경로와 소요 시간 미리 파악해두기\n• 차에 기름 여유 있게 채워두기\n• 출산가방과 산모수첩 차에 미리 실어두기\n• 넓은 수건이나 방수시트 준비해두기\n\n긴급 상황일수록 침착함이 중요해요. 순간의 당황이 아내에게 불안을 줄 수 있으니 아빠가 먼저 준비된 모습 보여주세요!",
          },
          {
            subTitle: "출산휴가, 꼭 신청하세요!",
            discribed:
              "근로자의 배우자가 출산한 경우 사용할 수 있는 배우자 출산휴가, 아시죠?\n\n**출산휴가 정보:**\n• 유급 10일\n• 출산일 전후 자유롭게 사용 가능\n• 고용노동부에 등록된 사업장이라면 누구나 신청 가능\n\n아직 신청 전이라면, 회사에 미리 문의하고 필요한 서류도 함께 챙겨두세요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "지금부터는 '긴장과 준비'가 함께 필요한 시기입니다. 두 아기를 맞이할 순간이 가까워질수록 엄마는 점점 더 불안해질 수 있어요.\n\n아빠는 든든한 조력자이자 리더예요. 실제 진통이 시작되었을 때 당황하지 않고 침착하게 대처할 수 있도록 오늘부터 다시 한번 마음을 다잡아볼까요?",
          },
        ],
      },
    },
    {
      week: 36,
      baby: {
        head: {
          title: "이제는 세상에 나올 준비 완료!\n곧 엄마를 만날 수 있어요.",
          discribed: "각각 큰 수박만 한 크기",
          size: "약 47~48cm, 2.6~2.7kg",
        },
        body: [
          {
            subTitle: "본격적인 출산 준비 돌입!",
            discribed:
              "지금 아기들은 심장, 간, 신장 등 주요 장기가 모두 성숙했고 뇌와 감각기관도 활발히 작동 중이에요. 하지만 폐 기능은 아직 최종 조율 중이에요.\n\n자연스럽게 호흡할 수 있을 정도로 거의 다 성장했지만, 태어났을 때 호흡이 불안정할 수 있어 일시적으로 인공호흡기나 신생아 집중 치료실(NICU)의 도움을 받을 수도 있어요.",
          },
          {
            subTitle: "배내털도 정리 중이에요!",
            discribed:
              "피부를 감싸던 부드러운 배내털은 점점 빠지고, 어깨나 팔꿈치, 허벅지 주름 부근에만 조금씩 남아 있어요.",
          },
          {
            subTitle: "몸이 골반 안으로! '머리 고정' 단계에요",
            discribed:
              "태아는 점차 머리를 아래로 향하며 골반 안으로 들어와 몸을 고정해요. 이때부터는 움직일 공간이 좁아지기 때문에 엄마가 느끼는 태동이 줄어든 것처럼 느껴질 수 있어요.\n\n하지만 아기들은 여전히 작은 움직임과 반응을 하고 있으니, 하루에 한 번씩 조용한 시간에 태동을 확인해보세요.",
          },
          {
            subTitle: "곧 만날 수 있어요!",
            discribed:
              "\"엄마, 이제 정말 곧 만날 수 있어요!\" 두 아기는 지금 이 순간에도 세상에 나올 준비를 부지런히 하고 있어요.\n\n출산까지 남은 날들, 따뜻한 말과 손길로 아기에게 계속 사랑을 전해주세요. 이제 만남까지 정말 '눈앞'이에요!",
          },
        ],
      },
      mom: {
        head: {
          title:
            "이제는 진짜 막달!\n두 아기를 품고 여기까지 오신 것만으로도 대단해요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "몸무게, 최고치에 도달해요!",
            discribed:
              "지금 엄마의 자궁은 이미 최대한 커져 있고, 복부는 마치 팽팽한 풍선처럼 꽉 찬 느낌일 수 있어요. 쌍둥이 임신의 경우 평균 체중 증가량은 16~20kg 내외예요.\n\n분만일까지 체중이 조금 늘거나 정체되는 시기예요.",
          },
          {
            subTitle: "체중 관리, 마지막까지 중요해요!",
            discribed:
              "하지만 출산이 가까워졌다고 해서 마음 놓고 폭식하는 건 금물! 지나친 체중 증가는 다음과 같은 문제로 이어질 수 있어요:\n\n• 고혈압\n• 부종\n• 자연분만 난이도 증가\n\n마지막까지 식사량 조절과 영양 밸런스를 신경 써주세요.",
          },
          {
            subTitle: "배가 아래로 내려가는 '하강감'이 느껴질 수 있어요",
            discribed:
              "태아 두 명이 자리를 잡으며, 배가 아래쪽으로 더 처진 느낌이 들 수 있어요.\n\n숨쉬기는 조금 편해지고 대신 방광 압박으로 소변이 더 자주 마려워지고 골반 아래쪽이 묵직하거나 찌릿한 통증이 느껴질 수도 있어요. 하강감은 사람마다 시기가 다르지만, 출산이 머지않았다는 몸의 신호로 생각하시면 돼요.",
          },
          {
            subTitle: "여기가 바로 막달!",
            discribed:
              "여기까지 정말 잘 오셨어요. 두 아기를 품고 견뎌낸 시간 동안 엄마의 몸과 마음은 믿을 수 없이 강해졌어요.\n\n이제는 출산을 위한 최종 정비의 시간이에요. 출산 가방도 다시 한 번 점검하고, 몸을 많이 쉬면서 컨디션 관리에 집중해 주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "기나긴 마라톤의 결승선이 가까워졌어요!",
          discribed: "이제 막달에 접어들었어요.",
        },
        body: [
          {
            subTitle: "40주까지 못 채울 수도 있어요",
            discribed:
              "쌍태아는 대부분 36~37주 무렵에 출산하는 경우가 많아요. 이제는 정말 언제 진통이 시작돼도 이상하지 않은 시기예요.\n\n아빠도 정신 바짝 차리고 있어야겠죠?",
          },
          {
            subTitle: "직장에 미리 이야기하세요!",
            discribed:
              "'지금이 막달이고, 언제든 연락이 오면 바로 출발해야 해요.' 이 말을 동료와 상사에게 꼭 미리 알리세요. 당일 통보는 모두를 당황하게 만들 수 있어요.\n\n가능하다면, 출산 예정일까지 재택근무가 가능한지 비상연락망과 업무 인수인계를 어떻게 해둘지 꼼꼼히 점검해보세요.",
          },
          {
            subTitle: "출산 D-day 준비물 다시 확인!",
            discribed:
              "**최종 점검 체크리스트:**\n• 출산 가방 위치는?\n• 차에 기름은 충분한가요?\n• 산부인과 병원 가는 길, 교통 상황 파악했나요?\n• 휴가 시작일, 병원 진료일정 다 적어놨나요?",
          },
          {
            subTitle: "아내의 감정 조율자 역할",
            discribed:
              "막달의 엄마는 육체적으로도, 감정적으로도 아주 민감해요. 일상적인 일에도 피곤함이 배가 되고 조금의 말에도 예민해질 수 있어요.\n\n그럴수록 아내의 '감정 조율자'는 아빠의 몫이에요. '힘들지?', '내가 도와줄게.' 이 짧은 말 한마디가 아내에게 큰 위로가 된답니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "쌍둥이 아빠, 지금부터가 진짜 시작이에요! 곧 두 아이의 아빠가 된다는 사실, 실감나시나요?\n\n준비된 마음과 태도가 이 결승선의 마지막 한 달을 더 단단하게 만들어줄 거예요. 함께 잘 달려온 지금까지도, 그리고 남은 시간도… 정말 멋져요!",
          },
        ],
      },
    },
    {
      week: 37,
      baby: {
        head: {
          title: "태어날 준비를 끝내고 발육과정을 마무리해요!",
          discribed: "각각 큰 수박만 한 크기",
          size: "약 49~50cm, 2.8~2.9kg",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "두 아기 모두 이제 신생아와 거의 같은 모습이에요. 피부 아래 지방도 충분히 쌓였고, 폐를 비롯한 주요 기관은 자체 기능이 가능한 수준까지 발달했어요.\n\n태어날 때까지 남은 기간 동안은 조금씩 체중을 늘리고, 피부를 매끄럽게 다듬으며 마무리 작업을 해요.",
          },
          {
            subTitle: "피부 보호막인 태지와 솜털이 사라져요",
            discribed:
              "태아를 보호하던 태지와 솜털은 점차 사라지고 있어요. 이제는 두 아기 모두 그것들을 삼켜서 태변으로 준비 중이에요.\n\n태변은 출산 이후 며칠 동안 배출되는 아기의 첫 대변이에요.",
          },
          {
            subTitle: "출산 방식, 아기 상태에 따라 결정돼요",
            discribed:
              "쌍둥이 중 첫째 아기가 머리를 아래로 두고 있다면, 자연분만도 가능하지만 둘째 아기의 자세, 아기들의 체중, 태반의 위치 등에 따라 의료진은 제왕절개 분만을 권할 수도 있어요.\n\n진통이 시작되기 전, 담당 의사 선생님과 충분히 상의하고 두 아기와 엄마에게 가장 안전한 분만 방법을 함께 결정해주세요.",
          },
          {
            subTitle: "곧 만날 날만 남았어요!",
            discribed:
              "이제는 진짜, 만날 날만 남았어요! 두 아기 모두 훌륭히 자라주었어요. 엄마의 뱃속에서 마지막 성장 단계를 마무리하고 있는 지금, 곧 엄마와 눈을 마주칠 준비를 하고 있답니다.",
          },
        ],
      },
      mom: {
        head: {
          title: "이제부터는 조산이 아니에요!",
          discribed: "쌍둥이 출산, 언제든 시작될 수 있어요.",
        },
        body: [
          {
            subTitle: "이제부터는 모든 준비를 마무리할 때예요",
            discribed:
              "쌍태아의 경우, 37주 출산이 매우 일반적이에요. 이미 진통이 시작되었거나, 언제든 병원에 가야 할 수 있어요.\n\n지금부터는 매주 정기검진을 받으며 아기가 얼마나 내려왔는지, 자궁경부가 얼마나 열렸는지를 내진 등을 통해 확인하게 돼요.",
          },
          {
            subTitle: "아랫배 당김과 진통 같은 통증, 드디어 시작될까요?",
            discribed:
              "쌍둥이를 품은 자궁은 이미 한계점에 가까운 크기로 늘어난 상태예요. 그래서 아랫배가 단단히 뭉치고, 종종 통증이 느껴지는 경우가 있어요.",
          },
          {
            subTitle: "진통 구별법",
            discribed:
              "• **불규칙적인 통증** = 가진통 (출산 준비 운동)\n• **규칙적으로 반복되고 간격이 짧아짐** = 진통 시작!\n\n진통이 10분 간격으로 1시간 이상 반복된다면 병원에 연락하고 출산 준비 모드로 전환하세요.",
          },
          {
            subTitle: "자궁 입구가 부드러워지고 분비물이 늘어요",
            discribed:
              "출산에 가까워지면 자궁경부가 말랑해지고 태아가 잘 빠져나올 수 있도록 점액 분비물이 늘어요.\n\n속옷을 자주 갈아입고, 외음부를 깨끗하게 관리해주세요. 출산 직전에는 피가 섞인 분비물(이슬)이 보일 수 있어요.",
          },
          {
            subTitle: "쌍둥이 출산은 '정확한 시기 예측'이 어려워요",
            discribed:
              "의사 선생님은 다음 사항들을 확인하며 출산이 임박했는지를 판단해요:\n\n• 자궁 경부가 얼마나 열렸는지\n• 경부의 길이가 얼마나 얇아졌는지\n• 태아의 위치와 자세\n\n하지만 자연 진통이 올 수도 있고, 계획된 제왕절개일이 앞당겨질 수도 있어요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "이제 정말 마지막 고지예요. 아기들이 곧 세상에 나올 준비를 마쳤어요. 그리고 엄마도 정말 잘 해오셨어요.\n\n남은 시간 동안은 무리하지 않고, 몸의 신호에 더 귀 기울이며, 출산 후 회복을 위한 체력 안배도 신경 써주세요. 수고했어요, 엄마!",
          },
        ],
      },
      dad: {
        head: {
          title: "아내의 곁을 지키는 슈퍼맨!",
          discribed: "출산 임박, 이제는 24시간 대기 상태예요!",
        },
        body: [
          {
            subTitle: "언제 진통이 시작될지 몰라요!",
            discribed:
              "이제는 쌍둥이를 만날 시간이 정말 가까워졌어요. 특히 쌍태아의 경우 단태아보다 출산 시기가 빨라지는 경우가 많기 때문에 예정일보다 빠른 진통과 출산도 충분히 가능한 시점이에요.\n\n자리를 비울 땐 반드시 휴대폰을 가까이 두고, 연락을 즉시 확인할 수 있는 상태를 유지해주세요. 회사나 외부 일정도 긴급상황 발생 시 바로 이동 가능하도록 조율해두는 것이 좋습니다.",
          },
          {
            subTitle: "장거리 이동은 금지!",
            discribed:
              "지금 시기의 아내는 언제 진통이 시작되어도 이상하지 않은 상황이에요. 그러므로 장거리 외출, 여행, 차량 이동은 자제해주세요.\n\n가벼운 외출조차도 함께 다니며 긴급한 상황에 대비할 수 있어야 해요. 곁에 있는 것만으로도 큰 힘이 돼요! 몸도 마음도 무거운 아내에게는 곁에 있어주는 것만으로도 엄청난 위로와 안정감이 된답니다.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "이제 진짜 아내와 아기들을 안전하게 맞이할 순간만 남았어요. 아빠, 지금처럼만 해주시면 정말 든든해요. 조금만 더 힘내요!",
          },
        ],
      },
    },
    {
      week: 38,
      baby: {
        head: {
          title: "대부분 예정일 2주 전후로 태어나요!",
          discribed: "각각 큰 호박만 한 크기",
          size: "약 50cm, 3kg",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "이제 두 아기의 신체는 대부분 완성되었어요. 심장, 간, 신장, 소화기관, 비뇨기관 등 생존에 필요한 기능들이 모두 준비 완료!\n\n마지막으로 부신에서 코르티솔이라는 호르몬이 분비되면서 세상에 나와 첫 울음을 위한 호흡 준비도 마쳐가고 있어요.",
          },
          {
            subTitle: "태동은 줄지만, 걱정하지 마세요!",
            discribed:
              "두 아기가 골반 쪽으로 자리를 잡으며 공간이 좁아져 태동은 자연스럽게 줄어들어요. 하지만 전혀 움직이지 않는다면 반드시 병원에 문의하세요!",
          },
          {
            subTitle: "규칙적인 생활 리듬도 생겼어요!",
            discribed:
              "두 아기는 자고 깨는 주기가 생기고, 하루 중 몇 번은 동시에 꿈도 꾼답니다. 엄마의 목소리와 손길은 여전히 아기들에게 큰 안정감을 주고 있어요.",
          },
          {
            subTitle: "이제 곧 만나요!",
            discribed:
              "두 아기는 세상 밖으로 나올 마지막 준비를 하며 아늑한 자궁 안에서 마지막 시간을 보내고 있어요. 이제는 정말 얼마 남지 않았어요. 조금만 더 힘내주세요, 엄마!",
          },
        ],
      },
      mom: {
        head: {
          title: "긴장을 늦출 수 없는 한주!",
          discribed: "예정일을 앞둔 지금, 철저하게 준비해요!",
        },
        body: [
          {
            subTitle: "출산가방 다시 한 번 꼼꼼히 점검해요!",
            discribed:
              "출산가방은 이미 준비해두셨죠? 쌍둥이를 맞이할 준비는 단태아보다 준비물이 조금 더 많을 수 있어요.\n\n아기 옷, 속싸개, 기저귀, 배냇저고리 등 쌍둥이 기준으로 2벌씩 준비되어 있는지 확인해주세요.",
          },
          {
            subTitle: "출산가방 필수 체크리스트",
            discribed:
              "**산모용품:**\n• 산모수첩, 신분증, 보험증, 병원 서류\n• 산모패드, 복대, 수유브라, 내의\n\n**쌍둥이 용품 각 2세트:**\n• 아기 옷, 속싸개, 기저귀, 배냇저고리\n\n차량에 미리 실어두거나 현관에 두는 센스!",
          },
          {
            subTitle: "병원으로 가야 할 때는?",
            discribed:
              "쌍태아 임신은 분만 진행 속도가 빠를 수 있기 때문에 다음의 경우 지체 없이 병원으로 출발해야 해요:",
          },
          {
            subTitle: "응급 상황 체크리스트",
            discribed:
              "• 양수가 터진 경우 (통증 여부와 관계없이 즉시 병원으로!)\n• 출혈이 있는 경우\n• 규칙적인 진통이 10분 간격 이내로 지속될 때\n• 아기가 잘 움직이지 않거나 태동이 갑자기 줄어든 경우\n\n진통의 시작 시점부터 시간 간격을 기록해두는 것도 도움이 돼요!",
          },
          {
            subTitle: "체력 관리, 지금이 가장 중요해요!",
            discribed:
              "쌍둥이 출산은 체력 소모가 커요. 제왕절개든 자연분만이든 체력은 회복력에 큰 영향을 미치기 때문에 지금부터 충분한 수면, 규칙적인 식사, 물 자주 마시기 꼭 기억하세요.",
          },
          {
            subTitle: "의료진과의 커뮤니케이션도 중요해요!",
            discribed:
              "분만 방식, 마취 여부, 입원 절차 등을 사전에 간단히 정리해서 의료진과 공유해두면 진통이 시작된 후에도 훨씬 편하게 대처할 수 있어요!",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "오늘도 잘 버티고 있어요, 엄마! 곧 우리 아기들을 만나게 될 거예요. 설레는 마음, 조금은 긴장되는 마음… 모두 자연스러운 감정이랍니다. 조금만 더 힘내요! 정말 잘하고 있어요!",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠도 불안하지만, 더 불안해하고 있을 아내를 위해!",
          discribed: "곁을 지키며 아내가 안심할 수 있게 해주세요.",
        },
        body: [
          {
            subTitle: "출산을 코앞에 둔 아내에게 필요한 건, 바로 당신입니다!",
            discribed:
              "쌍둥이 출산은 육체적 부담도 크지만, 정서적 불안감도 단태아보다 클 수 있어요. 아내가 불안해할 때, 말보다 함께 있어주는 것이 최고의 위로가 돼요.\n\n돌발 상황이 발생해도 차분하게 대응할 수 있는 태도를 갖춰주세요. 배가 뭉치거나, 미열이나 이상 신호가 보인다면 즉시 병원에 연락해주세요.",
          },
          {
            subTitle: "만반의 준비, 다시 한 번 점검!",
            discribed:
              "• 병원까지 가는 경로, 시간, 교통 상황 체크!\n• 차에 기름은 충분한지, 출산가방은 싣었는지 점검\n• 응급 상황 시 연락망도 다시 확인\n\n이렇게 준비해두면 안심이 되겠죠?",
          },
          {
            subTitle: "이제 정말 얼마 남지 않았어요!",
            discribed:
              "곧 두 아기가 세상에 나와 아내와 당신의 손을 꼭 잡게 될 거예요. 둘만의 마지막 밤들, 짧은 산책, 마음 나누기, 아내를 위한 따뜻한 말 한마디로 마무리해보세요.",
          },
        ],
      },
    },
    {
      week: 39,
      baby: {
        head: {
          title: "아기야 세상밖으로 나오기 가장 이상적인 시기!",
          discribed: "각각 큰 호박만 한 크기",
          size: "약 50~51cm, 3.2~3kg",
        },
        body: [
          {
            subTitle: "태어날 준비, 완료!",
            discribed:
              "두 아기 모두 자궁 속에서 충분히 자라 이제 세상 밖으로 나올 준비를 마쳤어요. 쌍둥이의 경우, 체중은 단태아보다 약간 작을 수 있지만 이 시기쯤 되면 대부분의 아기가 건강하게 출생할 수 있는 기준을 모두 갖추게 돼요.",
          },
          {
            subTitle: "감각이 완전히 깨어 있어요!",
            discribed:
              "이제 두 아기는 소리에 반응하고, 빛과 어둠을 구별하며, 냄새와 촉감도 느낄 수 있어요. 또, 아기의 몸은 전반적인 반사작용(빠는 반사, 잡는 반사, 놀람 반사 등)을 나타낼 수 있어 출생 후 바로 세상과 상호작용할 준비가 되어 있어요!",
          },
          {
            subTitle: "체온을 지킬 지방층도 축적 완료!",
            discribed:
              "출산 직후 체온을 유지하기 위해 몸 전체에 지방이 충분히 축적되어 있어요. 또, 태반에서 분비되는 호르몬의 영향으로 남자아이든 여자아이든 출생 직후엔 가슴이 일시적으로 부풀어 있을 수 있어요.\n\n하지만 곧 가라앉으니 걱정하지 마세요.",
          },
          {
            subTitle: "세상과의 만남을 기다리며",
            discribed:
              "두 아기 모두 이제 세상과의 만남을 기다리고 있어요. 엄마의 따뜻한 품에서 열 달을 잘 견딘 두 생명, 곧 만나게 될 거예요. 엄마 아빠, 조금만 더 힘내요!",
          },
        ],
      },
      mom: {
        head: {
          title: "이제 두 아기를 만날 수 있어요!",
          discribed:
            "지금까지 잘해 온 엄마도 그리고 뱃속 아기도 정말 대단해요.",
        },
        body: [
          {
            subTitle: "자궁 수축이 점점 규칙적이에요!",
            discribed:
              "분만을 앞두면 자궁경부는 더욱 부드러워지고, 자궁 수축은 규칙적인 간격으로 찾아오며 점점 강해져요.\n\n수축이 움직일 때 더 심해지고, 간격이 일정하고 점점 좁아지며 통증이 허리·하복부까지 퍼질 경우, 병원으로 갈 준비를 하셔야 해요!",
          },
          {
            subTitle: "분만을 알리는 신호, 이것도 기억해두세요!",
            discribed:
              "• 양막이 파열되며 양수가 흐르는 느낌\n• 자궁경관의 점액이 빠져나오며 나타나는 선홍빛 출혈, 이를 '이슬'이라고 해요\n\n이슬이 보이면 진통이 임박했음을 알리는 신호! 양수가 터졌다면, 즉시 병원에 연락하고 입원 준비를 하세요.\n\n쌍둥이는 조산 가능성이 높기 때문에 모든 신호에 민감하게 반응해야 해요.",
          },
          {
            subTitle: "힘주는 방법도 미리 머릿속에 이미지로 연습해요!",
            discribed:
              "진통 중 혹은 분만대에 올랐을 때 \"어디에 어떻게 힘을 줘야 하지?\" 당황할 수 있어요.\n\n그럴 땐 변을 볼 때처럼 항문·질 방향으로 자연스럽게 아래로 밀어내는 느낌으로 힘을 주세요. 배보다는 엉덩이 쪽으로! 발끝은 자유롭게, 허벅지를 잡고 밀어내듯이!\n\n남편 손을 잡고 함께 호흡에 맞춰 힘을 주세요.",
          },
          {
            subTitle: "엄마에게 드리는 따뜻한 한마디",
            discribed:
              "이제 정말 얼마 남지 않았어요. \"엄마, 너무 잘하고 있어요.\" \"우리 아기들, 곧 만나요.\" 이 말을 스스로에게 한 번 더 속삭여 주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "막판 스퍼트!\n지금이야말로 아빠의 힘이 필요한 순간!",
          discribed: "이제 곧 아기를 만날 수 있어요!",
        },
        body: [
          {
            subTitle: "결승선이 코앞에!",
            discribed:
              "길고 길었던 10개월의 여정, 이제 정말 아기들을 만날 순간이 가까워졌어요. 엄마는 지금 두 아기를 품은 무게감, 출산에 대한 긴장감, 그리고 복잡한 감정들로 인해 조금 예민하거나 울컥할 수 있어요.\n\n그럴 땐 말없이 옆에서 손잡아 주는 것만으로도 엄마에겐 큰 힘이 된답니다.",
          },
          {
            subTitle: "아빠의 체력과 마음도 중요해요!",
            discribed:
              "아빠도 지금까지 정말 잘 해오셨어요. 하지만 쌍둥이 출산은 체력전이기도 해요.\n\n출산 당일 아내를 곁에서 지키고, 출산 후 아기들 케어에 함께 뛰고, 가정과 병원을 오가며 잔뜩 몰려올 일정들을 소화하려면, 아빠의 체력과 멘탈이 매우 중요해요.",
          },
          {
            subTitle: "두 생명의 탄생, 함께 맞이해요!",
            discribed:
              "이제 곧 두 아기의 울음소리가 들릴 거예요. 떨리고 설레는 이 순간, 아내에게도, 아기들에게도 든든한 첫 번째 보호자이자 평생의 팀원이 되어줄 아빠의 존재가 절실해요.",
          },
          {
            subTitle: "예비 아빠에게 드리는 응원의 메시지",
            discribed:
              "지금까지도 충분히 잘해왔고, 이제부터는 더 멋지게 함께 해나갈 수 있어요! 아빠, 막판 스퍼트! 조금만 더, 함께 힘내요. 곧 우리 가족이 만나요.",
          },
        ],
      },
    },
    {
      week: 40,
      baby: {
        head: {
          title: "엄마, 아빠 보고싶었어요!",
          discribed: "각각 큰 호박만 한 크기",
          size: "약 52cm, 3.5kg",
        },
        body: [
          {
            subTitle: "모든 준비를 마치고 만날 날을 기다리고 있어요!",
            discribed:
              "이제 우리 아기들은 세상 밖으로 나올 모든 준비를 마치고 엄마, 아빠를 만날 그날만을 기다리고 있어요.\n\n쌍둥이 아기의 경우 단태아보다 조금 더 이른 시기에 태어나는 경우가 많지만, 40주까지 잘 지내고 있다면 정말 튼튼하게 자라준 거예요. 두 아기 모두 정말 기특하고 대단해요!",
          },
          {
            subTitle: "스스로 생활할 준비가 완료되었어요!",
            discribed:
              "태어나는 즉시 폐로 숨을 쉬고 본능적으로 엄마 젖을 찾으며 울음으로 \"우리 왔어요!\" 하고 말할 준비가 되었답니다.\n\n태변도 조만간 배설할 준비 완료! 탯줄은 생후 약 일주일 뒤 자연스럽게 떨어지게 돼요.",
          },
          {
            subTitle: "출산 예정일이 지나도 괜찮아요!",
            discribed:
              "전체 산모 중 단 5%만이 정확한 예정일에 출산한다고 해요. 그러니 예정일이 지나더라도 초조해하지 말고, 두 아기를 만날 시간을 넉넉한 마음으로 기다려 주세요.\n\n이제 정말 언제든지, 두 아이가 인사할지도 몰라요!",
          },
          {
            subTitle: "엄마와 아빠를 만나러 가는 길",
            discribed:
              "이제 정말 얼마 남지 않았어요. 배 속에서 사랑을 가득 받고 자라온 우리, 이제 그 사랑을 직접 느껴볼 준비가 되었답니다.",
          },
          {
            subTitle: "두 아기의 마지막 인사",
            discribed:
              "엄마, 아빠! 우리 이제 곧 만나요. 정말 정말 보고 싶었어요!",
          },
        ],
      },
      mom: {
        head: {
          title: "감격의 순간, 두 아기와의 첫 만남을 진심으로 축하드려요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "놀라운 여정이 마침내 끝을 향해 가고 있어요",
            discribed:
              "쌍둥이를 품고 여기까지 온 당신, 엄마라는 말로는 다 표현할 수 없는 놀라운 존재예요. 한 명의 아기도 벅찬데, 두 명을 함께 품고 버텨온 시간.\n\n진심으로 축하드리고, 무한한 존경을 보내요.",
          },
          {
            subTitle: "진통이 시작됐다면 침착하게 입원 준비!",
            discribed:
              "규칙적인 진통이 5~10분 간격으로 나타나면 병원으로 가요. 양수가 터지거나 출혈이 생긴다면, 즉시 병원에 연락해주세요.\n\n이미 제왕절개가 예정되어 있다면, 수술 날짜에 맞춰 준비된 병원으로 입원해요. 쌍태아는 제왕절개 분만 비율이 높기 때문에 예정된 날짜와 시간, 수술 전 금식 여부 등을 다시 한번 확인해두면 좋아요.",
          },
          {
            subTitle: "가진통과 진진통 구별하기",
            discribed:
              "초산인 경우 진통 시간이 길기 때문에 규칙적인 진통이 5~10분 간격으로 진행되면 입원하는 것이 좋아요.\n\n진통과 분만 양상은 사람마다 달라서, 진통 후 3시간 만에 출산하는 사람도 있는가 하면 1박 2일에 걸쳐 진통을 겪는 사람도 있어요.\n\n우선 진통이 시작된 것 같으면 진통 간격을 재어 병원에 연락하고, 파수되거나 많은 양의 출혈이 있을 때는 신속하게 병원으로 이동해야 해요.",
          },
          {
            subTitle: "분만 과정 안내",
            discribed:
              "쌍둥이 분만은 대부분 제왕절개로 진행되지만, 일부는 자연분만을 시도하기도 해요.\n\n**분만 과정**\n• **분만 1기**: 자궁경부가 열리는 시기\n• **분만 2기**: 아기들이 태어나는 순간\n• **분만 3기**: 태반이 배출되는 단계\n\n초산모의 경우 분만 제1기부터 분만까지 소요시간은 약 9~19시간, 경산모의 경우는 약 6~14시간이 소요되지만 산모에 따라 편차가 커요.\n\n쌍둥이인 만큼 분만 과정이 더 신중하고 정밀하게 진행돼요. 의료진을 믿고, 자신의 몸을 믿고, 끝까지 힘을 내주세요.",
          },
          {
            subTitle: "새로운 출발선에 선 엄마에게",
            discribed:
              "두 아기를 품고, 두 개의 심장을 느끼며 지내온 지난 10개월. 정말 고생 많으셨어요.\n\n지금까지는 '출산'이라는 목표를 향해 달려왔다면 이제부터는 '육아'라는 새로운 여정의 첫 페이지가 펼쳐집니다. 당신은 이미 충분히 훌륭한 엄마예요. 그리고 두 아이에게 가장 따뜻한 세상입니다.",
          },
          {
            subTitle: "진심 어린 축하의 말씀",
            discribed:
              "엄마와 아기들, 모두가 건강하길. 당신의 이 위대한 여정에 박수를 보냅니다. 진심으로 축하드려요!",
          },
        ],
      },
      dad: {
        head: {
          title: "출산, 그 감동의 순간! 아빠도 함께해요!",
          discribed: "마지막까지 든든한 동반자로 아내 곁을 지켜주세요.",
        },
        body: [
          {
            subTitle: "진통 주기를 체크해요!",
            discribed:
              "쌍태아 임신은 단태아보다 조산 가능성이 높기 때문에, 진통이 시작되었다면 그 시점부터 정확하게 기록하는 것이 중요해요.\n\n진통의 시작 시간과 간격을 메모하고 강도가 점점 세지고 있는지 확인해주세요. 5~10분 간격의 진통이 1시간 이상 지속되면 병원에 갈 준비를 해요.\n\n양수가 터졌다면 감염 방지를 위해 대형 패드나 기저귀를 대고 바로 병원으로 이동해주세요.",
          },
          {
            subTitle: "아내 곁에서 함께해 주세요!",
            discribed:
              "고통, 긴장, 낯선 환경… 아내가 진통과 출산의 고비를 넘기고 있을 때 무엇보다 필요한 건 곁에서 함께하는 아빠의 존재예요.\n\n연습했던 호흡법을 함께 해주고 가볍게 손을 잡아주거나 등을 쓰다듬으며 아내가 혼자가 아니라는 확신을 주세요.",
          },
          {
            subTitle: "아내의 상태를 가장 먼저 확인해주세요!",
            discribed:
              "아기가 무사히 태어났다는 감격의 순간! 하지만 동시에 아내는 40주간의 여정을 완주한 직후예요.\n\n산후 출혈 여부, 통증과 컨디션, 심리적 안정을 먼저 살펴주세요. 그리고 \"정말 수고했어, 고마워\"라는 진심 어린 한마디를 꼭 전해주세요. 이 말 한마디가 아내에게는 무엇보다 큰 힘이 될 거예요.",
          },
          {
            subTitle: "아빠도 정말 잘 해오셨어요!",
            discribed:
              "두 아이를 기다리며 함께 준비해온 모든 날들이 오늘이라는 감동의 순간으로 이어졌어요.",
          },
          {
            subTitle: "새로운 시작을 향한 응원",
            discribed:
              "쌍둥이 아빠로서의 첫 걸음, 지금 이 순간부터 시작입니다! 아내와 두 아기를 향한 따뜻한 응원, 아빠의 역할이 정말 소중해요.",
          },
        ],
      },
    },
  ],
};

export default twinsBabyData;
